/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".google-signInButton{-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:8px;padding-left:1px;height:43px;font-family:Roboto,sans-serif;font-size:14px;font-weight:500;color:rgba(0,0,0,.54);border:1px solid #efefef;border-bottom-width:2px;border-radius:4px;cursor:pointer}.google-signInButton,.google-signInButton__icon{display:inline-flex;align-items:center;background-color:#fff}.google-signInButton__icon{justify-content:center;width:38px;height:38px}.google-signInButton__icon img{width:18px;height:18px}.google-signInButton__text{display:inline-block;margin-left:8px}.google-signInButton:hover{background-color:#4285f4;color:#fff}.google-signInButton--disabled{opacity:.5;cursor:default}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--vp-border-radius-root:4px;--vp-border-radius-lg:8px;--vp-scrollbar-webkit-width:6px;--vp-scrollbar-webkit-border-radius:12px;--vp-scrollbar-width:thin;--vp-scrollbar:#ccc;--vp-scrollbar-background:#fff}.vp-btn-group{--vp-btn-group__display:flex;--vp-btn-group__gap:4px;--vp-btn-group__flex-wrap:nowrap;--vp-btn-group__justify-content:left;--vp-btn-group__align-items:flex-start;display:var(--vp-btn-group__display);gap:var(--vp-btn-group__gap);flex-wrap:var(--vp-btn-group__flex-wrap);justify-content:var(--vp-btn-group__justify-content);align-items:var(--vp-btn-group__align-items)}.vp-btn-group--center,.vp-btn-group--center-x{--vp-btn-group__justify-content:center}.vp-btn-group--right,.vp-btn-group--right-x{--vp-btn-group__justify-content:right}.vp-btn-group--center-y{--vp-btn-group__align-items:center}.vp-btn-group--end-y{--vp-btn-group__align-items:flex-end}.vp-btn{--vp-btn__color:rgba(0,0,0,.87);--vp-btn__has-bg--bck:#f5f5f5;--vp-btn__icon__color:inherit;--vp-btn__outlined--bck:#fff;--vp-btn__outlined--bor:currentColor;--vp-btn__color--primary:#fff;--vp-btn__bck--primary:var(--v-primary-base);--vp-btn__icon__color--primary:var(--vp-btn__icon__color);--vp-btn__color--secondary:#fff;--vp-btn__bck--secondary:var(--v-secondary-base);--vp-btn__icon__color--secondary:var(--vp-btn__icon__color);--vp-btn__color--accent:#fff;--vp-btn__bck--accent:var(--v-accent-base);--vp-btn__icon__color--accent:var(--vp-btn__icon__color);--vp-btn__color--error:#fff;--vp-btn__bck--error:var(--v-error-base);--vp-btn__icon__color--error:var(--vp-btn__icon__color);--vp-btn__color--info:#fff;--vp-btn__bck--info:var(--v-info-base);--vp-btn__icon__color--info:var(--vp-btn__icon__color);--vp-btn__color--success:#fff;--vp-btn__bck--success:var(--v-success-base);--vp-btn__icon__color--success:var(--vp-btn__icon__color);--vp-btn__color--warning:#fff;--vp-btn__bck--warning:var(--v-warning-base);--vp-btn__icon__color--warning:var(--vp-btn__icon__color);--vp-btn__text-transform:none;--vp-btn__border-radius:var(--vp-border-radius-root)}.vp-btn.v-btn{text-transform:var(--vp-btn__text-transform)}.vp-btn.v-btn:not(.vp-btn.v-btn--round){border-radius:var(--vp-btn__border-radius)}.vp-btn.v-btn>.v-btn__content .v-icon{color:var(--vp-btn__icon__color)}.vp-btn.v-btn--plain{--vp-btn__text-transform:uppercase;--vp-btn__text-padding:0;padding:var(--vp-btn__text-padding)!important}.v-application--is-ltr .vp-btn.v-btn--plain .v-btn__content .v-icon--left{margin-left:0}.vp-btn.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover) .v-btn__content{opacity:1}.vp-btn.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):hover .v-btn__content{opacity:.62}.vp-btn.theme--light:not(.primary).v-btn--has-bg{background-color:var(--vp-btn__has-bg--bck)}.vp-btn.theme--light.v-btn{color:var(--vp-btn__color)}.vp-btn.theme--light.v-btn.primary{background-color:var(--vp-btn__bck--primary)!important}.vp-btn.theme--light.v-btn.primary:not(.v-btn--outlined){color:var(--vp-btn__color--primary)}.vp-btn.theme--light.v-btn.primary>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--primary)}.vp-btn.theme--light.v-btn.secondary{background-color:var(--vp-btn__bck--secondary)!important}.vp-btn.theme--light.v-btn.secondary:not(.v-btn--outlined){color:var(--vp-btn__color--secondary)}.vp-btn.theme--light.v-btn.secondary>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--secondary)}.vp-btn.theme--light.v-btn.accent{background-color:var(--vp-btn__bck--accent)!important}.vp-btn.theme--light.v-btn.accent:not(.v-btn--outlined){color:var(--vp-btn__color--accent)}.vp-btn.theme--light.v-btn.accent>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--accent)}.vp-btn.theme--light.v-btn.error{background-color:var(--vp-btn__bck--error)!important}.vp-btn.theme--light.v-btn.error:not(.v-btn--outlined){color:var(--vp-btn__color--error)}.vp-btn.theme--light.v-btn.error>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--error)}.vp-btn.theme--light.v-btn.info{background-color:var(--vp-btn__bck--info)!important}.vp-btn.theme--light.v-btn.info:not(.v-btn--outlined){color:var(--vp-btn__color--info)}.vp-btn.theme--light.v-btn.info>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--info)}.vp-btn.theme--light.v-btn.success{background-color:var(--vp-btn__bck--success)!important}.vp-btn.theme--light.v-btn.success:not(.v-btn--outlined){color:var(--vp-btn__color--success)}.vp-btn.theme--light.v-btn.success>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--success)}.vp-btn.theme--light.v-btn.warning{background-color:var(--vp-btn__bck--warning)!important}.vp-btn.theme--light.v-btn.warning:not(.v-btn--outlined){color:var(--vp-btn__color--warning)}.vp-btn.theme--light.v-btn.warning>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--warning)}.vp-btn.theme--light.v-btn--outlined{background-color:var(--vp-btn__outlined--bck);border-color:var(--vp-btn__outlined--bor)}.vp-btn.theme--light.v-btn--outlined.primary--text{color:var(--vp-btn__bck--primary)!important}.vp-btn.theme--light.v-btn--outlined.primary--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--primary)}.vp-btn.theme--light.v-btn--outlined.secondary--text{color:var(--vp-btn__bck--secondary)!important}.vp-btn.theme--light.v-btn--outlined.secondary--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--secondary)}.vp-btn.theme--light.v-btn--outlined.accent--text{color:var(--vp-btn__bck--accent)!important}.vp-btn.theme--light.v-btn--outlined.accent--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--accent)}.vp-btn.theme--light.v-btn--outlined.error--text{color:var(--vp-btn__bck--error)!important}.vp-btn.theme--light.v-btn--outlined.error--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--error)}.vp-btn.theme--light.v-btn--outlined.info--text{color:var(--vp-btn__bck--info)!important}.vp-btn.theme--light.v-btn--outlined.info--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--info)}.vp-btn.theme--light.v-btn--outlined.success--text{color:var(--vp-btn__bck--success)!important}.vp-btn.theme--light.v-btn--outlined.success--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--success)}.vp-btn.theme--light.v-btn--outlined.warning--text{color:var(--vp-btn__bck--warning)!important}.vp-btn.theme--light.v-btn--outlined.warning--text>.v-btn__content .v-icon{color:var(--vp-btn__icon__color--warning)}.v-dialog>.vp-card,.vp-card{--vp-card__border-radius:var(--vp-border-radius-root);--vp-card__border-radius--title:calc(var(--vp-card__border-radius) - 3px);--vp-card__txt:rgba(0,0,0,.87);--vp-card__bck:#fff;--vp-card__title--color:rgba(0,0,0,.87);--vp-card__title--bck:#fafafa;--vp-card__title__padding--xs:12px 16px;--vp-card__title__padding--smUp:12px 24px;--vp-card__text--color:rgba(0,0,0,.6);--vp-card__bor--weight:2px;--vp-card__bor--style:solid;--vp-card__bor--color:var(--vp-card__title--bck);--vp-card__padding--xs:16px;--vp-card__padding--smUp:24px}.v-dialog>.vp-card--primary,.vp-card--primary{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-primary-base)}.v-dialog>.vp-card--secondary,.vp-card--secondary{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-secondary-base)}.v-dialog>.vp-card--accent,.vp-card--accent{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-accent-base)}.v-dialog>.vp-card--error,.vp-card--error{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-error-base)}.v-dialog>.vp-card--info,.vp-card--info{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-info-base)}.v-dialog>.vp-card--success,.vp-card--success{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-success-base)}.v-dialog>.vp-card--warning,.vp-card--warning{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-warning-base)}.v-dialog>.vp-card--plain,.vp-card--plain{--vp-card__title--bck:none}.v-dialog>.vp-card--plain.v-card .v-card__title,.vp-card--plain.v-card .v-card__title{--vp-card__title__padding--xs:16px 12px 12px 16px;--vp-card__title__padding--smUp:24px 24px 12px 24px}.v-dialog>.vp-card--plain.v-card .v-card__text,.vp-card--plain.v-card .v-card__text{--vp-card__padding--xs:0 16px 16px;--vp-card__padding--smUp:0 24px 24px}.v-dialog>.vp-card--plain.v-sheet--outlined.v-card .v-card__title,.vp-card--plain.v-sheet--outlined.v-card .v-card__title{--vp-card__title__padding--xs:0 0 12px 0;--vp-card__title__padding--smUp:0 0 12px 0}.v-dialog>.vp-card--plain.v-sheet--outlined.v-card .v-card__actions,.v-dialog>.vp-card--plain.v-sheet--outlined.v-card .v-card__text,.vp-card--plain.v-sheet--outlined.v-card .v-card__actions,.vp-card--plain.v-sheet--outlined.v-card .v-card__text{--vp-card__padding--xs:0;--vp-card__padding--smUp:0}.v-dialog>.vp-card--border,.vp-card--border{--vp-card__bor--color:#eee}.v-dialog>.vp-card--border>.v-card__title,.vp-card--border>.v-card__title{border-bottom:var(--vp-card__bor--weight) var(--vp-card__bor--style) var(--vp-card__bor--color)}.v-dialog>.vp-card.v-card.v-sheet--outlined>.v-card__progress+:not(.v-btn):not(.v-chip):not(.v-avatar),.v-dialog>.vp-card.v-card.v-sheet--outlined>:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),.vp-card.v-card.v-sheet--outlined>.v-card__progress+:not(.v-btn):not(.v-chip):not(.v-avatar),.vp-card.v-card.v-sheet--outlined>:first-child:not(.v-btn):not(.v-chip):not(.v-avatar){border-top-left-radius:var(--vp-card__border-radius--title);border-top-right-radius:var(--vp-card__border-radius--title)}.v-dialog>.vp-card.v-card.v-sheet,.vp-card.v-card.v-sheet{border-radius:var(--vp-card__border-radius)!important}.v-dialog>.vp-card.v-card .v-card__title,.vp-card.v-card .v-card__title{padding:var(--vp-card__title__padding--xs)}@media only screen and (min-width:600px){.v-dialog>.vp-card.v-card .v-card__title,.vp-card.v-card .v-card__title{padding:var(--vp-card__title__padding--smUp)}}.v-dialog>.vp-card.v-card .v-card__text,.vp-card.v-card .v-card__text{padding:var(--vp-card__padding--xs)}@media only screen and (min-width:600px){.v-dialog>.vp-card.v-card .v-card__text,.vp-card.v-card .v-card__text{padding:var(--vp-card__padding--smUp)}}.v-dialog>.vp-card.v-card .v-card__actions,.vp-card.v-card .v-card__actions{padding:var(--vp-card__padding--xs);padding-top:0}@media only screen and (min-width:600px){.v-dialog>.vp-card.v-card .v-card__actions,.vp-card.v-card .v-card__actions{padding:var(--vp-card__padding--smUp);padding-top:0}}.v-dialog>.vp-card.v-card .v-divider+.v-card__actions,.vp-card.v-card .v-divider+.v-card__actions{padding:calc(var(--vp-card__padding--xs)/2) var(--vp-card__padding--xs)}@media only screen and (min-width:600px){.v-dialog>.vp-card.v-card .v-divider+.v-card__actions,.vp-card.v-card .v-divider+.v-card__actions{padding:calc(var(--vp-card__padding--smUp)/2) var(--vp-card__padding--smUp)}}.v-dialog>.vp-card.theme--light.v-card,.vp-card.theme--light.v-card{color:var(--vp-card__txt);background:var(--vp-card__bck)}.v-dialog>.vp-card.theme--light.v-card>.v-card__title,.vp-card.theme--light.v-card>.v-card__title{color:var(--vp-card__title--color);background:var(--vp-card__title--bck)}.v-dialog>.vp-card.theme--light.v-card>.v-card__text,.vp-card.theme--light.v-card>.v-card__text{color:var(--vp-card__text--color)}.v-dialog>.vp-card.theme--light.v-sheet--outlined,.vp-card.theme--light.v-sheet--outlined{border:var(--vp-card__bor--weight) var(--vp-card__bor--style) var(--vp-card__bor--color)}.vp-dialog>.vp-card{--vp-card__title--color:#fff;--vp-card__title--bck:var(--v-primary-base)}.vp-dialog:not(.v-dialog--fullscreen)>.vp-card>.v-card__progress+:not(.v-btn):not(.v-chip):not(.v-avatar),.vp-dialog:not(.v-dialog--fullscreen)>.vp-card>:first-child:not(.v-btn):not(.v-chip):not(.v-avatar){border-top-left-radius:var(--vp-card__border-radius--title);border-top-right-radius:var(--vp-card__border-radius--title)}.vp-dialog.v-dialog--fullscreen .v-sheet.vp-card{border-radius:0!important}.vp-data-table,.vp-simple-table{--vp-data-table--hoverBck:#fafafa}.vp-data-table--scrollbar.v-data-table--fixed-height .v-data-table__wrapper{scrollbar-width:var(--vp-scrollbar-width);scrollbar-color:var(--vp-scrollbar) var(--vp-scrollbar-background)}.vp-data-table--scrollbar.v-data-table--fixed-height .v-data-table__wrapper::-webkit-scrollbar{width:var(--vp-scrollbar-webkit-width);background:var(--vp-scrollbar-background);border-radius:var(--vp-scrollbar-webkit-border-radius)}.vp-data-table--scrollbar.v-data-table--fixed-height .v-data-table__wrapper::-webkit-scrollbar-thumb{background:var(--vp-scrollbar);border-radius:var(--vp-scrollbar-webkit-border-radius)}@media only screen and (max-width:599.98px){.vp-data-table .v-data-footer{justify-content:center}.vp-data-table .v-data-footer__select{flex:1 1 100%;justify-content:center}}.v-application--is-ltr .vp-data-table .v-data-footer__pagination{margin-right:16px}.v-application--is-ltr .vp-data-table .v-data-footer__icons-after{margin-right:8px}.v-application--is-ltr .vp-data-table .v-data-footer__select{margin-left:8px;margin-right:auto}.vp-data-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),.vp-data-table.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),.vp-simple-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),.vp-simple-table.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){background:var(--vp-data-table--hoverBck)}.vp-data-table .v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:first-child,.vp-data-table.v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:first-child,.vp-simple-table .v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:first-child,.vp-simple-table.v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:first-child{border-top-left-radius:0}.vp-data-table .v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:last-child,.vp-data-table.v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:last-child,.vp-simple-table .v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:last-child,.vp-simple-table.v-data-table>.v-data-table__wrapper thead+tbody tr:first-child:hover td:last-child{border-top-right-radius:0}.vp-dialog{--vp-dialog__border-radius:var(--vp-border-radius-root)}.vp-dialog.v-dialog{border-radius:var(--vp-dialog__border-radius)}.vp-dialog.v-dialog.v-dialog--fullscreen{border-radius:0!important}.vp-expansion-panels{--vp-expansion-panels__border-radius:var(--vp-border-radius-root);--vp-expansion-panels__header__border-radius:calc(var(--vp-expansion-panels__border-radius) - 3px);--vp-expansion-panels__bck:#fff;--vp-expansion-panels__header--color:rgba(0,0,0,.87);--vp-expansion-panels__header--bck:#fff;--vp-expansion-panels__header__icon__color:currentColor;--vp-expansion-panels__header--active--color:rgba(0,0,0,.87);--vp-expansion-panels__header--active--bck:#fafafa;--vp-expansion-panels__header__icon__color--active:var(--vp-expansion-panels__header__icon__color);--vp-expansion-panels__header__height:initial;--vp-expansion-panels__header__height--active:var(--vp-expansion-panels__header__height);--vp-expansion-panels__header__padding--xs:12px 16px;--vp-expansion-panels__header__padding--smUp:12px 24px;--vp-expansion-panels__header__padding--xs--active:var(--vp-expansion-panels__header__padding--xs);--vp-expansion-panels__header__padding--smUp--active:var(--vp-expansion-panels__header__padding--smUp);--vp-expansion-panels__bor--weight:2px;--vp-expansion-panels__bor--style:solid;--vp-expansion-panels__bor--color:#eee;--vp-expansion-panels__padding--xs:16px;--vp-expansion-panels__padding--smUp:24px}.vp-expansion-panels--primary{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-primary-base)}.vp-expansion-panels--secondary{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-secondary-base)}.vp-expansion-panels--accent{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-accent-base)}.vp-expansion-panels--error{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-error-base)}.vp-expansion-panels--info{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-info-base)}.vp-expansion-panels--success{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-success-base)}.vp-expansion-panels--warning{--vp-expansion-panels__header--active--color:#fff;--vp-expansion-panels__header--active--bck:var(--v-warning-base)}.vp-expansion-panels.v-expansion-panels{border-radius:var(--vp-expansion-panels__border-radius)}.vp-expansion-panels.v-expansion-panels>:first-child{border-top-left-radius:var(--vp-expansion-panels__header__border-radius);border-top-right-radius:var(--vp-expansion-panels__header__border-radius)}.vp-expansion-panels.v-expansion-panels .v-expansion-panel-header{min-height:var(--vp-expansion-panels__header__height);padding:var(--vp-expansion-panels__header__padding--xs)}@media only screen and (min-width:600px){.vp-expansion-panels.v-expansion-panels .v-expansion-panel-header{padding:var(--vp-expansion-panels__header__padding--smUp)}}.vp-expansion-panels.v-expansion-panels .v-expansion-panel-header--active{min-height:var(--vp-expansion-panels__header__height--active);padding:var(--vp-expansion-panels__header__padding--xs--active)}@media only screen and (min-width:600px){.vp-expansion-panels.v-expansion-panels .v-expansion-panel-header--active{padding:var(--vp-expansion-panels__header__padding--smUp--active)}}.vp-expansion-panels.v-expansion-panels .v-expansion-panel-content__wrap{padding:var(--vp-expansion-panels__padding--xs)}@media only screen and (min-width:600px){.vp-expansion-panels.v-expansion-panels .v-expansion-panel-content__wrap{padding:var(--vp-expansion-panels__padding--smUp)}}.vp-expansion-panels.v-expansion-panels.theme--light .v-expansion-panel{background-color:var(--vp-expansion-panels__bck)}.vp-expansion-panels.v-expansion-panels.theme--light .v-expansion-panel-header{color:var(--vp-expansion-panels__header--color)}.vp-expansion-panels.v-expansion-panels.theme--light .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{color:var(--vp-expansion-panels__header__icon__color)}.vp-expansion-panels.v-expansion-panels.theme--light .v-expansion-panel-header--active{color:var(--vp-expansion-panels__header--active--color);background:var(--vp-expansion-panels__header--active--bck)}.vp-expansion-panels.v-expansion-panels.theme--light .v-expansion-panel-header--active .v-expansion-panel-header__icon .v-icon{color:var(--vp-expansion-panels__header__icon__color--active)}.vp-expansion-panels--border .v-expansion-panel:not(:first-child):after{border-top:var(--vp-expansion-panels__bor--weight) var(--vp-expansion-panels__bor--style) var(--vp-expansion-panels__bor--color)!important}.vp-expansion-panels--border .v-expansion-panel--active:before,.vp-expansion-panels--border .v-expansion-panel:before{box-shadow:0 0 0 var(--vp-expansion-panels__bor--weight) var(--vp-expansion-panels__bor--color)}.vp-expansion-panels--border.v-expansion-panels.theme--light .v-expansion-panel-header--active{border-bottom:var(--vp-expansion-panels__bor--weight) var(--vp-expansion-panels__bor--style) var(--vp-expansion-panels__bor--color)}.vp-field-group{--vp-field-group__display:grid;--vp-field-group__grid-template-columns:minmax(0,1fr);--vp-field-group__grid-template-columns--min:250px;--vp-field-group__grid-template-columns--smUp:repeat(auto-fit,minmax(var(--vp-field-group__grid-template-columns--min),1fr));--vp-field-group__gap:24px 32px;--vp-field-group__auto-flow:dense;--vp-field-group__full-width-col:1/-1;display:var(--vp-field-group__display);grid-template-columns:var(--vp-field-group__grid-template-columns);gap:var(--vp-field-group__gap);grid-auto-flow:var(--vp-field-group__auto-flow)}.vp-field-group--details{--vp-field-group__gap:0 32px}.vp-field-group .v-textarea,.vp-field-group .vp-simple-json-editor,.vp-field-group .vp-text-editor{grid-column:var(--vp-field-group__full-width-col)}@media only screen and (min-width:600px){.vp-field-group{--vp-field-group__grid-template-columns:var(--vp-field-group__grid-template-columns--smUp)}}.vp-field-group--flex{--vp-field-group__display:flex;--vp-field-group__flex-wrap:wrap;--vp-field-group__flex-align-content:flex-start;--vp-field-group__flex-width:100%;flex-wrap:var(--vp-field-group__flex-wrap);align-content:var(--vp-field-group__flex-align-content)}.vp-field-group--flex .v-textarea,.vp-field-group--flex .vp-simple-json-editor,.vp-field-group--flex .vp-text-editor{width:var(--vp-field-group__flex-width)}.vp-form-control{--vp-form-control__bck:#fff;--vp-form-control__bor--weight:2px;--vp-form-control__bor--style:solid;--vp-form-control__bor--color:#eee;--vp-form-control__bor--color--hov:#e0e0e0;--vp-form-control__border-radius:var(--vp-border-radius-root);--vp-form-control__field__min-height:58px;--vp-form-control__field__padding:0 12px;--vp-form-control__textarea--min-height:127px;--vp-form-control__select--label-icon:36px;--vp-form-control__radio-group--gap:8px 0;--vp-form-control__fieldset__legend--color:rgba(0,0,0,.87);--vp-form-control__fieldset__legend--weight:bold;--vp-form-control__fieldset__legend__padding:0 4px;--vp-form-control__fieldset__legend__padding--offset:-4px;--vp-form-control__fieldset__padding--xs:6px 16px 16px 16px;--vp-form-control__fieldset__padding--smUp:14px 24px 24px 24px}.vp-form-control.theme--light.v-text-field--filled{border-radius:unset}.vp-form-control.theme--light.v-text-field--filled>.v-input__control>.v-input__slot{background:var(--vp-form-control__bck);border:var(--vp-form-control__bor--weight) var(--vp-form-control__bor--style) var(--vp-form-control__bor--color);border-radius:var(--vp-form-control__border-radius)}.vp-form-control.theme--light.v-text-field--filled.v-input--has-state>.v-input__control>.v-input__slot{--vp-form-control__bor--color:currentColor}.vp-form-control.theme--light.v-text-field--filled.v-input--has-state>.v-input__control>.v-input__slot:before,.vp-form-control.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:before{display:none}.vp-form-control.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{background:var(--vp-form-control__bck);border-color:var(--vp-form-control__bor--color--hov)}.vp-form-control.theme--light.v-input--is-focused>.v-input__control>.v-input__slot{border-color:currentColor}.vp-form-control.theme--light.v-input--is-focused>.v-input__control>.v-input__slot:before{border:unset}.vp-form-control.theme--light.v-input--is-focused>.v-input__control>.v-input__slot:after{transform:scaleX(0)}.vp-form-control.theme--light .v-radio .v-icon,.vp-form-control.theme--light.v-input--checkbox .v-icon{color:var(--vp-form-control__bor--color)}.vp-form-control.v-text-field--filled>.v-input__control>.v-input__slot,.vp-form-control.v-text-field--full-width>.v-input__control>.v-input__slot,.vp-form-control.v-text-field--outlined>.v-input__control>.v-input__slot{min-height:var(--vp-form-control__field__min-height)}.vp-form-control--inline.v-input--selection-controls{margin-top:unset;padding-top:unset}.vp-form-control--inline.v-input--selection-controls .v-input__control .v-input__slot{min-height:var(--vp-form-control__field__min-height)}.vp-form-control--inline.v-input--selection-controls .v-input__control .v-messages{margin-bottom:8px}.vp-form-control.v-text-field.v-text-field--enclosed .v-text-field__details,.vp-form-control.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot{padding:var(--vp-form-control__field__padding)}.vp-form-control.v-textarea textarea{min-height:var(--vp-form-control__textarea--min-height)}.vp-form-control.v-select.v-text-field--filled .v-label--active{width:calc(133% - var(--vp-form-control__select--label-icon))}.vp-form-control.vp-text-editor .ck.ck-editor .ck.ck-toolbar{border:var(--vp-form-control__bor--weight) var(--vp-form-control__bor--style) var(--vp-form-control__bor--color);border-bottom-width:0}.vp-form-control.vp-text-editor .ck.ck-editor .ck.ck-content.ck-editor__editable{transition:.3s cubic-bezier(.25,.8,.5,1)}.vp-form-control.vp-text-editor .ck.ck-editor .ck.ck-content.ck-editor__editable:not(.ck-focused){border:var(--vp-form-control__bor--weight) var(--vp-form-control__bor--style) var(--vp-form-control__bor--color)}.vp-form-control.vp-text-editor .ck.ck-editor .ck.ck-content.ck-editor__editable:not(.ck-focused):hover{border-color:var(--vp-form-control__bor--color--hov)}.vp-form-control.vp-text-editor .ck.ck-editor .ck.ck-content.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{border:var(--vp-form-control__bor--weight) var(--vp-form-control__bor--style) var(--v-primary-base);box-shadow:unset}.vp-form-control.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot>input{margin-top:20px}.vp-form-control.v-input--radio-group--row .v-input--radio-group__input{gap:var(--vp-form-control__radio-group--gap)}.vp-form-control.v-input--radio-group--row .v-input--radio-group__input>legend{flex-grow:1}.vp-form-control.v-input--radio-group--row .v-input--radio-group__input>.vp-radios{display:flex;flex-wrap:wrap}.vp-form-control.v-input--radio-group--row .v-input--radio-group__input>.vp-radios .v-radio:last-child{margin-right:unset}fieldset.vp-form-control{padding:var(--vp-form-control__fieldset__padding--xs);border:var(--vp-form-control__bor--weight) var(--vp-form-control__bor--style) var(--vp-form-control__bor--color);border-radius:var(--vp-form-control__border-radius)}@media only screen and (min-width:600px){fieldset.vp-form-control{padding:var(--vp-form-control__fieldset__padding--smUp)}}fieldset.vp-form-control--thin{--vp-form-control__fieldset__padding--xs:4px 12px 12px 12px;--vp-form-control__fieldset__padding--smUp:var(--vp-form-control__fieldset__padding--xs);--vp-field-group__gap:0 12px}fieldset.vp-form-control>legend{margin-left:var(--vp-form-control__fieldset__legend__padding--offset);padding:var(--vp-form-control__fieldset__legend__padding);color:var(--vp-form-control__fieldset__legend--color);font-weight:var(--vp-form-control__fieldset__legend--weight)}.vp-menu{scrollbar-width:var(--vp-scrollbar-width);scrollbar-color:var(--vp-scrollbar) var(--vp-scrollbar-background)}.vp-menu::-webkit-scrollbar{width:var(--vp-scrollbar-webkit-width);background:var(--vp-scrollbar-background);border-radius:var(--vp-scrollbar-webkit-border-radius)}.vp-menu::-webkit-scrollbar-thumb{background:var(--vp-scrollbar);border-radius:var(--vp-scrollbar-webkit-border-radius)}.vp-tabs-bar{--vp-tabs-bar__bck:transparent;--vp-tabs-bar__items__bck:transparent;--vp-tabs-bar__height:40px;--vp-tabs-bar__gap:8px;--vp-tabs-bar__btn__color:rgba(0,0,0,.87);--vp-tabs-bar__btn__bck:#eee;--vp-tabs-bar__btn__color--active:#fff;--vp-tabs-bar__btn__bck--active:var(--v-primary-base);--vp-tabs-bar__text-transform:none}.vp-tabs-bar .v-tabs-bar{height:var(--vp-tabs-bar__height)}.vp-tabs-bar .v-tabs-bar .v-tabs-bar__content{gap:var(--vp-tabs-bar__gap)}.vp-tabs-bar .v-tabs-bar .v-tabs-bar__content .v-tab{text-transform:var(--vp-tabs-bar__text-transform);border-radius:var(--vp-border-radius-lg)}.vp-tabs-bar .v-tabs-bar .v-tabs-bar__content .v-tab:before{border-radius:var(--vp-border-radius-lg)}.vp-tabs-bar .theme--light.v-tabs-bar .v-tabs-bar__content .v-tab{color:var(--vp-tabs-bar__btn__color);background:var(--vp-tabs-bar__btn__bck)}.vp-tabs-bar .theme--light.v-tabs-bar .v-tabs-bar__content .v-tab.v-tab--active{color:var(--vp-tabs-bar__btn__color--active);background:var(--vp-tabs-bar__btn__bck--active)}.vp-tabs-bar .theme--light.v-tabs-items{background:var(--vp-tabs-bar__items__bck)}.vp-tabs-bar.theme--light.v-tabs>.v-tabs-bar{background-color:var(--vp-tabs-bar__bck)}.vp-tabs-bar.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled,.vp-tabs-bar.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),.vp-tabs-bar.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-btn,.vp-tabs-bar.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon{color:var(--vp-tabs-bar__btn__color)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-columns-selector__menu{--vp-columns-selector__height:400px;--vp-columns-selector__min-width:190px}.vp-columns-selector__menu .v-sheet{display:flex;flex-direction:column;height:var(--vp-columns-selector__height);max-height:90vh;min-width:var(--vp-columns-selector__min-width)}.vp-columns-selector__menu__actions,.vp-columns-selector__menu__toggle{flex-grow:0}.vp-columns-selector__menu__columns{flex-grow:1;overflow-y:auto}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application .data-table-setting{gap:16px}@media only screen and (max-width:959.98px){.v-application .data-table-setting__title{flex:0 0 100px}}@media only screen and (max-width:599.98px){.v-application .data-table-setting__title{flex:0 0 70px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application .vp-data-table{--vp-data-table__table__settings--bck:#fafafa}.v-application .vp-data-table__heading{margin:0!important}.v-application .vp-data-table__search{flex-grow:0}@media only screen and (min-width:960px){.v-application .vp-data-table__search{width:300px}}.v-application .vp-data-table__table--saveEnabled.v-card>.v-card__progress+:not(.v-btn):not(.v-chip):not(.v-avatar),.v-application .vp-data-table__table--saveEnabled.v-card>:first-child:not(.v-btn):not(.v-chip):not(.v-avatar){border-top-left-radius:0}.v-application .vp-data-table__table__settings{padding:8px;background-color:var(--vp-data-table__table__settings--bck);gap:16px}.v-application .vp-data-table__table__settings__settings{display:flex;align-items:center;gap:16px;flex-grow:1}.v-application .vp-data-table__table__settings__settings .data-table-setting{flex-grow:1}.v-application .vp-data-table__table__settings__sort-by{display:flex;flex-grow:1;align-items:center;gap:16px}@media only screen and (max-width:959.98px){.v-application .vp-data-table__table__settings__sort-by__label{flex:0 0 100px}}@media only screen and (max-width:599.98px){.v-application .vp-data-table__table__settings__sort-by__label{flex:0 0 70px}}.v-application .vp-data-table__table__settings__options{gap:16px}.v-application .vp-data-table__table__back{border-bottom:thin solid rgba(0,0,0,.12)}.v-application .vp-data-table__table__back .v-btn{text-transform:capitalize}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-dateRangeComparisonPicker{--vp-dateRangeComparisonPicker--message-icon:46px;flex-grow:1}.vp-dateRangeComparisonPicker .v-text-field--filled .v-input__slot{margin-bottom:0}.vp-dateRangeComparisonPicker .v-text-field--filled .v-text-field__details{--vp-form-control__field__padding:0 0 0 12px;pointer-events:none;position:absolute;top:15px;left:2px;max-width:calc(100% - var(--vp-dateRangeComparisonPicker--message-icon))}.vp-dateRangeComparisonPicker .v-text-field--filled .v-text-field__details .v-messages{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.vp-dateRangeComparisonPicker--compare.v-text-field--filled label{opacity:0}.vp-dateRangeComparisonPicker--compare.v-text-field--solo .v-text-field__details{display:none}.vp-dateRangeComparisonPicker__value{display:inline-flex;flex-direction:column}.vp-dateRangeComparisonPicker__value__comparison{font-size:10px;color:rgba(0,0,0,.5)}.vp-dateRangeComparisonPicker__ranges{container:vp-dateRangeComparisonPicker/inline-size}.vp-dateRangeComparisonPicker__ranges__inner{display:flex;align-items:center;justify-content:center;gap:24px 12px}@container vp-dateRangeComparisonPicker (max-width: 627.98px){.vp-dateRangeComparisonPicker__ranges__inner{flex-direction:column}}.vp-dateRangeComparisonPicker__range{display:flex;flex-direction:column;align-items:center}.vp-dateRangeComparisonPicker__range__title{margin-bottom:12px;font-weight:700}.vp-dateRangeComparisonPicker__range__date{margin-top:12px;font-weight:700}@container vp-dateRangeComparisonPicker (max-width: 627.98px){.vp-dateRangeComparisonPicker__divider--ver.v-icon.v-icon{display:inline-flex}}@container vp-dateRangeComparisonPicker (min-width: 628px){.vp-dateRangeComparisonPicker__divider--ver.v-icon.v-icon{display:none}}@container vp-dateRangeComparisonPicker (max-width: 627.98px){.vp-dateRangeComparisonPicker__divider--hoz.v-icon.v-icon{display:none}}@container vp-dateRangeComparisonPicker (min-width: 628px){.vp-dateRangeComparisonPicker__divider--hoz.v-icon.v-icon{display:inline-flex}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-dialog__header{font-weight:700}.vp-dialog__body,.vp-dialog__header{padding:24px!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filters__active,.filters__add{display:inline-block}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-form__fieldSet{margin:20px 0;padding:20px 12px 12px}.vp-form__fieldSet__field .v-input--checkbox{margin-top:4px}.vp-form__fieldSet__field .vp-text-editor{margin-bottom:32px}.vp-form--stepper .v-stepper__wrapper{overflow:visible}.vp-form--stepper .vp-form__fieldSet{margin:0;padding:0;border:none}.vp-form .vp-formField__description,.vp-form .vp-formField__label{display:block;margin-bottom:12px}.vp-form .vp-formField--row .v-input--checkbox{display:inline-flex;margin-right:12px}.vp-form .vp-formField--row .v-input--checkbox .v-input__control{width:auto;flex-grow:0}.vp-form .vp-formField__dateSplit{display:flex;flex-wrap:wrap;gap:0 12px}.vp-form .v-input--selection-controls{margin:0 0 8px;padding:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-simple-table .v-data-table__wrapper{scrollbar-width:var(--vp-scrollbar-width);scrollbar-color:var(--vp-scrollbar) var(--vp-scrollbar-background)}.vp-simple-table .v-data-table__wrapper::-webkit-scrollbar{width:var(--vp-scrollbar-webkit-width);background:var(--vp-scrollbar-background);border-radius:var(--vp-scrollbar-webkit-border-radius)}.vp-simple-table .v-data-table__wrapper::-webkit-scrollbar-thumb{background:var(--vp-scrollbar);border-radius:var(--vp-scrollbar-webkit-border-radius)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:599.98px){.vp-priority-table .v-data-footer{justify-content:center}.vp-priority-table .v-data-footer .v-data-footer__select{margin-left:0}.vp-priority-table .v-data-footer .v-btn{flex-basis:100%;margin-top:12px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-saved-searches__tabs .v-tabs-bar .v-slide-group__next,.vp-saved-searches__tabs .v-tabs-bar .v-slide-group__prev{border-top-left-radius:4px;border-top-right-radius:4px;background-color:#fff}.vp-saved-searches__tabs .v-tabs-bar .v-slide-group__next:hover i,.vp-saved-searches__tabs .v-tabs-bar .v-slide-group__prev:hover i{color:var(--v-primary-base)}.vp-saved-searches__row{gap:4px}.vp-saved-searches__tabs .v-tabs-bar{height:auto}.vp-saved-searches__tabs .v-tabs-bar__content{gap:4px}.vp-saved-searches__tabs .v-tabs-bar .v-slide-group__next{margin-left:4px}.vp-saved-searches__tabs .v-tabs-bar .v-slide-group__prev{margin-right:4px}.vp-saved-searches__viewAllDialog .v-data-table tr{cursor:pointer}.vp-saved-searches__pinned__close{pointer-events:auto}.vp-saved-searches__list-items__item.v-item--active:before{display:none}.vp-saved-searches__list-items__item .v-list-item__title{font-size:.85rem;font-weight:700}.vp-saved-searches__list-items__item .v-list-item__subtitle{font-size:.75rem}.vp-saved-searches__list-items__item .v-list-item__icon{margin:8px 0}.vp-saved-searches__list-items__item--active{background-color:#eee}.vp-saved-searches__active-title{background-color:var(--v-primary-base)}.vp-btn.vp-saved-searches__list:not(.vp-btn.v-btn--round),.vp-btn.vp-saved-searches__pinned:not(.vp-btn.v-btn--round){border-bottom-left-radius:0;border-bottom-right-radius:0}.vp-btn.vp-saved-searches__pinned.primary{pointer-events:none}.vp-btn.vp-saved-searches__viewAll{--vp-btn__text-transform:none}.vp-btn.theme--light.vp-saved-searches__pinned{--vp-btn__color--secondary:var(--vp-btn__color);--vp-btn__bck--secondary:#fff}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-simple-json-editor__cardText--editable-keys{--vp-field-group__grid-template-columns--smUp:minmax(0,1fr)}.vp-simple-json-editor__cardText__fieldGroup--editable-keys{--vp-field-group__grid-template-columns--smUp:repeat(2,minmax(0,1fr)) auto}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-text-editor{--vp-ck-editor-min-height:var(--vp-form-control__textarea--min-height);width:100%}.vp-text-editor .ck.ck-editor .ck.ck-toolbar.ck-toolbar_grouping{border-top-left-radius:var(--vp-border-radius-root);border-top-right-radius:var(--vp-border-radius-root)}.vp-text-editor .ck.ck-editor .ck.ck-content.ck-editor__editable{min-height:var(--vp-ck-editor-min-height);border-bottom-left-radius:var(--vp-border-radius-root);border-bottom-right-radius:var(--vp-border-radius-root)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".translatable-field__tabs.vp-tabs-bar{--vp-tabs-bar__text-transform:uppercase}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trend{margin:0 4px}.trend svg{width:24px;height:24px;margin-top:4px;fill:currentColor}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trending-value--trending-up,.trending-value--trending-up .v-icon{color:#4caf50}.trending-value--trending-down,.trending-value--trending-down .v-icon{color:#f44336}.trending-value--trending-neutral,.trending-value--trending-neutral .v-icon{color:#ff9800}.trending-value__trend{margin:0 4px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-widget-icon .v-icon{padding:20px}.vp-widget-icon .v-icon--outline{border:8px solid #eee}.vp-widget-icon .v-icon--background{background-color:#eee}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-widget{--vp-widget__subtitle--size:1rem;--vp-widget__subtitle--line-height:2rem;--vp-widget__subtitle--weight:normal;--vp-widget__title--size:2rem;--vp-widget__title--line-height:3rem;--vp-widget__title--weight:bold}.vp-widget__subtitle{font-size:var(--vp-widget__subtitle--size);font-weight:var(--vp-widget__subtitle--weight);line-height:var(--vp-widget__subtitle--line-height)}.vp-widget__title{font-size:var(--vp-widget__title--size);font-weight:var(--vp-widget__title--weight);line-height:var(--vp-widget__title--line-height)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widgets{--vp-widgets-swiper-container-bck:#fff;position:relative}.widgets .swiper-wrapper{background-color:var(--vp-widgets-swiper-container-bck);border-radius:4px}.widgets .swiper-wrapper .swiper-slide{width:340px}.widgets .swiper-wrapper .swiper-slide:not(:last-child) .widget:after{content:\"\";position:absolute;top:15%;right:-1px;width:2px;height:70%;background-color:rgba(0,0,0,.12);z-index:1}.widgets__button-next,.widgets__button-previous{position:absolute;top:50%;margin-top:-16px;z-index:1}.widgets__button-next .v-btn,.widgets__button-previous .v-btn{width:32px;height:32px}.widgets__button-previous{left:-16px}.widgets__button-next{right:-16px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 314:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 601:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(325);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("7174648e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(453);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("6cd09272", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 99:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("50e38e2a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(353);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("0f9d1d6a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(69);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("1f4d3b8e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 15:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(921);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("442c31d6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(819);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("98aed39e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 93:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(303);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("130920c2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(877);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("2f403f75", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(821);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("35f74e81", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(709);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("7d93e494", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(963);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("aaf4b66c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 27:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("3c6df6dd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(673);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("7d157fbc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(154);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("325fc912", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(773);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("1ed5a7bb", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(463);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("7b63d0a4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 71:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(302);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("35e10530", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 979:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(717);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("21ef3289", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(785);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("5975ee75", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(548)/* ["default"] */ .A)
var update = add("7d39ac14", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ addStylesClient; }
});

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external "vue-property-decorator"
var external_vue_property_decorator_namespaceObject = require("vue-property-decorator");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-base-styling/_logic.ts?vue&type=script&lang=ts&external

class BaseStylingComponent extends external_vue_property_decorator_namespaceObject.Vue {}
;// CONCATENATED MODULE: ./src/components/vp-base-styling/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var _logicvue_type_script_lang_ts_external = (BaseStylingComponent); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-base-styling/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var _stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(519);
;// CONCATENATED MODULE: ./src/components/vp-base-styling/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/vp-base-styling/vp-base-styling.vue
var render, staticRenderFns
;

;


/* normalize component */

var component = normalizeComponent(
  _logicvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_base_styling = (component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VRadioGroup"
var VRadioGroup_namespaceObject = require("vuetify/lib/components/VRadioGroup");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-boolean-radio-group/vp-boolean-radio-group.html?vue&type=template&id=44e9bf4e&external



var vp_boolean_radio_groupvue_type_template_id_44e9bf4e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRadioGroup_namespaceObject.VRadioGroup, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "column": _vm.column,
      "row": _vm.row,
      "hide-details": _vm.hideDetails,
      "error": _vm.error,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.workingValue,
      callback: function ($$v) {
        _vm.workingValue = $$v;
      },
      expression: "workingValue"
    }
  }, [_vm.either ? _c(VRadioGroup_namespaceObject.VRadio, {
    attrs: {
      "label": _vm.eitherText,
      "value": null,
      "readonly": _vm.readonly
    }
  }) : _vm._e(), _c(VRadioGroup_namespaceObject.VRadio, {
    attrs: {
      "label": _vm.yesText,
      "value": true,
      "readonly": _vm.readonly
    }
  }), _c(VRadioGroup_namespaceObject.VRadio, {
    attrs: {
      "label": _vm.noText,
      "value": false,
      "readonly": _vm.readonly
    }
  })], 1);
};
var vp_boolean_radio_groupvue_type_template_id_44e9bf4e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-boolean-radio-group/vp-boolean-radio-group.html?vue&type=template&id=44e9bf4e&external

;// CONCATENATED MODULE: external "tslib"
var external_tslib_namespaceObject = require("tslib");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-boolean-radio-group/vp-boolean-radio-group.ts?vue&type=script&lang=ts&external


let BooleanRadioGroupComponent = class BooleanRadioGroupComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.workingValue = false;
  }
  created() {
    this.workingValue = this.value;
  }
  onValueChange() {
    this.workingValue = this.value;
  }
  /**
   * Handles radio selection change events.
   */
  onChange() {
    this.$emit('input', this.workingValue);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], BooleanRadioGroupComponent.prototype, "name", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], BooleanRadioGroupComponent.prototype, "label", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: null,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "either", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'Either',
  type: String
})], BooleanRadioGroupComponent.prototype, "eitherText", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'Yes',
  type: String
})], BooleanRadioGroupComponent.prototype, "yesText", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'No',
  type: String
})], BooleanRadioGroupComponent.prototype, "noText", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: true,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "column", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "row", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "hideDetails", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], BooleanRadioGroupComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], BooleanRadioGroupComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], BooleanRadioGroupComponent.prototype, "errorMessages", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], BooleanRadioGroupComponent.prototype, "onValueChange", null);
BooleanRadioGroupComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], BooleanRadioGroupComponent);
/* harmony default export */ var vp_boolean_radio_groupvue_type_script_lang_ts_external = (BooleanRadioGroupComponent);
;// CONCATENATED MODULE: ./src/components/vp-boolean-radio-group/vp-boolean-radio-group.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_boolean_radio_group_vp_boolean_radio_groupvue_type_script_lang_ts_external = (vp_boolean_radio_groupvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-boolean-radio-group/vp-boolean-radio-group.vue





/* normalize component */
;
var vp_boolean_radio_group_component = normalizeComponent(
  vp_boolean_radio_group_vp_boolean_radio_groupvue_type_script_lang_ts_external,
  vp_boolean_radio_groupvue_type_template_id_44e9bf4e_external_render,
  vp_boolean_radio_groupvue_type_template_id_44e9bf4e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_boolean_radio_group = (vp_boolean_radio_group_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VAlert"
var VAlert_namespaceObject = require("vuetify/lib/components/VAlert");
;// CONCATENATED MODULE: external "vuetify/lib/components/VBtn"
var VBtn_namespaceObject = require("vuetify/lib/components/VBtn");
;// CONCATENATED MODULE: external "vuetify/lib/components/VCard"
var VCard_namespaceObject = require("vuetify/lib/components/VCard");
;// CONCATENATED MODULE: external "vuetify/lib/components/VDialog"
var VDialog_namespaceObject = require("vuetify/lib/components/VDialog");
;// CONCATENATED MODULE: external "vuetify/lib/components/VGrid"
var VGrid_namespaceObject = require("vuetify/lib/components/VGrid");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-confirm-dialog/vp-confirm-dialog.html?vue&type=template&id=6d4b1ddb&external









var vp_confirm_dialogvue_type_template_id_6d4b1ddb_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "contentClass": "confirm-dialog vp-dialog",
      "persistent": "",
      "scrollable": "",
      "max-width": "552",
      "light": _vm.light,
      "dark": _vm.dark
    },
    model: {
      value: _vm.isVisible,
      callback: function ($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, {
    staticClass: "confirm-dialog__title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c(VAlert_namespaceObject.VAlert, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.warning,
      expression: "warning"
    }],
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.message.warning')) + " ")]), _c(VCard_namespaceObject.VCardText, {
    staticClass: "confirm-dialog__message"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _c(VAlert_namespaceObject.VAlert, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.warning,
      expression: "warning"
    }],
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.message.warning')) + " ")]), _c(VCard_namespaceObject.VCardActions, {
    staticClass: "confirm-dialog__actions"
  }, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "text": _vm.text
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('general.action.cancel')))]), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "text": _vm.text,
      "depressed": ""
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('general.action.yes')))])], 1)], 1)], 1);
};
var vp_confirm_dialogvue_type_template_id_6d4b1ddb_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-confirm-dialog/vp-confirm-dialog.html?vue&type=template&id=6d4b1ddb&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-confirm-dialog/vp-confirm-dialog.ts?vue&type=script&lang=ts&external


let ConfirmDialogComponent = class ConfirmDialogComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.isVisible = false;
    this.title = '';
    this.message = '';
    this.warning = false;
  }
  open(title, message, warning = false) {
    this.title = title;
    this.message = message;
    this.warning = warning;
    this.isVisible = true;
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
  onConfirm() {
    this.resolve(true);
    this.isVisible = false;
  }
  onCancel() {
    this.resolve(false);
    this.isVisible = false;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ConfirmDialogComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ConfirmDialogComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ConfirmDialogComponent.prototype, "text", void 0);
ConfirmDialogComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ConfirmDialogComponent);
/* harmony default export */ var vp_confirm_dialogvue_type_script_lang_ts_external = (ConfirmDialogComponent);
;// CONCATENATED MODULE: ./src/components/vp-confirm-dialog/vp-confirm-dialog.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_confirm_dialog_vp_confirm_dialogvue_type_script_lang_ts_external = (vp_confirm_dialogvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-confirm-dialog/vp-confirm-dialog.vue





/* normalize component */
;
var vp_confirm_dialog_component = normalizeComponent(
  vp_confirm_dialog_vp_confirm_dialogvue_type_script_lang_ts_external,
  vp_confirm_dialogvue_type_template_id_6d4b1ddb_external_render,
  vp_confirm_dialogvue_type_template_id_6d4b1ddb_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_confirm_dialog = (vp_confirm_dialog_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VDataTable"
var VDataTable_namespaceObject = require("vuetify/lib/components/VDataTable");
;// CONCATENATED MODULE: external "vuetify/lib/components/VIcon"
var VIcon_namespaceObject = require("vuetify/lib/components/VIcon");
;// CONCATENATED MODULE: external "vuetify/lib/components/VList"
var VList_namespaceObject = require("vuetify/lib/components/VList");
;// CONCATENATED MODULE: external "vuetify/lib/components/VMenu"
var VMenu_namespaceObject = require("vuetify/lib/components/VMenu");
;// CONCATENATED MODULE: external "vuetify/lib/components/VSelect"
var VSelect_namespaceObject = require("vuetify/lib/components/VSelect");
;// CONCATENATED MODULE: external "vuetify/lib/components/VTextField"
var VTextField_namespaceObject = require("vuetify/lib/components/VTextField");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-data-table/vp-data-table.html?vue&type=template&id=7d89ef5e&external















var vp_data_tablevue_type_template_id_7d89ef5e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.initialising ? _c('div', {
    staticClass: "vp-data-table data-table"
  }, [_vm.title || !_vm.disableSearch ? _c('div', {
    staticClass: "align-center",
    class: [_vm.headerClassName ? _vm.headerClassName : 'd-md-flex']
  }, [_vm.title ? [_vm.h1 ? _c('h1', {
    staticClass: "vp-data-table__heading data-table__heading text-h4 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _c('h2', {
    staticClass: "vp-data-table__heading data-table__heading text-h5 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])] : _vm._e(), _vm.helpMessage ? [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "align-self-end mb-2 ml-2",
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showHelp = true;
      }
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-information-outline")])], 1), _c('vp-notification-dialog', {
    attrs: {
      "title": _vm.helpTitle,
      "message": _vm.helpMessage,
      "text": ""
    },
    model: {
      value: _vm.showHelp,
      callback: function ($$v) {
        _vm.showHelp = $$v;
      },
      expression: "showHelp"
    }
  })] : _vm._e(), _c(VGrid_namespaceObject.VSpacer), !_vm.disableSearch ? _c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-data-table__search data-table__search vp-form-control",
    class: {
      'mt-3': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "label": _vm.$t('general.action.search'),
      "placeholder": _vm.$t('general.action.search'),
      "filled": "",
      "hide-details": "auto",
      "clearable": "",
      "append-icon": "mdi-magnify"
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm.description ? _c('p', [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e(), _vm.report.widgets.length > 0 ? _c('vp-widgets', {
    staticClass: "vp-data-table__widgets data-table__widgets my-5",
    attrs: {
      "widgets": _vm.report.widgets
    }
  }) : _vm._e(), _vm.report.filters.length > 0 ? _c('vp-filters', {
    staticClass: "vp-data-table__filters data-table__filters my-5",
    attrs: {
      "filters": _vm.report.filters
    },
    model: {
      value: _vm.activeFilters,
      callback: function ($$v) {
        _vm.activeFilters = $$v;
      },
      expression: "activeFilters"
    }
  }) : _vm._e(), _vm.enableSave ? _c('vp-saved-searches', {
    on: {
      "click:current": _vm.onCurrentSearchClicked,
      "click:report": _vm.onSavedSearchClicked,
      "click:pin": _vm.onSavedSearchPinClicked,
      "click:delete": _vm.onSavedSearchDeleteClicked
    },
    model: {
      value: _vm.savedSearches,
      callback: function ($$v) {
        _vm.savedSearches = $$v;
      },
      expression: "savedSearches"
    }
  }) : _vm._e(), _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-data-table__table data-table__table my-5",
    class: {
      'mt-0 vp-data-table__table--saveEnabled': _vm.enableSave
    }
  }, [_vm.showSettings ? _c('div', {
    staticClass: "vp-data-table__table__settings data-table__table__settings d-flex flex-wrap-reverse align-end align-sm-start justify-end flex-sm-nowrap py-4 px-4"
  }, [_c('div', {
    staticClass: "vp-data-table__table__settings__options data-table__table__settings__options d-flex flex-wrap"
  }, [_vm.report.settings.length > 0 ? _c('vp-data-table-settings', {
    staticClass: "vp-data-table__table__settings__settings data-table__table__settings__settings flex-wrap",
    attrs: {
      "settings": _vm.report.settings
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [!_vm.disableSortBySelector && _vm.report.sortBys.length > 0 ? _c('div', {
          staticClass: "vp-data-table__table__settings__sort-by data-table__table__settings__sort-by d-flex"
        }, [_c(VSelect_namespaceObject.VSelect, {
          staticClass: "vp-form-control",
          attrs: {
            "items": _vm.report.sortBys,
            "item-text": "title",
            "item-value": "key",
            "label": _vm.$t('search.message.sort_by'),
            "placeholder": _vm.$t('search.message.sort_by'),
            "persistent-placeholder": "",
            "filled": "",
            "hide-details": "auto",
            "menu-props": {
              contentClass: 'vp-menu'
            }
          },
          on: {
            "change": _vm.updateVuetifyDatatableSort
          },
          model: {
            value: _vm.sortBy,
            callback: function ($$v) {
              _vm.sortBy = $$v;
            },
            expression: "sortBy"
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 2530508443),
    model: {
      value: _vm.activeSettings,
      callback: function ($$v) {
        _vm.activeSettings = $$v;
      },
      expression: "activeSettings"
    }
  }) : [!_vm.disableSortBySelector && _vm.report.sortBys.length > 0 ? _c('div', {
    staticClass: "vp-data-table__table__settings__sort-by data-table__table__settings__sort-by d-flex"
  }, [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-form-control",
    attrs: {
      "items": _vm.report.sortBys,
      "item-text": "title",
      "item-value": "key",
      "label": _vm.$t('search.message.sort_by'),
      "placeholder": _vm.$t('search.message.sort_by'),
      "persistent-placeholder": "",
      "filled": "",
      "hide-details": "auto",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    model: {
      value: _vm.sortBy,
      callback: function ($$v) {
        _vm.sortBy = $$v;
      },
      expression: "sortBy"
    }
  })], 1) : _vm._e()]], 2), _c(VGrid_namespaceObject.VSpacer), _vm.enableDownload && _vm.downloadFormats.length === 1 ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-data-table__table__settings__downloadBtn",
    attrs: {
      "depressed": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.onDownloadClicked(_vm.downloadFormats[0].id);
      }
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    class: {
      'ma-0': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-down")]), _c('span', {
    staticClass: "d-none d-md-flex"
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.download')) + " ")])], 1) : _vm._e(), _vm.enableDownload && _vm.downloadFormats.length > 1 ? _c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn vp-data-table__table__settings__downloadBtn",
          attrs: {
            "depressed": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, {
          class: {
            'ma-0': _vm.$vuetify.breakpoint.smAndDown
          },
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-arrow-down")]), _c('span', {
          staticClass: "d-none d-md-flex"
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.download')) + " ")])], 1)];
      }
    }], null, false, 3430924466)
  }, [_c(VList_namespaceObject.VList, _vm._l(_vm.downloadFormats, function (downloadFormat) {
    return _c(VList_namespaceObject.VListItem, {
      key: downloadFormat.id,
      on: {
        "click": function ($event) {
          return _vm.onDownloadClicked(downloadFormat.id);
        }
      }
    }, [downloadFormat.icon ? _c(VList_namespaceObject.VListItemIcon, [_c(VIcon_namespaceObject.VIcon, [_vm._v(_vm._s(downloadFormat.icon))])], 1) : _vm._e(), _c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, [_vm._v(_vm._s(downloadFormat.title))])], 1)], 1);
  }), 1)], 1) : _vm._e(), _vm.enableSave ? _c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "content-class": "vp-dialog",
      "persistent": "",
      "scrollable": "",
      "max-width": "552",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn vp-data-table__table__settings__saveBtn",
          attrs: {
            "color": "secondary",
            "depressed": ""
          },
          on: {
            "click": _vm.onSaveClicked
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, {
          class: {
            'ma-0': _vm.$vuetify.breakpoint.smAndDown
          },
          attrs: {
            "left": ""
          }
        }, [_vm._v(" mdi-star ")]), _c('span', {
          staticClass: "d-none d-md-flex"
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")])], 1)];
      }
    }], null, false, 384949084),
    model: {
      value: _vm.saveDialog,
      callback: function ($$v) {
        _vm.saveDialog = $$v;
      },
      expression: "saveDialog"
    }
  }, [_c('vp-saved-search-form', {
    attrs: {
      "value": _vm.savedSearch
    },
    on: {
      "cancel": function ($event) {
        _vm.saveDialog = false;
      },
      "save": _vm.save
    }
  })], 1) : _vm._e(), !_vm.disableColumnSelector ? _c('vp-columns-selector', {
    staticClass: "vp-data-table__table__settings__column-selector data-table__table__settings__column-selector",
    attrs: {
      "columns": _vm.report.columns,
      "enableSave": _vm.enableColumnSave,
      "enableSaveGlobal": _vm.enableColumnSaveGlobal
    },
    on: {
      "save:local": function ($event) {
        return _vm.onSaveActiveColumns(false);
      },
      "save:global": function ($event) {
        return _vm.onSaveActiveColumns(true);
      }
    },
    model: {
      value: _vm.activeColumns,
      callback: function ($$v) {
        _vm.activeColumns = $$v;
      },
      expression: "activeColumns"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.back || _vm.backRoute ? _c('div', {
    staticClass: "vp-data-table__table__back data-table__table__back"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn ma-1",
    attrs: {
      "text": "",
      "to": _vm.backRoute
    },
    on: {
      "click": _vm.onBackClicked
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v(" " + _vm._s(_vm.$t('general.action.back')) + " ")], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "vp-data-table__table__results data-table__table__results"
  }, [_c(VDataTable_namespaceObject.VDataTable, {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.results.results,
      "items-per-page": _vm.conditions.itemsPerPage,
      "options": _vm.options,
      "server-items-length": _vm.results.totalResults,
      "footer-props": {
        itemsPerPageOptions: [10, 20, 50],
        showFirstLastPage: true
      },
      "loading": _vm.loading,
      "disable-pagination": _vm.disablePagination,
      "hide-default-footer": _vm.disablePagination,
      "mobile-breakpoint": _vm.mobileBreakpoint,
      "fixed-header": _vm.fixedHeader,
      "height": _vm.tableHeight
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      },
      "click:row": _vm.onRowClicked
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    })], null, true)
  })], 1)])], 1) : _c('vp-loader');
};
var vp_data_tablevue_type_template_id_7d89ef5e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-data-table/vp-data-table.html?vue&type=template&id=7d89ef5e&external

;// CONCATENATED MODULE: external "core-js/modules/es.array.push.js"
var es_array_push_js_namespaceObject = require("core-js/modules/es.array.push.js");
;// CONCATENATED MODULE: external "lodash"
var external_lodash_namespaceObject = require("lodash");
;// CONCATENATED MODULE: external "date-fns"
var external_date_fns_namespaceObject = require("date-fns");
;// CONCATENATED MODULE: external "vuetify/lib/components/VCheckbox"
var VCheckbox_namespaceObject = require("vuetify/lib/components/VCheckbox");
;// CONCATENATED MODULE: external "vuetify/lib/components/VSheet"
var VSheet_namespaceObject = require("vuetify/lib/components/VSheet");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-columns-selector/vp-columns-selector.html?vue&type=template&id=40295735&external






var vp_columns_selectorvue_type_template_id_40295735_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-columns-selector columns-selector"
  }, [_c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "content-class": "vp-menu vp-columns-selector__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn",
          attrs: {
            "color": "primary",
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-table-edit")]), _c(VIcon_namespaceObject.VIcon, {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.menuIsVisible,
            expression: "menuIsVisible"
          }]
        }, [_vm._v("mdi-chevron-up")]), _c(VIcon_namespaceObject.VIcon, {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.menuIsVisible,
            expression: "!menuIsVisible"
          }]
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }]),
    model: {
      value: _vm.menuIsVisible,
      callback: function ($$v) {
        _vm.menuIsVisible = $$v;
      },
      expression: "menuIsVisible"
    }
  }, [_c(VSheet_namespaceObject.VSheet, {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "vp-columns-selector__menu__toggle"
  }, [_c(VBtn_namespaceObject.VBtn, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAllVisible,
      expression: "!isAllVisible"
    }],
    staticClass: "vp-btn",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.onShowAllClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('search.action.show_all_columns')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAllVisible,
      expression: "isAllVisible"
    }],
    staticClass: "vp-btn",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.onHideAllClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('search.action.hide_all_columns')) + " ")])], 1), _c('div', {
    staticClass: "vp-columns-selector__menu__columns"
  }, _vm._l(_vm.columns, function (column) {
    return _c(VCheckbox_namespaceObject.VCheckbox, {
      key: column.key,
      staticClass: "ma-3 vp-form-control",
      attrs: {
        "label": column.title,
        "input-value": _vm.isActive(column.key),
        "hide-details": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onCheckboxClicked(column.key);
        }
      }
    });
  }), 1), _c('div', {
    staticClass: "vp-columns-selector__menu__actions"
  }, [_vm.enableSave ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "block": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('save:local');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")]) : _vm._e(), _vm.enableSaveGlobal ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn mt-2",
    attrs: {
      "color": "secondary",
      "block": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('save:global');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save_global')) + " ")]) : _vm._e()], 1)])], 1)], 1);
};
var vp_columns_selectorvue_type_template_id_40295735_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-columns-selector/vp-columns-selector.html?vue&type=template&id=40295735&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-columns-selector/vp-columns-selector.ts?vue&type=script&lang=ts&external



let ColumnsSelectorComponent = class ColumnsSelectorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.activeColumns = [];
    this.menuIsVisible = false;
  }
  created() {
    this.activeColumns = [...this.value];
  }
  onValueChanged() {
    this.activeColumns = [...this.value];
  }
  /**
   * Returns whether the column is active
   *
   * @param key
   * @returns
   */
  isActive(key) {
    return this.activeColumns.includes(key);
  }
  /**
   * Returns whether all columns are visible
   */
  get isAllVisible() {
    return this.activeColumns.length === this.columns.length;
  }
  /**
   * Returns whether all columns are hidden
   */
  get isAllHidden() {
    return this.activeColumns.length === 0;
  }
  /**
   * Handles show all clicks
   */
  onShowAllClicked() {
    this.activeColumns = this.columns.map(column => column.key);
    this.$emit('input', this.activeColumns);
  }
  /**
   * Handles hide all clicks
   */
  onHideAllClicked() {
    this.activeColumns = [];
    this.$emit('input', this.activeColumns);
  }
  /**
   * Handles checkbox clicks
   *
   * @param key
   */
  onCheckboxClicked(key) {
    if (this.isActive(key)) {
      this.activeColumns = this.activeColumns.filter(currentKey => currentKey !== key);
    } else {
      this.activeColumns.push(key);
    }
    this.$emit('input', this.activeColumns);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], ColumnsSelectorComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ColumnsSelectorComponent.prototype, "columns", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ColumnsSelectorComponent.prototype, "enableSave", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ColumnsSelectorComponent.prototype, "enableSaveGlobal", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ColumnsSelectorComponent.prototype, "onValueChanged", null);
ColumnsSelectorComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], ColumnsSelectorComponent);
/* harmony default export */ var vp_columns_selectorvue_type_script_lang_ts_external = (ColumnsSelectorComponent);
;// CONCATENATED MODULE: ./src/components/vp-columns-selector/vp-columns-selector.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_columns_selector_vp_columns_selectorvue_type_script_lang_ts_external = (vp_columns_selectorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-columns-selector/vp-columns-selector.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_columns_selectorvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(99);
;// CONCATENATED MODULE: ./src/components/vp-columns-selector/vp-columns-selector.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-columns-selector/vp-columns-selector.vue



;


/* normalize component */

var vp_columns_selector_component = normalizeComponent(
  vp_columns_selector_vp_columns_selectorvue_type_script_lang_ts_external,
  vp_columns_selectorvue_type_template_id_40295735_external_render,
  vp_columns_selectorvue_type_template_id_40295735_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_columns_selector = (vp_columns_selector_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-data-table-settings/vp-data-table-settings.html?vue&type=template&id=7f886a73&external
var vp_data_table_settingsvue_type_template_id_7f886a73_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "data-table-settings"
  }, [_vm._l(_vm.settings, function (setting) {
    return [!setting.hidden ? _c('vp-data-table-setting', {
      key: setting.key,
      attrs: {
        "setting": setting
      },
      on: {
        "input": _vm.onSettingChange
      },
      model: {
        value: _vm.activeSettings[setting.key],
        callback: function ($$v) {
          _vm.$set(_vm.activeSettings, setting.key, $$v);
        },
        expression: "activeSettings[setting.key]"
      }
    }) : _vm._e()];
  }), _vm._t("append")], 2);
};
var vp_data_table_settingsvue_type_template_id_7f886a73_external_staticRenderFns = [];

;// CONCATENATED MODULE: external "vuetify/lib/components/VDatePicker"
var VDatePicker_namespaceObject = require("vuetify/lib/components/VDatePicker");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-data-table-setting/vp-data-table-setting.html?vue&type=template&id=018a02d4&external







var vp_data_table_settingvue_type_template_id_018a02d4_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: `data-table-setting data-table-setting--${_vm.setting.key} d-flex align-center`
  }, [_vm.setting.type === 'boolean' ? [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "data-table-setting__field vp-form-control",
    attrs: {
      "items": [{
        title: _vm.$t('general.action.yes'),
        value: true
      }, {
        title: _vm.$t('general.action.no'),
        value: false
      }],
      "item-text": "title",
      "item-value": "value",
      "label": _vm.setting.title,
      "placeholder": _vm.setting.placeholder,
      "persistent-placeholder": "",
      "filled": "",
      "hide-details": "auto",
      "clearable": _vm.setting.clearable,
      "readonly": _vm.setting.readonly,
      "disabled": _vm.setting.disabled,
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "click:clear": _vm.onClearValue,
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })] : _vm.setting.type === 'date_day' ? [!_vm.setting.readonly && !_vm.setting.disabled ? [_c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "close-on-content-click": false,
      "transition": "fade-transition",
      "min-width": "auto",
      "content-class": "vp-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
          staticClass: "vp-form-control",
          attrs: {
            "append-icon": "mdi-calendar",
            "label": _vm.setting.title,
            "placeholder": _vm.$t('general.field.day'),
            "persistent-placeholder": "",
            "filled": "",
            "hide-details": "auto",
            "readonly": "",
            "clearable": _vm.setting.clearable
          },
          on: {
            "click:clear": _vm.onClearValue
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }], null, false, 1040200489),
    model: {
      value: _vm.menuVisible,
      callback: function ($$v) {
        _vm.menuVisible = $$v;
      },
      expression: "menuVisible"
    }
  }, [_c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "type": "date",
      "width": "256"
    },
    on: {
      "input": function ($event) {
        _vm.menuVisible = false;
      },
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })], 1)] : _c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
    staticClass: "vp-form-control",
    attrs: {
      "append-icon": "mdi-calendar",
      "label": _vm.setting.title,
      "placeholder": _vm.$t('general.field.day'),
      "persistent-placeholder": "",
      "filled": "",
      "hide-details": "auto",
      "readonly": "",
      "disabled": _vm.setting.disabled,
      "clearable": _vm.setting.clearable
    },
    on: {
      "click:clear": _vm.onClearValue
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))] : _vm.setting.type === 'date_month' ? [!_vm.setting.readonly && !_vm.setting.disabled ? [_c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "close-on-content-click": false,
      "transition": "fade-transition",
      "min-width": "auto",
      "content-class": "vp-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
          staticClass: "vp-form-control",
          attrs: {
            "append-icon": "mdi-calendar",
            "label": _vm.setting.title,
            "placeholder": _vm.$t('general.field.month'),
            "persistent-placeholder": "",
            "filled": "",
            "hide-details": "auto",
            "readonly": "",
            "clearable": _vm.setting.clearable
          },
          on: {
            "click:clear": _vm.onClearValue
          },
          model: {
            value: _vm.currentValue,
            callback: function ($$v) {
              _vm.currentValue = $$v;
            },
            expression: "currentValue"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }], null, false, 892563109),
    model: {
      value: _vm.menuVisible,
      callback: function ($$v) {
        _vm.menuVisible = $$v;
      },
      expression: "menuVisible"
    }
  }, [_c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "type": "month",
      "width": "256"
    },
    on: {
      "input": function ($event) {
        _vm.menuVisible = false;
      },
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })], 1)] : _c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
    staticClass: "vp-form-control",
    attrs: {
      "append-icon": "mdi-calendar",
      "label": _vm.setting.title,
      "placeholder": _vm.$t('general.field.month'),
      "persistent-placeholder": "",
      "filled": "",
      "hide-details": "auto",
      "readonly": "",
      "disabled": _vm.setting.disabled,
      "clearable": _vm.setting.clearable
    },
    on: {
      "click:clear": _vm.onClearValue
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))] : _vm.setting.type === 'date_range_comparison' ? [_c('vp-date-range-comparison-picker', {
    staticClass: "data-table-setting__field",
    attrs: {
      "label": _vm.setting.title,
      "filled": "",
      "clearable": _vm.setting.clearable,
      "readonly": _vm.setting.readonly,
      "disabled": _vm.setting.disabled
    },
    on: {
      "click:clear": _vm.onClearValue,
      "input": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })] : _vm.setting.type === 'radio' ? [_c(VRadioGroup_namespaceObject.VRadioGroup, {
    staticClass: "data-table-setting__field mt-0 mb-3 pt-0",
    attrs: {
      "hide-details": "",
      "readonly": _vm.setting.readonly,
      "disabled": _vm.setting.disabled
    },
    on: {
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, _vm._l(_vm.setting.options, function (option) {
    return _c(VRadioGroup_namespaceObject.VRadio, {
      key: option.value,
      attrs: {
        "label": option.title,
        "value": option.value,
        "readonly": _vm.setting.readonly,
        "disabled": _vm.setting.disabled
      }
    });
  }), 1)] : _vm.setting.type === 'select' ? [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "data-table-setting__field vp-form-control",
    attrs: {
      "items": _vm.setting.options,
      "item-text": "title",
      "item-value": "value",
      "label": _vm.setting.title,
      "placeholder": _vm.setting.placeholder,
      "persistent-placeholder": "",
      "filled": "",
      "hide-details": "auto",
      "clearable": _vm.setting.clearable,
      "readonly": _vm.setting.readonly,
      "disabled": _vm.setting.disabled,
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "click:clear": _vm.onClearValue,
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })] : _vm._e()], 2);
};
var vp_data_table_settingvue_type_template_id_018a02d4_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-data-table-setting/vp-data-table-setting.html?vue&type=template&id=018a02d4&external

;// CONCATENATED MODULE: external "vuetify/lib/components/VDivider"
var VDivider_namespaceObject = require("vuetify/lib/components/VDivider");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.html?vue&type=template&id=0ed25aee&external












var vp_date_range_comparison_pickervue_type_template_id_0ed25aee_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-dateRangeComparisonPicker"
  }, [_c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "max-width": "700",
      "contentClass": "vp-dateRangeComparisonPicker__dialog vp-dialog",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "scrollable": ""
    },
    on: {
      "click:outside": _vm.onCancel
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
          staticClass: "vp-form-control",
          class: _vm.comparedTo.length > 1 ? 'vp-dateRangeComparisonPicker--compare' : '',
          attrs: {
            "value": _vm.formattedDateRange,
            "label": _vm.label,
            "hint": _vm.hint,
            "persistent-hint": "",
            "append-icon": _vm.comparedTo.length > 1 ? 'mdi-compare-vertical' : 'mdi-calendar',
            "clearable": _vm.clearable,
            "filled": _vm.filled,
            "outlined": _vm.outlined,
            "solo": _vm.solo,
            "readonly": "",
            "disabled": _vm.disabled,
            "light": _vm.light,
            "dark": _vm.dark,
            "error": _vm.error,
            "error-messages": _vm.errorMessages
          },
          on: {
            "click:clear": _vm.onClear
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card",
    attrs: {
      "light": _vm.light,
      "dark": _vm.dark
    }
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('general.message.choose_comparison_date_ranges')) + " ")]), _c(VCard_namespaceObject.VCardText, [_c('div', {
    staticClass: "vp-dateRangeComparisonPicker__ranges"
  }, [_c('div', {
    staticClass: "vp-dateRangeComparisonPicker__ranges__inner"
  }, [_c('div', {
    staticClass: "vp-dateRangeComparisonPicker__range"
  }, [_c('span', {
    staticClass: "vp-dateRangeComparisonPicker__range__title"
  }, [_vm._v(_vm._s(_vm.$t('general.field.date_range')))]), _c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "range": "",
      "light": _vm.light,
      "dark": _vm.dark
    },
    model: {
      value: _vm.workingRange,
      callback: function ($$v) {
        _vm.workingRange = $$v;
      },
      expression: "workingRange"
    }
  }), _c('span', {
    staticClass: "vp-dateRangeComparisonPicker__range__date"
  }, [_vm._v(" " + _vm._s(_vm.formattedWorkingDateRange) + " ")])], 1), _c(VIcon_namespaceObject.VIcon, {
    staticClass: "vp-dateRangeComparisonPicker__divider vp-dateRangeComparisonPicker__divider--hoz"
  }, [_vm._v("mdi-compare-horizontal")]), _c(VIcon_namespaceObject.VIcon, {
    staticClass: "vp-dateRangeComparisonPicker__divider vp-dateRangeComparisonPicker__divider--ver"
  }, [_vm._v("mdi-compare-vertical")]), _c('div', {
    staticClass: "vp-dateRangeComparisonPicker__range"
  }, [_c('span', {
    staticClass: "vp-dateRangeComparisonPicker__range__title"
  }, [_vm._v(_vm._s(_vm.$t('general.field.compared_to')))]), _c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "range": "",
      "light": _vm.light,
      "dark": _vm.dark
    },
    model: {
      value: _vm.workingComparedTo,
      callback: function ($$v) {
        _vm.workingComparedTo = $$v;
      },
      expression: "workingComparedTo"
    }
  }), _c('span', {
    staticClass: "vp-dateRangeComparisonPicker__range__date"
  }, [_vm._v(" " + _vm._s(_vm.formattedWorkingComparedTo) + " ")])], 1)], 1)])]), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.onUpdate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.update')) + " ")])], 1)], 1)], 1)], 1);
};
var vp_date_range_comparison_pickervue_type_template_id_0ed25aee_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.html?vue&type=template&id=0ed25aee&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.ts?vue&type=script&lang=ts&external




let DateRangeComparisonPickerComponent = class DateRangeComparisonPickerComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.dialog = false;
    this.workingRange = [];
    this.workingComparedTo = [];
    this.range = [];
    this.comparedTo = [];
  }
  created() {
    this.updateDates();
  }
  onValueChanged() {
    this.updateDates();
  }
  onWorkingRangeChanged() {
    // Ensure the dates are in ascending order
    if (this.workingRange.length !== 2) {
      return;
    }
    if (this.workingRange[0] > this.workingRange[1]) {
      this.workingRange = [this.workingRange[1], this.workingRange[0]];
    }
  }
  onWorkingComparedToChanged() {
    // Ensure the dates are in ascending order
    if (this.workingComparedTo.length !== 2) {
      return;
    }
    if (this.workingComparedTo[0] > this.workingComparedTo[1]) {
      this.workingComparedTo = [this.workingComparedTo[1], this.workingComparedTo[0]];
    }
  }
  /**
   * Returns the formatted date range
   */
  get formattedDateRange() {
    const formattedDates = [];
    for (const dateString of this.range) {
      const date = (0,external_date_fns_namespaceObject.parse)(dateString, 'yyyy-MM-dd', new Date());
      formattedDates.push((0,external_date_fns_namespaceObject.format)(date, this.displayFormat));
    }
    return this.generateFormattedDate(formattedDates);
  }
  /**
   * Returns the formatted compared to date range
   */
  get formattedComparedTo() {
    const formattedDates = [];
    for (const dateString of this.comparedTo) {
      const date = (0,external_date_fns_namespaceObject.parse)(dateString, 'yyyy-MM-dd', new Date());
      formattedDates.push((0,external_date_fns_namespaceObject.format)(date, this.displayFormat));
    }
    return this.generateFormattedDate(formattedDates);
  }
  /**
   * Returns the formatted working date range
   */
  get formattedWorkingDateRange() {
    const formattedDates = [];
    for (const dateString of this.workingRange) {
      const date = (0,external_date_fns_namespaceObject.parse)(dateString, 'yyyy-MM-dd', new Date());
      formattedDates.push((0,external_date_fns_namespaceObject.format)(date, this.displayFormat));
    }
    return this.generateFormattedDate(formattedDates);
  }
  /**
    * Returns the formatted working compared to date range
    */
  get formattedWorkingComparedTo() {
    const formattedDates = [];
    for (const dateString of this.workingComparedTo) {
      const date = (0,external_date_fns_namespaceObject.parse)(dateString, 'yyyy-MM-dd', new Date());
      formattedDates.push((0,external_date_fns_namespaceObject.format)(date, this.displayFormat));
    }
    return this.generateFormattedDate(formattedDates);
  }
  /**
   * Generates a formatted range of dates
   *
   * @param formattedDates
   * @returns
   */
  generateFormattedDate(formattedDates) {
    if (formattedDates.length > 0) {
      if (formattedDates[0] === formattedDates[1]) {
        return formattedDates[0];
      } else {
        return formattedDates.join(' - ');
      }
    } else {
      return '-';
    }
  }
  /**
   * Returns the hint text for the display field
   */
  get hint() {
    return this.formattedComparedTo === '-' ? null : this.formattedComparedTo;
  }
  /**
   * Updates the working date values for the component
   */
  updateDates() {
    var _a, _b;
    this.range = [];
    if (((_a = this.value) === null || _a === void 0 ? void 0 : _a.range) && Array.isArray(this.value.range)) {
      for (const date of this.value.range) {
        if (typeof date === 'string') {
          const dateObject = (0,external_date_fns_namespaceObject.parse)(date, this.dateFormat, new Date());
          this.range.push((0,external_date_fns_namespaceObject.format)(dateObject, 'yyyy-MM-dd'));
        } else {
          this.range.push((0,external_date_fns_namespaceObject.format)(date, 'yyyy-MM-dd'));
        }
      }
    }
    // Sanity check to only ensure max of 2 values
    if (this.range.length > 2) {
      this.range = this.range.slice(0, 2);
    }
    this.comparedTo = [];
    if (((_b = this.value) === null || _b === void 0 ? void 0 : _b.range) && Array.isArray(this.value.range)) {
      for (const date of this.value.comparedTo) {
        if (typeof date === 'string') {
          const dateObject = (0,external_date_fns_namespaceObject.parse)(date, this.dateFormat, new Date());
          this.comparedTo.push((0,external_date_fns_namespaceObject.format)(dateObject, 'yyyy-MM-dd'));
        } else {
          this.comparedTo.push((0,external_date_fns_namespaceObject.format)(date, 'yyyy-MM-dd'));
        }
      }
    }
    // Sanity check to only ensure max of 2 values
    if (this.comparedTo.length > 2) {
      this.comparedTo = this.comparedTo.slice(0, 2);
    }
    // Validate the range lengths
    this.validateRangeLengths();
    // Update the working dates
    this.updateWorkingDates();
  }
  /**
   * Updates the working dates
   *
   * Note: These are different as the component always returns ranges with from and to,
   *       whereas the date range component could only return a single date in either range.
   *
   *       e.g. Single days
   */
  updateWorkingDates() {
    if (this.range.length > 0 && this.range[0] === this.range[1]) {
      this.workingRange = [this.range[0]];
    } else {
      this.workingRange = this.range;
    }
    if (this.comparedTo.length > 0 && this.comparedTo[0] === this.comparedTo[1]) {
      this.workingComparedTo = [this.comparedTo[0]];
    } else {
      this.workingComparedTo = this.comparedTo;
    }
  }
  /**
   * Handles clear button clicks
   */
  onClear() {
    this.$emit('input', {
      range: [],
      comparedTo: []
    });
  }
  /**
   * Handles cancel button clicks
   */
  onCancel() {
    // Close the dialog
    this.dialog = false;
    // Reset the dates
    this.updateDates();
  }
  /**
   * Handles update button clicks
   */
  onUpdate() {
    // Close the dialog
    this.dialog = false;
    // Update the model ranges
    this.range = [...this.workingRange];
    this.comparedTo = [...this.workingComparedTo];
    // Validate the range lengths
    this.validateRangeLengths();
    // Trigger a value update
    this.$emit('input', {
      range: this.range,
      comparedTo: this.comparedTo
    });
  }
  /**
   * Ensures the actual model range lengths are always 2, so a from and to date.
   *
   * Note: The date range component can return single days.
   */
  validateRangeLengths() {
    if (this.range.length === 1) {
      this.range.push(this.range[0]);
    }
    if (this.comparedTo.length === 1) {
      this.comparedTo.push(this.comparedTo[0]);
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object,
  default: undefined
})], DateRangeComparisonPickerComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], DateRangeComparisonPickerComponent.prototype, "label", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: 'yyyy-MM-dd'
})], DateRangeComparisonPickerComponent.prototype, "dateFormat", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: 'd MMM yyyy'
})], DateRangeComparisonPickerComponent.prototype, "displayFormat", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "clearable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "filled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "outlined", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "solo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "disabled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateRangeComparisonPickerComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateRangeComparisonPickerComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], DateRangeComparisonPickerComponent.prototype, "errorMessages", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DateRangeComparisonPickerComponent.prototype, "onValueChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('workingRange')], DateRangeComparisonPickerComponent.prototype, "onWorkingRangeChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('workingComparedTo')], DateRangeComparisonPickerComponent.prototype, "onWorkingComparedToChanged", null);
DateRangeComparisonPickerComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], DateRangeComparisonPickerComponent);
/* harmony default export */ var vp_date_range_comparison_pickervue_type_script_lang_ts_external = (DateRangeComparisonPickerComponent);
;// CONCATENATED MODULE: ./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_date_range_comparison_picker_vp_date_range_comparison_pickervue_type_script_lang_ts_external = (vp_date_range_comparison_pickervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_date_range_comparison_pickervue_type_style_index_0_prod_lang_scss_external = __webpack_require__(15);
;// CONCATENATED MODULE: ./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-date-range-comparison-picker/vp-date-range-comparison-picker.vue



;


/* normalize component */

var vp_date_range_comparison_picker_component = normalizeComponent(
  vp_date_range_comparison_picker_vp_date_range_comparison_pickervue_type_script_lang_ts_external,
  vp_date_range_comparison_pickervue_type_template_id_0ed25aee_external_render,
  vp_date_range_comparison_pickervue_type_template_id_0ed25aee_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_date_range_comparison_picker = (vp_date_range_comparison_picker_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-data-table-setting/vp-data-table-setting.ts?vue&type=script&lang=ts&external



let DataTableSettingComponent = class DataTableSettingComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.currentValue = null;
    this.menuVisible = false;
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    if (this.value === null && this.setting.defaultValue !== null && this.setting.defaultValue !== undefined) {
      this.currentValue = this.setting.defaultValue;
      this.onCurrentValueUpdated();
    } else {
      this.currentValue = this.value;
    }
  }
  /**
   * Handles clearing the value
   */
  onClearValue() {
    this.currentValue = null;
    this.onCurrentValueUpdated();
  }
  /**
   * Handles updates to the current value
   */
  onCurrentValueUpdated() {
    this.$emit('input', this.currentValue);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: null
})], DataTableSettingComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DataTableSettingComponent.prototype, "setting", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DataTableSettingComponent.prototype, "onValueChanged", null);
DataTableSettingComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-date-range-comparison-picker': vp_date_range_comparison_picker
  }
})], DataTableSettingComponent);
/* harmony default export */ var vp_data_table_settingvue_type_script_lang_ts_external = (DataTableSettingComponent);
;// CONCATENATED MODULE: ./src/components/vp-data-table-setting/vp-data-table-setting.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_data_table_setting_vp_data_table_settingvue_type_script_lang_ts_external = (vp_data_table_settingvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-data-table-setting/vp-data-table-setting.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_data_table_settingvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(183);
;// CONCATENATED MODULE: ./src/components/vp-data-table-setting/vp-data-table-setting.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-data-table-setting/vp-data-table-setting.vue



;


/* normalize component */

var vp_data_table_setting_component = normalizeComponent(
  vp_data_table_setting_vp_data_table_settingvue_type_script_lang_ts_external,
  vp_data_table_settingvue_type_template_id_018a02d4_external_render,
  vp_data_table_settingvue_type_template_id_018a02d4_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_data_table_setting = (vp_data_table_setting_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-data-table-settings/vp-data-table-settings.ts?vue&type=script&lang=ts&external




let DataTableSettingsComponent = class DataTableSettingsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.activeSettings = {};
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    this.activeSettings = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
  }
  onSettingChange() {
    this.$emit('input', this.activeSettings);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: {}
})], DataTableSettingsComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DataTableSettingsComponent.prototype, "settings", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DataTableSettingsComponent.prototype, "onValueChanged", null);
DataTableSettingsComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-data-table-setting': vp_data_table_setting
  }
})], DataTableSettingsComponent);
/* harmony default export */ var vp_data_table_settingsvue_type_script_lang_ts_external = (DataTableSettingsComponent);
;// CONCATENATED MODULE: ./src/components/vp-data-table-settings/vp-data-table-settings.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_data_table_settings_vp_data_table_settingsvue_type_script_lang_ts_external = (vp_data_table_settingsvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-data-table-settings/vp-data-table-settings.vue





/* normalize component */
;
var vp_data_table_settings_component = normalizeComponent(
  vp_data_table_settings_vp_data_table_settingsvue_type_script_lang_ts_external,
  vp_data_table_settingsvue_type_template_id_7f886a73_external_render,
  vp_data_table_settingsvue_type_template_id_7f886a73_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_data_table_settings = (vp_data_table_settings_component.exports);
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/event/event-bus"
var event_bus_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/event/event-bus");
var event_bus_default = /*#__PURE__*/__webpack_require__.n(event_bus_namespaceObject);
;// CONCATENATED MODULE: ./src/model/services/search/filter-service.ts


class FilterService {
  /**
   * Returns the query string value for a filter value
   *
   * @param filter
   * @param value
   * @returns
   */
  static getQueryValueFomFilter(filter, value) {
    switch (filter.type) {
      case 'boolean':
        return value === true ? '1' : '0';
      case 'date-range':
        if (Array.isArray(value)) {
          return `${value[0]}~${value[1]}`;
        } else {
          return null;
        }
      default:
        if (filter.optionsCallback) {
          if (filter.multiple && Array.isArray(value)) {
            const queryValues = [];
            for (const item of value) {
              queryValues.push(item.value);
            }
            return queryValues.join(',');
          } else {
            return value === null || value === void 0 ? void 0 : value.value;
          }
        } else if (filter.options && filter.multiple && Array.isArray(value)) {
          return value.join(',');
        } else {
          return value;
        }
    }
  }
  /**
   * Returns a filter value from a query string value
   *
   * @param filter
   * @param value
   * @returns
   */
  static getFilterValueFromQuery(filter, value) {
    switch (filter.type) {
      case 'boolean':
        return value === 'true' || value === '1';
      case 'date-range':
        return value.split('~');
      default:
        if (filter.optionsCallback) {
          return FilterService.getFilterOptionValues(filter, value);
        } else if (filter.options && filter.multiple) {
          return Array.isArray(value) ? value : value.split(',');
        } else {
          return value;
        }
    }
  }
  /**
   * Returns a filter value from a query string value, taking into account existing values
   *
   * @param filter
   * @param value
   * @param existingValue
   * @returns
   */
  static getUpdatedFilterValueFromQuery(filter, value, existingValue) {
    const filterValue = FilterService.getFilterValueFromQuery(filter, value);
    if (filterValue === null) {
      return null;
    }
    if (Array.isArray(filterValue) && Array.isArray(existingValue)) {
      for (const item of filterValue) {
        if (typeof item !== 'object' || item.title !== item.value) {
          continue;
        }
        for (const existingItem of existingValue) {
          if (typeof existingItem !== 'object' || existingItem.value !== item.value) {
            continue;
          }
          item.title = existingItem.title;
        }
      }
    } else if (typeof filterValue === 'object' && 'title' in filterValue && existingValue && typeof existingValue === 'object' && 'title' in existingValue && filterValue.title === filterValue.value) {
      filterValue.title = existingValue.title;
    }
    return filterValue;
  }
  /**
   * Returns the values for filter options
   *
   * @param filter
   * @param value
   * @returns
   */
  static getFilterOptionValues(filter, value) {
    if (filter.multiple) {
      const queryValues = value.split(',');
      const filterValues = [];
      for (const queryValue of queryValues) {
        let queryTitle = queryValue;
        if (filter.options) {
          const option = (0,external_lodash_namespaceObject.find)(filter.options, {
            value: queryValue
          });
          if (option) {
            queryTitle = option.title;
          }
        }
        filterValues.push({
          value: queryValue,
          title: queryTitle
        });
      }
      return filterValues;
    } else {
      return {
        value,
        title: value
      };
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-filters/vp-filters.html?vue&type=template&id=30e4b76e&external






var vp_filtersvue_type_template_id_30e4b76e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filters__active"
  }, _vm._l(_vm.activeFilters, function (value, key) {
    return _c(VBtn_namespaceObject.VBtn, {
      key: key,
      staticClass: "vp-btn filters__button filters__button--active mr-3 mb-3 pr-2",
      on: {
        "click": function ($event) {
          return _vm.editFilter(key);
        }
      }
    }, [_c('strong', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(_vm.getActiveFilterTitle(key)) + " >")]), _c('span', [_vm._v(_vm._s(_vm.getActiveFilterValue(key)))]), _c(VBtn_namespaceObject.VBtn, {
      staticClass: "ml-1",
      attrs: {
        "icon": "",
        "small": ""
      }
    }, [_c(VIcon_namespaceObject.VIcon, {
      attrs: {
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeActiveFilter(key);
        }
      }
    }, [_vm._v(" mdi-close ")])], 1)], 1);
  }), 1), _c('div', {
    staticClass: "filters__add"
  }, [_c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "offset-y": "",
      "content-class": "vp-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn filters__button filters__button--add mb-3",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('search.action.add_filter')) + " ")], 1)];
      }
    }]),
    model: {
      value: _vm.filtersVisible,
      callback: function ($$v) {
        _vm.filtersVisible = $$v;
      },
      expression: "filtersVisible"
    }
  }, [_c(VList_namespaceObject.VList, {
    attrs: {
      "min-width": "145px"
    }
  }, _vm._l(_vm.filters, function (filter) {
    return _c('vp-filter-list-item', {
      key: filter.key,
      attrs: {
        "filter": filter
      },
      on: {
        "edit-filter": _vm.editFilter
      }
    });
  }), 1)], 1)], 1), _c('vp-dialog', {
    attrs: {
      "title": _vm.filter?.title ?? '',
      "max-width": "350",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn",
          attrs: {
            "depressed": ""
          },
          on: {
            "click": _vm.onCancelEditFilter
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn",
          attrs: {
            "color": "primary",
            "depressed": ""
          },
          on: {
            "click": _vm.onApplyFilter
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('search.action.apply_filter')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.filterOptionsVisible,
      callback: function ($$v) {
        _vm.filterOptionsVisible = $$v;
      },
      expression: "filterOptionsVisible"
    }
  }, [_vm.filter ? _c('vp-filter-options', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: _vm.filterValue,
      callback: function ($$v) {
        _vm.filterValue = $$v;
      },
      expression: "filterValue"
    }
  }) : _vm._e()], 1)], 1);
};
var vp_filtersvue_type_template_id_30e4b76e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-filters/vp-filters.html?vue&type=template&id=30e4b76e&external

;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/content/date-helper"
var date_helper_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/content/date-helper");
var date_helper_default = /*#__PURE__*/__webpack_require__.n(date_helper_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-dialog/_template.html?vue&type=template&id=0c658949&external










var _templatevue_type_template_id_0c658949_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog_namespaceObject.VDialog, {
    staticClass: "vp-dialog",
    attrs: {
      "max-width": _vm.maxWidth,
      "fullscreen": _vm.fullscreen,
      "persistent": _vm.persistent,
      "scrollable": _vm.scrollable
    },
    on: {
      "input": _vm.onShowChanged
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c(VCard_namespaceObject.VCard, [_vm._t("header", function () {
    return [_c(VCard_namespaceObject.VCardTitle, {
      staticClass: "vp-dialog__header"
    }, [_vm._t("header.title", function () {
      return [_c('span', [_vm._v(_vm._s(_vm.title))])];
    }), _vm.cornerClose ? [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
      attrs: {
        "icon": ""
      },
      on: {
        "click": _vm.onClose
      }
    }, [_vm._t("header.icon", function () {
      return [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-close-circle")])];
    })], 2)] : _vm._e()], 2)];
  }), _c(VCard_namespaceObject.VCardText, {
    staticClass: "vp-dialog__body"
  }, [_vm._t("default")], 2), _c(VDivider_namespaceObject.VDivider), _vm.hasActions ? _c(VCard_namespaceObject.VCardActions, {
    staticClass: "vp-dialog__actions"
  }, [_vm._t("actions")], 2) : _vm._e()], 2)], 1);
};
var _templatevue_type_template_id_0c658949_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-dialog/_template.html?vue&type=template&id=0c658949&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-dialog/_logic.ts?vue&type=script&lang=ts&external


let DialogComponent = class DialogComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.show = false;
  }
  created() {
    this.show = this.value;
  }
  onValueChanged() {
    this.show = this.value;
  }
  /**
   * Returns whether the dialog has actions
   */
  get hasActions() {
    return !!this.$slots.actions;
  }
  /**
   * Handles the dialog changing the show property
   *
   * @param show
   */
  onShowChanged(show) {
    this.$emit('input', show);
  }
  /**
   * Handles closing the dialog
   */
  onClose() {
    this.$emit('input', false);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DialogComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DialogComponent.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DialogComponent.prototype, "cornerClose", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DialogComponent.prototype, "maxWidth", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DialogComponent.prototype, "fullscreen", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DialogComponent.prototype, "persistent", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DialogComponent.prototype, "scrollable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DialogComponent.prototype, "onValueChanged", null);
DialogComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], DialogComponent);
/* harmony default export */ var vp_dialog_logicvue_type_script_lang_ts_external = (DialogComponent);
;// CONCATENATED MODULE: ./src/components/vp-dialog/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_vp_dialog_logicvue_type_script_lang_ts_external = (vp_dialog_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-dialog/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_dialog_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(817);
;// CONCATENATED MODULE: ./src/components/vp-dialog/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-dialog/index.vue



;


/* normalize component */

var vp_dialog_component = normalizeComponent(
  components_vp_dialog_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_0c658949_external_render,
  _templatevue_type_template_id_0c658949_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_dialog = (vp_dialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-filter-list-item/vp-filter-list-item.html?vue&type=template&id=e27d23ea&external





var vp_filter_list_itemvue_type_template_id_e27d23ea_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VList_namespaceObject.VListItem, {
    on: {
      "click": function ($event) {
        return _vm.$emit('edit-filter', _vm.filter.key);
      }
    }
  }, [_c(VList_namespaceObject.VListItemTitle, [_vm._v(_vm._s(_vm.filter.title))]), _c(VList_namespaceObject.VListItemIcon, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-right")])], 1)], 1);
};
var vp_filter_list_itemvue_type_template_id_e27d23ea_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-filter-list-item/vp-filter-list-item.html?vue&type=template&id=e27d23ea&external

;// CONCATENATED MODULE: external "vuetify/lib/components/VAutocomplete"
var VAutocomplete_namespaceObject = require("vuetify/lib/components/VAutocomplete");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-filter-options/vp-filter-options.html?vue&type=template&id=17c7a003&external










var vp_filter_optionsvue_type_template_id_17c7a003_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.filter.type === 'boolean' ? [_c(VRadioGroup_namespaceObject.VRadioGroup, {
    staticClass: "mt-0 mb-3 pt-0",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, [_c(VRadioGroup_namespaceObject.VRadio, {
    attrs: {
      "label": _vm.$t('general.action.yes'),
      "value": true
    }
  }), _c(VRadioGroup_namespaceObject.VRadio, {
    attrs: {
      "label": _vm.$t('general.action.no'),
      "value": false
    }
  })], 1)] : _vm.filter.type === 'string' ? [_vm.filter.options ? [_vm.filter.options.length > 5 ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    staticClass: "mt-0 mb-3 pt-0 vp-form-control",
    attrs: {
      "items": _vm.filter.options,
      "item-text": "title",
      "item-value": "value",
      "multiple": _vm.filter.multiple,
      "label": _vm.filter.title,
      "placeholder": _vm.filter.title,
      "filled": "",
      "hide-details": "auto",
      "clearable": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }) : _c(VRadioGroup_namespaceObject.VRadioGroup, {
    staticClass: "mt-0 mb-3 pt-0",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }, _vm._l(_vm.filter.options, function (option) {
    return _c(VRadioGroup_namespaceObject.VRadio, {
      key: option.value,
      attrs: {
        "label": option.title,
        "value": option.value
      }
    });
  }), 1)] : _vm.filter.optionsCallback ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    staticClass: "mt-0 mb-3 pt-0 vp-form-control",
    attrs: {
      "items": _vm.dynamicOptions,
      "loading": _vm.loading,
      "search-input": _vm.search,
      "item-text": "title",
      "item-value": "value",
      "return-object": "",
      "multiple": _vm.filter.multiple,
      "filter": _vm.filter.disableFilter ? _vm.dynamicOptionsDisabledFilter : undefined,
      "hide-no-data": "",
      "label": _vm.filter.title,
      "placeholder": _vm.filter.title,
      "filled": "",
      "hide-details": "auto",
      "clearable": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }) : _c(VTextField_namespaceObject.VTextField, {
    staticClass: "mt-0 mb-3 pt-0 vp-form-control",
    attrs: {
      "label": _vm.filter.title,
      "placeholder": _vm.filter.title,
      "filled": "",
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "change": _vm.onCurrentValueUpdated
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  })] : _vm.filter.type === 'date-range' ? [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "mb-3 vp-form-control",
    attrs: {
      "items": _vm.dateRangeItems,
      "label": _vm.filter.title,
      "placeholder": _vm.filter.title,
      "filled": "",
      "hide-details": "auto",
      "clearable": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    model: {
      value: _vm.dateRangeType,
      callback: function ($$v) {
        _vm.dateRangeType = $$v;
      },
      expression: "dateRangeType"
    }
  }), _vm.dateRangeType === 'custom' ? _c(VMenu_namespaceObject.VMenu, {
    ref: "dateRangeMenu",
    staticClass: "vp-menu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.currentValue,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function ($event) {
        _vm.currentValue = $event;
      },
      "update:return-value": [function ($event) {
        _vm.currentValue = $event;
      }, _vm.onCurrentValueUpdated]
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g(_vm._b({
          staticClass: "mt-3 mb-3",
          attrs: {
            "prepend-icon": "mdi-calendar",
            "solo": "",
            "hide-details": "",
            "read-only": ""
          },
          model: {
            value: _vm.dateRangeText,
            callback: function ($$v) {
              _vm.dateRangeText = $$v;
            },
            expression: "dateRangeText"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }], null, false, 3209622843),
    model: {
      value: _vm.dateRangeMenu,
      callback: function ($$v) {
        _vm.dateRangeMenu = $$v;
      },
      expression: "dateRangeMenu"
    }
  }, [_c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "range": ""
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }), _c(VGrid_namespaceObject.VSpacer), _c('div', {
    staticClass: "d-flex"
  }, [_c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.dateRangeMenu = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.dateRangeMenu.save(_vm.currentValue);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.ok')) + " ")])], 1)], 1) : _vm._e()] : _vm._e()], 2);
};
var vp_filter_optionsvue_type_template_id_17c7a003_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-filter-options/vp-filter-options.html?vue&type=template&id=17c7a003&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-filter-options/vp-filter-options.ts?vue&type=script&lang=ts&external





let FilterOptionsComponent = class FilterOptionsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.currentValue = null;
    this.dateRangeType = '';
    this.dateRangeMenu = false;
    this.loading = false;
    this.search = '';
    this.existingDynamicOptions = [];
    this.results = [];
  }
  /**
   * Returns the items for a date-range filter
   */
  get dateRangeItems() {
    return [{
      value: 'today',
      text: this.$t('general.field.today').toString()
    }, {
      value: 'yesterday',
      text: this.$t('general.field.yesterday').toString()
    }, {
      value: 'this-week',
      text: this.$t('general.field.this_week').toString()
    }, {
      value: 'last-week',
      text: this.$t('general.field.last_week').toString()
    }, {
      value: 'last-7-days',
      text: this.$t('general.field.last_days', {
        days: 7
      }).toString()
    }, {
      value: 'this-month',
      text: this.$t('general.field.this_month').toString()
    }, {
      value: 'last-month',
      text: this.$t('general.field.last_month').toString()
    }, {
      value: 'last-30-days',
      text: this.$t('general.field.last_days', {
        days: 30
      }).toString()
    }, {
      value: 'this-quarter',
      text: this.$t('general.field.this_quarter').toString()
    }, {
      value: 'last-quarter',
      text: this.$t('general.field.last_quarter').toString()
    }, {
      value: 'this-year',
      text: this.$t('general.field.this_year').toString()
    }, {
      value: 'last-year',
      text: this.$t('general.field.last_year').toString()
    }, {
      value: 'custom',
      text: this.$t('general.field.custom').toString()
    }];
  }
  onDateRangeTypeChange() {
    const dateRanges = date_helper_default().getStandardDateRanges();
    switch (this.dateRangeType) {
      case 'today':
        this.currentValue = dateRanges.today;
        break;
      case 'yesterday':
        this.currentValue = dateRanges.yesterday;
        break;
      case 'this-week':
        this.currentValue = dateRanges['this-week'];
        break;
      case 'last-week':
        this.currentValue = dateRanges['last-week'];
        break;
      case 'last-7-days':
        this.currentValue = dateRanges['last-7-days'];
        break;
      case 'this-month':
        this.currentValue = dateRanges['this-month'];
        break;
      case 'last-month':
        this.currentValue = dateRanges['last-month'];
        break;
      case 'last-30-days':
        this.currentValue = dateRanges['last-30-days'];
        break;
      case 'this-quarter':
        this.currentValue = dateRanges['this-quarter'];
        break;
      case 'last-quarter':
        this.currentValue = dateRanges['last-quarter'];
        break;
      case 'this-year':
        this.currentValue = dateRanges['this-year'];
        break;
      case 'last-year':
        this.currentValue = dateRanges['last-year'];
        break;
      default:
        return;
    }
    this.onCurrentValueUpdated();
  }
  get dateRangeText() {
    if (!Array.isArray(this.currentValue) || typeof this.currentValue[0] !== 'string' || typeof this.currentValue[1] !== 'string') {
      return '';
    }
    return `${this.currentValue[0]} ~ ${this.currentValue[1]}`;
  }
  set dateRangeText(text) {
    if (!text.match(/[0-9]{4,4}-[0-9]{2,2}-[0-9]{2,2} ~ [0-9]{4,4}-[0-9]{2,2}-[0-9]{2,2}/)) {
      return;
    }
    this.currentValue = text.split(' ~ ');
  }
  get dynamicOptions() {
    const options = [];
    // Add currently selected items
    if (this.filter.titlesCallback) {
      for (const result of this.existingDynamicOptions) {
        options.push(result);
      }
    } else if (Array.isArray(this.currentValue)) {
      for (const value of this.currentValue) {
        if (typeof value === 'string') {
          continue;
        }
        options.push(Object.assign({}, value));
      }
    }
    // Add search results
    for (const result of this.results) {
      options.push(result);
    }
    return options;
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    this.currentValue = this.value;
    this.updateExistingDynamicOptions();
    this.setDateRangeType();
    this.debouncedLoadResults = (0,external_lodash_namespaceObject.debounce)(this.loadResults, 300, {
      maxWait: 500
    });
  }
  updateExistingDynamicOptions() {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.existingDynamicOptions = [];
      if (!this.filter.titlesCallback) {
        return;
      }
      const values = [];
      if (Array.isArray(this.currentValue)) {
        for (const value of this.currentValue) {
          if (typeof value === 'object' && value.value) {
            values.push(value.value);
          }
        }
      } else if (typeof this.currentValue === 'object' && ((_a = this.currentValue) === null || _a === void 0 ? void 0 : _a.value)) {
        values.push(this.currentValue.value);
      }
      if (values.length === 0) {
        return;
      }
      const titles = yield this.filter.titlesCallback(values);
      for (const value in titles) {
        const title = titles[value];
        this.existingDynamicOptions.push({
          value,
          title
        });
      }
    });
  }
  onSearchChanged() {
    this.debouncedLoadResults();
  }
  /**
   * Handles updates to the current value
   */
  onCurrentValueUpdated() {
    // Trigger an event
    this.$emit('input', this.currentValue);
    // Clear the search term
    this.$nextTick(() => {
      this.search = '';
    });
  }
  /**
   * Loads dynamic results
   *
   * @returns
   */
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.filter.optionsCallback) {
        return;
      }
      try {
        this.loading = true;
        this.results = yield this.filter.optionsCallback(this.search);
      } finally {
        this.loading = false;
      }
    });
  }
  /**
   * Filter function that returns all items regardless of query.
   *
   * This is used when you may want API based results that search through non-title fields, e.g. barcode
   *
   * @returns
   */
  dynamicOptionsDisabledFilter() {
    return true;
  }
  /**
   * Sets the date range type
   *
   * @returns
   */
  setDateRangeType() {
    if (this.filter.type !== 'date-range' || !Array.isArray(this.currentValue)) {
      this.dateRangeType = '';
    } else {
      const dateRanges = date_helper_default().getStandardDateRanges();
      const currentValue = [...this.currentValue];
      const types = Object.keys(dateRanges);
      for (const type of types) {
        if ((0,external_lodash_namespaceObject.isEqual)(currentValue, dateRanges[type])) {
          this.dateRangeType = type;
          return;
        }
      }
      this.dateRangeType = 'custom';
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: null
})], FilterOptionsComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], FilterOptionsComponent.prototype, "filter", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('dateRangeType')], FilterOptionsComponent.prototype, "onDateRangeTypeChange", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], FilterOptionsComponent.prototype, "onValueChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('search')], FilterOptionsComponent.prototype, "onSearchChanged", null);
FilterOptionsComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], FilterOptionsComponent);
/* harmony default export */ var vp_filter_optionsvue_type_script_lang_ts_external = (FilterOptionsComponent);
;// CONCATENATED MODULE: ./src/components/vp-filter-options/vp-filter-options.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_filter_options_vp_filter_optionsvue_type_script_lang_ts_external = (vp_filter_optionsvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-filter-options/vp-filter-options.vue





/* normalize component */
;
var vp_filter_options_component = normalizeComponent(
  vp_filter_options_vp_filter_optionsvue_type_script_lang_ts_external,
  vp_filter_optionsvue_type_template_id_17c7a003_external_render,
  vp_filter_optionsvue_type_template_id_17c7a003_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_filter_options = (vp_filter_options_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-filter-list-item/vp-filter-list-item.ts?vue&type=script&lang=ts&external



let FilterListItemComponent = class FilterListItemComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], FilterListItemComponent.prototype, "filter", void 0);
FilterListItemComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-filter-options': vp_filter_options
  }
})], FilterListItemComponent);
/* harmony default export */ var vp_filter_list_itemvue_type_script_lang_ts_external = (FilterListItemComponent);
;// CONCATENATED MODULE: ./src/components/vp-filter-list-item/vp-filter-list-item.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_filter_list_item_vp_filter_list_itemvue_type_script_lang_ts_external = (vp_filter_list_itemvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-filter-list-item/vp-filter-list-item.vue





/* normalize component */
;
var vp_filter_list_item_component = normalizeComponent(
  vp_filter_list_item_vp_filter_list_itemvue_type_script_lang_ts_external,
  vp_filter_list_itemvue_type_template_id_e27d23ea_external_render,
  vp_filter_list_itemvue_type_template_id_e27d23ea_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_filter_list_item = (vp_filter_list_item_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-filters/vp-filters.ts?vue&type=script&lang=ts&external

var FiltersComponent_1;







let FiltersComponent = FiltersComponent_1 = class FiltersComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.activeFilters = {};
    this.dynamicFilterTitles = {};
    this.filtersVisible = false;
    this.filterOptionsVisible = false;
    this.filter = null;
    this.filterValue = null;
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    // Clone the filters
    this.activeFilters = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
    // Load dynamic option titles
    this.loadDynamicOptionTitles();
  }
  /**
   * Loads dynamic option titles
   */
  loadDynamicOptionTitles() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const titles = {};
      for (const key in this.activeFilters) {
        const filter = (0,external_lodash_namespaceObject.find)(this.filters, {
          key
        });
        if (!filter || !filter.optionsCallback || !filter.titlesCallback) {
          continue;
        }
        // Get the values to look up the titles for
        const filterValue = this.activeFilters[key];
        if (!filterValue) {
          continue;
        }
        const values = [];
        if (Array.isArray(filterValue)) {
          for (const value of filterValue) {
            if (typeof value === 'object') {
              values.push(value.value);
            } else {
              values.push(value);
            }
          }
        } else if (typeof filterValue === 'object') {
          values.push(filterValue.value);
        } else {
          values.push(filterValue);
        }
        // Load the titles for each value
        const filterTitlesKeyed = yield filter.titlesCallback(values);
        // Store the joined string against the filter key
        titles[key] = Object.values(filterTitlesKeyed).sort().join(', ');
      }
      // Update the titles
      this.dynamicFilterTitles = Object.assign({}, titles);
    });
  }
  /**
   * Returns the title for a current active filter
   *
   * @param key
   */
  getActiveFilterTitle(key) {
    // Find a matching filter
    const activeFilter = (0,external_lodash_namespaceObject.find)(this.filters, {
      key
    });
    if (!activeFilter) {
      return '?';
    }
    const title = activeFilter.title;
    return title;
  }
  /**
   * Returns the value for a current active filter
   *
   * @param key
   */
  getActiveFilterValue(key) {
    // Find a matching filter
    const activeFilter = (0,external_lodash_namespaceObject.find)(this.filters, {
      key
    });
    if (!activeFilter) {
      return '?';
    }
    let value = '';
    if (activeFilter.type === 'boolean') {
      value += this.getBooleanValueTitle(activeFilter);
    } else if (activeFilter.type === 'date-range') {
      value += this.getDateRangeValueTitle(activeFilter);
    } else if (activeFilter.options || activeFilter.optionsCallback) {
      value += this.getOptionsValueTitle(activeFilter);
    } else {
      value += this.activeFilters[key];
    }
    return value;
  }
  /**
   * Returns the title for a boolean value
   *
   * @param filter
   * @returns
   */
  getBooleanValueTitle(filter) {
    return this.activeFilters[filter.key] ? this.$t('general.action.yes').toString() : this.$t('general.action.no').toString();
  }
  /**
   * Returns the title for a date range value
   *
   * @param filter
   * @returns
   */
  getDateRangeValueTitle(filter) {
    let title = '';
    const filterValue = this.activeFilters[filter.key];
    if (Array.isArray(filterValue)) {
      title += this.getDateRangeTitle(filterValue);
    } else {
      title += '?';
    }
    return title;
  }
  /**
   * Returns the title for an options value
   *
   * @param filter
   * @returns
   */
  getOptionsValueTitle(filter) {
    let title = '';
    const filterValue = this.activeFilters[filter.key];
    // Use the pre-loaded dynamic filter titles if appropriate
    if (filter.optionsCallback && filter.titlesCallback) {
      return this.dynamicFilterTitles[filter.key];
    }
    // Concatenate titles if the value is an array
    else if (Array.isArray(filterValue)) {
      if (filter.multiple) {
        title += this.getMultipleValueTitle(filter, filterValue);
      } else {
        title += this.getSingleValueTitle(filter, filterValue[0]);
      }
    }
    // Get the single value title
    else {
      title += this.getSingleValueTitle(filter, filterValue);
    }
    return title;
  }
  /**
   * Returns a single value title for a filter option
   *
   * @param filter
   * @param value
   * @returns
   */
  getSingleValueTitle(filter, value) {
    if (value === null) {
      return '?';
    }
    let option;
    switch (typeof value) {
      case 'string':
      case 'number':
      case 'boolean':
        option = (0,external_lodash_namespaceObject.find)(filter.options, {
          value
        });
        break;
      default:
        return value.title;
    }
    return option ? option.title : '?';
  }
  /**
   * Returns a multiple value title for a filter option
   *
   * @param filter
   * @param values
   * @returns
   */
  getMultipleValueTitle(filter, values) {
    const titles = [];
    for (const value of values) {
      titles.push(this.getSingleValueTitle(filter, value));
    }
    titles.sort();
    return titles.join(', ');
  }
  /**
   * Adds a new active filter
   *
   * @param filter
   * @param value
   */
  addActiveFilter(filter, value) {
    const activeFilters = (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
    activeFilters[filter.key] = value;
    this.activeFilters = Object.assign({}, activeFilters);
    this.filtersVisible = false;
    this.$emit('input', this.activeFilters);
  }
  /**
   * Edits a filter
   *
   * @param key
   */
  editFilter(key) {
    var _a, _b;
    this.filter = (_a = (0,external_lodash_namespaceObject.find)(this.filters, {
      key
    })) !== null && _a !== void 0 ? _a : null;
    if (this.filter) {
      this.filterValue = (_b = this.activeFilters[key]) !== null && _b !== void 0 ? _b : null;
      this.filterOptionsVisible = true;
    }
  }
  /**
   * Deletes an active filter
   *
   * @param key
   */
  removeActiveFilter(key) {
    const activeFilters = (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
    activeFilters[key] = null;
    delete activeFilters[key];
    this.activeFilters = Object.assign({}, activeFilters);
    this.filtersVisible = false;
    this.$emit('input', this.activeFilters);
  }
  /**
   * Cancels adding a filter
   */
  cancelAddFilter() {
    this.filtersVisible = false;
  }
  /**
   * Cancels editing a filter
   */
  onCancelEditFilter() {
    this.filterOptionsVisible = false;
    this.filter = null;
    this.filterValue = null;
  }
  /**
   * Applies a filter
   *
   * @returns
   */
  onApplyFilter() {
    if (!this.filter) {
      return;
    }
    if (this.filterValue === '' || (0,external_lodash_namespaceObject.isNull)(this.filterValue)) {
      this.removeActiveFilter(this.filter.key);
    } else {
      this.addActiveFilter(this.filter, this.filterValue);
    }
    this.onCancelEditFilter();
  }
  /**
   * Returns the title for a date range value
   *
   * @param filterValue
   * @returns
   */
  getDateRangeTitle(filterValue) {
    for (const dateRange in FiltersComponent_1.dateRanges) {
      const dateRangeValue = FiltersComponent_1.dateRanges[dateRange];
      if ((0,external_lodash_namespaceObject.isEqual)(filterValue, dateRangeValue)) {
        const lastDaysMatch = dateRange.match(/last-([0-9]+)-days/);
        if (lastDaysMatch) {
          return this.$t('general.field.last_days', {
            days: lastDaysMatch[1]
          }).toString();
        } else {
          return this.$t(`general.field.${dateRange.replaceAll('-', '_')}`).toString();
        }
      }
    }
    return `${filterValue[0]} ~ ${filterValue[1]}`;
  }
};
FiltersComponent.dateRanges = date_helper_default().getStandardDateRanges();
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: {}
})], FiltersComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], FiltersComponent.prototype, "filters", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], FiltersComponent.prototype, "onValueChanged", null);
FiltersComponent = FiltersComponent_1 = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-dialog': vp_dialog,
    'vp-filter-list-item': vp_filter_list_item,
    'vp-filter-options': vp_filter_options
  }
})], FiltersComponent);
/* harmony default export */ var vp_filtersvue_type_script_lang_ts_external = (FiltersComponent);
;// CONCATENATED MODULE: ./src/components/vp-filters/vp-filters.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_filters_vp_filtersvue_type_script_lang_ts_external = (vp_filtersvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-filters/vp-filters.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_filtersvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(93);
;// CONCATENATED MODULE: ./src/components/vp-filters/vp-filters.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-filters/vp-filters.vue



;


/* normalize component */

var vp_filters_component = normalizeComponent(
  vp_filters_vp_filtersvue_type_script_lang_ts_external,
  vp_filtersvue_type_template_id_30e4b76e_external_render,
  vp_filtersvue_type_template_id_30e4b76e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_filters = (vp_filters_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VProgressCircular"
var VProgressCircular_namespaceObject = require("vuetify/lib/components/VProgressCircular");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-loader/vp-loader.html?vue&type=template&id=085b7857&external


var vp_loadervue_type_template_id_085b7857_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loader pa-3"
  }, [_vm.logo ? _c('img', {
    staticClass: "loader__logo",
    attrs: {
      "src": _vm.logo,
      "alt": _vm.logoAlt
    }
  }) : _vm._e(), _c('p', [_c(VProgressCircular_namespaceObject.VProgressCircular, {
    staticClass: "loader__circle",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _c('span', {
    staticClass: "loader__text ml-3"
  }, [_vm._v(_vm._s(_vm.text))])], 1)]);
};
var vp_loadervue_type_template_id_085b7857_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-loader/vp-loader.html?vue&type=template&id=085b7857&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-loader/vp-loader.ts?vue&type=script&lang=ts&external


let LoaderComponent = class LoaderComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], LoaderComponent.prototype, "logo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], LoaderComponent.prototype, "logoAlt", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'Please wait, loading...',
  type: String
})], LoaderComponent.prototype, "text", void 0);
LoaderComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], LoaderComponent);
/* harmony default export */ var vp_loadervue_type_script_lang_ts_external = (LoaderComponent);
;// CONCATENATED MODULE: ./src/components/vp-loader/vp-loader.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_loader_vp_loadervue_type_script_lang_ts_external = (vp_loadervue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-loader/vp-loader.vue





/* normalize component */
;
var vp_loader_component = normalizeComponent(
  vp_loader_vp_loadervue_type_script_lang_ts_external,
  vp_loadervue_type_template_id_085b7857_external_render,
  vp_loadervue_type_template_id_085b7857_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_loader = (vp_loader_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-notification-dialog/vp-notification-dialog.html?vue&type=template&id=361e7b5d&external








var vp_notification_dialogvue_type_template_id_361e7b5d_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "value": _vm.value,
      "content-class": "vp-dialog",
      "max-width": "552",
      "persistent": "",
      "scrollable": ""
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "notification-dialog vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, {
    staticClass: "notification-dialog__title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c(VCard_namespaceObject.VCardText, {
    staticClass: "notification-dialog__message"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _c(VCard_namespaceObject.VCardActions, {
    staticClass: "notification-dialog__actions"
  }, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "depressed": "",
      "text": _vm.text
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.action.ok')))])], 1)], 1)], 1);
};
var vp_notification_dialogvue_type_template_id_361e7b5d_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-notification-dialog/vp-notification-dialog.html?vue&type=template&id=361e7b5d&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-notification-dialog/vp-notification-dialog.ts?vue&type=script&lang=ts&external


let NotificationDialogComponent = class NotificationDialogComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean
})], NotificationDialogComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], NotificationDialogComponent.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], NotificationDialogComponent.prototype, "message", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], NotificationDialogComponent.prototype, "text", void 0);
NotificationDialogComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], NotificationDialogComponent);
/* harmony default export */ var vp_notification_dialogvue_type_script_lang_ts_external = (NotificationDialogComponent);
;// CONCATENATED MODULE: ./src/components/vp-notification-dialog/vp-notification-dialog.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_notification_dialog_vp_notification_dialogvue_type_script_lang_ts_external = (vp_notification_dialogvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-notification-dialog/vp-notification-dialog.vue





/* normalize component */
;
var vp_notification_dialog_component = normalizeComponent(
  vp_notification_dialog_vp_notification_dialogvue_type_script_lang_ts_external,
  vp_notification_dialogvue_type_template_id_361e7b5d_external_render,
  vp_notification_dialogvue_type_template_id_361e7b5d_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_notification_dialog = (vp_notification_dialog_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VForm"
var VForm_namespaceObject = require("vuetify/lib/components/VForm");
;// CONCATENATED MODULE: external "vuetify/lib/components/VTextarea"
var VTextarea_namespaceObject = require("vuetify/lib/components/VTextarea");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-saved-search-form/vp-saved-search-form.html?vue&type=template&id=637d5cd1&external











var vp_saved_search_formvue_type_template_id_637d5cd1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.search ? _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-savedSearchForm vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('report.action.save_search')) + " ")]), _c(VCard_namespaceObject.VCardText, [_c(VForm_namespaceObject.VForm, {
    staticClass: "vp-field-group",
    attrs: {
      "value": _vm.valid
    }
  }, [_c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.title'),
      "placeholder": _vm.$t('general.field.title'),
      "filled": "",
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.search.title,
      callback: function ($$v) {
        _vm.$set(_vm.search, "title", $$v);
      },
      expression: "search.title"
    }
  }), _c(VTextarea_namespaceObject.VTextarea, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.description'),
      "placeholder": _vm.$t('general.field.description'),
      "filled": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.search.description,
      callback: function ($$v) {
        _vm.$set(_vm.search, "description", $$v);
      },
      expression: "search.description"
    }
  })], 1)], 1), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-savedSearchForm__cancelBtn",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _vm.search.id ? [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "secondary",
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveAsNewClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save_as_new')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-savedSearchForm__saveBtn",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.onUpdateClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.update')) + " ")])] : _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-savedSearchForm__saveBtn",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveAsNewClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")])], 2)], 1) : _vm._e();
};
var vp_saved_search_formvue_type_template_id_637d5cd1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-saved-search-form/vp-saved-search-form.html?vue&type=template&id=637d5cd1&external

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-text-editor/vp-text-editor.html?vue&type=template&id=7f62dd24&external
var vp_text_editorvue_type_template_id_7f62dd24_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "text-editor vp-text-editor vp-form-control"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig,
      "disabled": _vm.readonly
    },
    on: {
      "ready": _vm.onEditorReady,
      "input": _vm.onEditorInput
    },
    model: {
      value: _vm.editorData,
      callback: function ($$v) {
        _vm.editorData = $$v;
      },
      expression: "editorData"
    }
  }), _c('div', {
    ref: "wordCount"
  })], 1);
};
var vp_text_editorvue_type_template_id_7f62dd24_external_staticRenderFns = [];

;// CONCATENATED MODULE: external "@ckeditor/ckeditor5-vue2"
var ckeditor5_vue2_namespaceObject = require("@ckeditor/ckeditor5-vue2");
var ckeditor5_vue2_default = /*#__PURE__*/__webpack_require__.n(ckeditor5_vue2_namespaceObject);
;// CONCATENATED MODULE: external "@vertical-plus/ckeditor5-build-classic"
var ckeditor5_build_classic_namespaceObject = require("@vertical-plus/ckeditor5-build-classic");
var ckeditor5_build_classic_default = /*#__PURE__*/__webpack_require__.n(ckeditor5_build_classic_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-text-editor/vp-text-editor.ts?vue&type=script&lang=ts&external
var TextEditorComponent_1;




let TextEditorComponent = TextEditorComponent_1 = class TextEditorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.ckeditor = null;
    this.words = 0;
    this.characters = 0;
  }
  /**
   * Returns the editor type for the instance
   */
  get editor() {
    return this.markdown ? (ckeditor5_build_classic_default()).ClassicMarkdownEditor : (ckeditor5_build_classic_default()).ClassicEditor;
  }
  /**
   * Gets the editor data
   */
  get editorData() {
    return this.parseValue();
  }
  /**
   * Sets the editor data
   */
  set editorData(value) {
    this.$emit('input', value);
  }
  /**
   * Returns the editor config
   */
  get editorConfig() {
    return {
      plugins: this.getPlugins(),
      toolbar: this.toolbar ? this.toolbar : this.getToolbar(),
      // Image:
      // {
      //     toolbar: []
      // },
      wordCount: {
        onUpdate: stats => {
          // Update the counts
          this.words = stats.words;
          this.characters = stats.characters;
        }
      },
      heading: {
        options: [{
          model: 'paragraph',
          title: 'Paragraph',
          class: 'body-1'
        }, {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'display-3'
        }, {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'display-2'
        }, {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'display-1'
        }]
      }
    };
  }
  /**
   * Handles editor initialisation
   *
   * @param editor
   */
  onEditorReady(editor) {
    // Add word / character count to the output
    if (this.wordCount) {
      const wordCountPlugin = editor.plugins.get('WordCount');
      this.$refs.wordCount.appendChild(wordCountPlugin.wordCountContainer);
    }
    this.$emit('initialised');
  }
  /**
   * Handles editor input
   *
   * @param value
   * @param event
   * @param editor
   */
  onEditorInput(value, event, editor) {
    // Limit the words if a word limit is set
    if (this.wordLimit > 0) {
      this.limitWords(editor);
    }
  }
  /**
   * Returns the active plugins.
   */
  getPlugins() {
    const plugins = this.markdown ? (ckeditor5_build_classic_default()).ClassicMarkdownEditor.builtinPlugins : (ckeditor5_build_classic_default()).ClassicEditor.builtinPlugins;
    return plugins;
  }
  /**
   * Returns the active toolbar items.
   */
  getToolbar() {
    if (this.toolbar) {
      return this.toolbar;
    } else if (this.markdown) {
      return (ckeditor5_build_classic_default()).ClassicMarkdownEditor.defaultConfig.toolbar.items;
    } else {
      return (ckeditor5_build_classic_default()).ClassicEditor.defaultConfig.toolbar.items;
    }
  }
  /**
   * Parses the value returning only non-stripped text.
   *
   * This is used because when replying to emails, the original email may contain content that breaks CKEditor 5's strict model.
   */
  parseValue() {
    if (!this.value) {
      return '';
    }
    const stripRegex = new RegExp(`\\s*${TextEditorComponent_1.CONTENT_STRIP_START}[\\s\\S]*${TextEditorComponent_1.CONTENT_STRIP_END}\\s*`, 'gi');
    const stripped = this.value.replace(stripRegex, '');
    return stripped;
  }
  /**
   * Limits the words in the editor.
   *
   * @param editor
   */
  limitWords(editor) {
    // Safety check
    if (!editor) {
      return;
    }
    // Get current text data.
    const text = editor.getData();
    if (!text) {
      return;
    }
    // Trim the text if over the word limit.
    const wordLimit = this.getWordLimit();
    if (this.words > wordLimit) {
      // Trim from the end of the text.
      let trimmed = text;
      while (this.words > wordLimit) {
        trimmed = trimmed.replace(/[\W]*\S+[\W]*$/, '');
        this.words = trimmed.match(/\S+/g).length;
      }
      // Add a space at the end to make sure more typing creates new words.
      editor.setData(`${trimmed} `);
      // Move cursor to the end of the text.
      window.setTimeout(() => {
        editor.model.change(writer => {
          writer.setSelection(editor.model.document.getRoot(), 'end');
        });
      }, 0);
      // Emit an event to indicate the word limit has been reached.
      this.$emit('word-limit-reached');
    }
  }
  /**
   * Returns the word limit taking into account the buffer.
   */
  getWordLimit() {
    return Math.round(this.wordLimit * (1 + this.wordLimitBufferPercentage / 100));
  }
};
TextEditorComponent.CONTENT_STRIP_START = '<!-- text-editor-strip-start -->';
TextEditorComponent.CONTENT_STRIP_END = '<!-- text-editor-strip-end -->';
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], TextEditorComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TextEditorComponent.prototype, "markdown", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array
})], TextEditorComponent.prototype, "toolbar", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TextEditorComponent.prototype, "wordCount", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 0,
  type: Number
})], TextEditorComponent.prototype, "wordLimit", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 0,
  type: Number
})], TextEditorComponent.prototype, "wordLimitBufferPercentage", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TextEditorComponent.prototype, "readonly", void 0);
TextEditorComponent = TextEditorComponent_1 = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    ckeditor: (ckeditor5_vue2_default()).component
  }
})], TextEditorComponent);
/* harmony default export */ var vp_text_editorvue_type_script_lang_ts_external = (TextEditorComponent);
;// CONCATENATED MODULE: ./src/components/vp-text-editor/vp-text-editor.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_text_editor_vp_text_editorvue_type_script_lang_ts_external = (vp_text_editorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-text-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_text_editor_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(540);
;// CONCATENATED MODULE: ./src/components/vp-text-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-text-editor/vp-text-editor.vue



;


/* normalize component */

var vp_text_editor_component = normalizeComponent(
  vp_text_editor_vp_text_editorvue_type_script_lang_ts_external,
  vp_text_editorvue_type_template_id_7f62dd24_external_render,
  vp_text_editorvue_type_template_id_7f62dd24_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_text_editor = (vp_text_editor_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-saved-search-form/vp-saved-search-form.ts?vue&type=script&lang=ts&external




let SavedSearchFormComponent = class SavedSearchFormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.search = null;
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    this.search = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
  }
  onUpdate() {
    if (this.search) {
      this.$emit('input', this.search);
    }
  }
  get valid() {
    var _a;
    if (!((_a = this.search) === null || _a === void 0 ? void 0 : _a.title)) {
      return false;
    }
    return true;
  }
  onCancel() {
    this.$emit('cancel');
  }
  /**
   * Handles updating an existing entry
   *
   * @returns
   */
  onUpdateClicked() {
    if (!this.search || !this.valid) {
      return;
    }
    this.$emit('save', this.search);
  }
  /**
   * Handles saving a new entry
   *
   * @returns
   */
  onSaveAsNewClicked() {
    if (!this.search || !this.valid) {
      return;
    }
    this.search.id = '';
    this.$emit('save', this.search);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SavedSearchFormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], SavedSearchFormComponent.prototype, "onValueChanged", null);
SavedSearchFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-text-editor': vp_text_editor
  }
})], SavedSearchFormComponent);
/* harmony default export */ var vp_saved_search_formvue_type_script_lang_ts_external = (SavedSearchFormComponent);
;// CONCATENATED MODULE: ./src/components/vp-saved-search-form/vp-saved-search-form.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_saved_search_form_vp_saved_search_formvue_type_script_lang_ts_external = (vp_saved_search_formvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-saved-search-form/vp-saved-search-form.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_saved_search_formvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(9);
;// CONCATENATED MODULE: ./src/components/vp-saved-search-form/vp-saved-search-form.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-saved-search-form/vp-saved-search-form.vue



;


/* normalize component */

var vp_saved_search_form_component = normalizeComponent(
  vp_saved_search_form_vp_saved_search_formvue_type_script_lang_ts_external,
  vp_saved_search_formvue_type_template_id_637d5cd1_external_render,
  vp_saved_search_formvue_type_template_id_637d5cd1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_saved_search_form = (vp_saved_search_form_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VTabs"
var VTabs_namespaceObject = require("vuetify/lib/components/VTabs");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-saved-searches/vp-saved-searches.html?vue&type=template&id=35e56542&external























var vp_saved_searchesvue_type_template_id_35e56542_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VGrid_namespaceObject.VContainer, {
    staticClass: "vp-saved-searches",
    attrs: {
      "fluid": ""
    }
  }, [_c(VGrid_namespaceObject.VRow, {
    staticClass: "vp-saved-searches__row flex-nowrap"
  }, [_c(VGrid_namespaceObject.VCol, {
    staticClass: "flex-grow-0 flex-shrink-1 pa-0"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-saved-searches__pinned",
    attrs: {
      "color": _vm.active == 'default' ? 'primary' : 'secondary',
      "depressed": ""
    },
    on: {
      "click": _vm.onCurrentSearchClicked
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    class: {
      'd-none': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_vm._v(" mdi-clipboard-search-outline ")]), _c('span', {
    staticClass: "d-none d-md-flex"
  }, [_vm._v(" " + _vm._s(_vm.$t('report.action.current_search')) + " ")])], 1)], 1), _c(VGrid_namespaceObject.VCol, {
    staticClass: "pa-0 flex-grow-1 flex-shrink-1",
    staticStyle: {
      "min-width": "0",
      "max-width": "100%"
    },
    attrs: {
      "cols": "4"
    }
  }, [_vm.$vuetify.breakpoint.mdAndUp ? _c(VTabs_namespaceObject.VTabs, {
    staticClass: "vp-saved-searches__tabs",
    attrs: {
      "show-arrows": "",
      "background-color": "transparent"
    }
  }, [_vm._l(_vm.pinnedReports, function (savedSearch) {
    return _c(VBtn_namespaceObject.VBtn, {
      key: savedSearch.id,
      staticClass: "vp-btn vp-saved-searches__pinned",
      attrs: {
        "color": _vm.active == savedSearch.id ? 'primary' : 'secondary',
        "depressed": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onSavedSearchClicked(savedSearch);
        }
      }
    }, [_vm._v(" " + _vm._s(savedSearch.title) + " "), _vm.active != savedSearch.id ? _c(VIcon_namespaceObject.VIcon, {
      attrs: {
        "right": "",
        "small": ""
      }
    }, [_vm._v(" mdi-pin ")]) : _c(VIcon_namespaceObject.VIcon, {
      staticClass: "vp-saved-searches__pinned__close",
      attrs: {
        "right": ""
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onPinClicked(savedSearch);
        }
      }
    }, [_vm._v(" mdi-close ")])], 1);
  }), _vm.showActiveTitle ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-saved-searches__pinned text-truncate",
    attrs: {
      "color": "primary",
      "depressed": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.activeTitle) + " ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "vp-saved-searches__tabs",
    attrs: {
      "background-color": "transparent",
      "hide-slider": ""
    }
  }, [(_vm.$vuetify.breakpoint.smAndDown, _vm.activeTitle != '') ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-saved-searches__pinned text-truncate",
    attrs: {
      "color": "primary",
      "depressed": "",
      "max-width": "160px"
    }
  }, [_c('span', {
    staticClass: "text-truncate",
    staticStyle: {
      "max-width": "125px"
    }
  }, [_vm._v(_vm._s(_vm.activeTitle))])]) : _vm._e()], 1)], 1), _c(VGrid_namespaceObject.VCol, {
    staticClass: "pa-0 flex-grow-0 flex-shrink-1"
  }, [_vm.limitedList.length > 0 ? _c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "offset-y": "",
      "content-class": "vp-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn vp-saved-searches__list",
          attrs: {
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, {
          class: {
            'ma-0': _vm.$vuetify.breakpoint.smAndDown
          },
          attrs: {
            "left": ""
          }
        }, [_vm._v(" mdi-star ")]), _c('span', {
          staticClass: "d-none d-md-flex"
        }, [_vm._v(" " + _vm._s(_vm.$t('report.action.saved_searches')) + " ")])], 1)];
      }
    }], null, false, 4197443413),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c(VList_namespaceObject.VList, {
    staticClass: "vp-saved-searches__list-items pb-0",
    attrs: {
      "max-width": "300"
    }
  }, [_c(VList_namespaceObject.VListItemGroup, {
    staticClass: "vp-saved-searches__list-items__group"
  }, [_vm._l(_vm.limitedList, function (savedSearch) {
    return _c(VList_namespaceObject.VListItem, {
      key: savedSearch.id,
      staticClass: "vp-saved-searches__list-items__item",
      class: {
        'vp-saved-searches__list-items__item--active': _vm.active == savedSearch.id
      },
      on: {
        "click": function ($event) {
          return _vm.onSavedSearchClicked(savedSearch);
        }
      }
    }, [_c(VList_namespaceObject.VListItemIcon, {
      staticClass: "mt-4 mr-3"
    }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-magnify")])], 1), _c(VList_namespaceObject.VListItemContent, {
      staticClass: "pa-0"
    }, [_c(VList_namespaceObject.VListItemTitle, [_vm._v(_vm._s(savedSearch.title))]), _c(VList_namespaceObject.VListItemSubtitle, [_vm._v(_vm._s(savedSearch.description))])], 1), _c(VList_namespaceObject.VListItemIcon, {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onPinClicked(savedSearch);
        }
      }
    }, [_c(VBtn_namespaceObject.VBtn, {
      attrs: {
        "icon": "",
        "depressed": "",
        "small": "",
        "fab": "",
        "plain": ""
      }
    }, [savedSearch.pinned ? _c(VIcon_namespaceObject.VIcon, {
      staticClass: "vp-btn vp-saved-searches__item__pinned",
      attrs: {
        "color": "secondary",
        "small": ""
      }
    }, [_vm._v(" mdi-pin ")]) : _c(VIcon_namespaceObject.VIcon, {
      staticClass: "vp-btn vp-saved-searches__item__pin",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-pin-outline ")])], 1)], 1)], 1);
  }), _c(VDivider_namespaceObject.VDivider, {
    staticClass: "mt-2"
  }), _c(VGrid_namespaceObject.VCol, {
    staticClass: "text-right"
  }, [_c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "content-class": "vp-saved-searches__viewAllDialog vp-dialog",
      "max-width": "912",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn vp-saved-searches__viewAll mr-4",
          attrs: {
            "plain": "",
            "ripple": false
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t('general.message.view_all')) + " ")])];
      }
    }], null, false, 4108925514),
    model: {
      value: _vm.viewAllDialog,
      callback: function ($$v) {
        _vm.viewAllDialog = $$v;
      },
      expression: "viewAllDialog"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('report.action.saved_searches')) + " ")]), _c(VCard_namespaceObject.VCardText, [_c(VDataTable_namespaceObject.VDataTable, {
    staticClass: "vp-data-table",
    attrs: {
      "headers": _vm.viewAllHeaders,
      "items": _vm.value,
      "mobile-breakpoint": 700
    },
    on: {
      "click:row": _vm.onSavedSearchClicked
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "vp-saved-searches__item vp-btn-group vp-btn-group--right"
        }, [_c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn vp-saved-searches__item__view",
          attrs: {
            "fab": "",
            "text": "",
            "small": ""
          }
        }, [_c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-magnify ")])], 1), _c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn vp-saved-searches__item__pin",
          attrs: {
            "fab": "",
            "text": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onPinClicked(item);
            }
          }
        }, [item.pinned ? _c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-pin ")]) : _c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-pin-outline ")])], 1), _c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn vp-saved-searches__item__delete",
          attrs: {
            "fab": "",
            "text": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onDeleteItemClick(item);
            }
          }
        }, [_c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-trash-can-outline")])], 1)], 1)];
      }
    }], null, false, 4079758698)
  })], 1), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn vp-saved-searches__list__close",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.viewAllDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.close')) + " ")])], 1)], 1)], 1), _c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "content-class": "vp-dialog",
      "persistent": "",
      "scrollable": "",
      "max-width": "552"
    },
    model: {
      value: _vm.confirmDeleteDialog,
      callback: function ($$v) {
        _vm.confirmDeleteDialog = $$v;
      },
      expression: "confirmDeleteDialog"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('report.action.confirm_deletion')) + " ")]), _c(VCard_namespaceObject.VCardText, [_vm._v(" " + _vm._s(_vm.$t('report.message.confirm_deletion')) + " "), _c('strong', [_vm._v(_vm._s(_vm.confirmDeleteItem.title))])]), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.confirmDeleteDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.onDeleteItemConfirmClick(_vm.confirmDeleteItem);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.delete')) + " ")])], 1)], 1)], 1)], 1)], 2)], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var vp_saved_searchesvue_type_template_id_35e56542_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-saved-searches/vp-saved-searches.html?vue&type=template&id=35e56542&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-saved-searches/vp-saved-searches.ts?vue&type=script&lang=ts&external


let SavedSearchesComponent = class SavedSearchesComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.active = 'default';
    this.activeTitle = '';
    this.showActiveTitle = false;
    this.menu = false;
    this.viewAllDialog = false;
    this.confirmDeleteDialog = false;
    this.editDialog = false;
    this.confirmDeleteItem = '';
  }
  /**
   * Checks to see if to limits the amount of save search results
   */
  get limitedList() {
    if (this.limitAmount) {
      return this.value.slice(0, this.limitAmount);
    }
    return this.value;
  }
  /**
   * Returns pinned reports
   */
  get pinnedReports() {
    return this.value.filter(report => report.pinned);
  }
  /**
   * Returns the headers for the view all dialog
   */
  get viewAllHeaders() {
    return [{
      value: 'title',
      text: this.$t('general.field.title'),
      align: 'left'
    }, {
      value: 'description',
      text: this.$t('general.field.description'),
      align: 'left'
    }, {
      value: 'actions',
      text: this.$t('general.field.actions'),
      align: 'right',
      sortable: false
    }];
  }
  /**
   * Handles current search clicks
   */
  onCurrentSearchClicked() {
    this.showActiveTitle = false;
    this.activeTitle = '';
    this.active = 'default';
    this.$emit('click:current');
  }
  /**
   * Handles report clicks
   *
   * @param report
   */
  onSavedSearchClicked(report) {
    this.activeTitle = report.title;
    this.active = report.id;
    this.viewAllDialog = false;
    this.menu = false;
    this.$emit('click:report', report);
    this.checkPinnedReports(report);
  }
  /**
   * Handles pin clicks
   *
   * @param report
   */
  onPinClicked(report) {
    this.$emit('click:pin', report);
    if (report.id === this.active) {
      this.checkPinnedReports(report);
    }
  }
  /**
   * Check to see if can display active report title
   */
  checkPinnedReports(report) {
    if (!this.pinnedReports.includes(report)) {
      this.showActiveTitle = true;
    } else if (this.pinnedReports.includes(report)) {
      this.showActiveTitle = false;
    }
  }
  /**
   * Handles the click of the delete item icon, pop us a confirm dialog
   */
  onDeleteItemClick(item) {
    this.confirmDeleteItem = item;
    this.confirmDeleteDialog = true;
  }
  /**
   * Handles the click of the delete item
   */
  onDeleteItemConfirmClick(item) {
    this.confirmDeleteDialog = false;
    this.$emit('click:delete', item);
    this.checkSavedSearchesAmount();
  }
  /**
   * Checks the lenght of the saved searches to see if to close the dialog and menu
   */
  checkSavedSearchesAmount() {
    if (this.value.length === 0) {
      this.viewAllDialog = false;
      this.menu = false;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SavedSearchesComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: 6
})], SavedSearchesComponent.prototype, "limitAmount", void 0);
SavedSearchesComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], SavedSearchesComponent);
/* harmony default export */ var vp_saved_searchesvue_type_script_lang_ts_external = (SavedSearchesComponent);
;// CONCATENATED MODULE: ./src/components/vp-saved-searches/vp-saved-searches.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_saved_searches_vp_saved_searchesvue_type_script_lang_ts_external = (vp_saved_searchesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-saved-searches/vp-saved-searches.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_saved_searchesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(27);
;// CONCATENATED MODULE: ./src/components/vp-saved-searches/vp-saved-searches.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-saved-searches/vp-saved-searches.vue



;


/* normalize component */

var vp_saved_searches_component = normalizeComponent(
  vp_saved_searches_vp_saved_searchesvue_type_script_lang_ts_external,
  vp_saved_searchesvue_type_template_id_35e56542_external_render,
  vp_saved_searchesvue_type_template_id_35e56542_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_saved_searches = (vp_saved_searches_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-widgets/vp-widgets.html?vue&type=template&id=ea795406&external



var vp_widgetsvue_type_template_id_ea795406_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "widgets"
  }, [_c('swiper', {
    staticClass: "elevation-1",
    attrs: {
      "slides-per-view": "auto"
    },
    on: {
      "swiper": _vm.onSwiper
    },
    scopedSlots: _vm._u([{
      key: "wrapper-start",
      fn: function () {
        return _vm._l(_vm.widgets, function (widget, index) {
          return _c('swiper-slide', {
            key: index
          }, [_c('vp-widget', {
            attrs: {
              "value": widget,
              "flat": ""
            }
          })], 1);
        });
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "widgets__button-previous"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "1"
    },
    on: {
      "click": _vm.onPreviousClicked
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-left")])], 1)], 1), _c('div', {
    staticClass: "widgets__button-next"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "1"
    },
    on: {
      "click": _vm.onNextClicked
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1);
};
var vp_widgetsvue_type_template_id_ea795406_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-widgets/vp-widgets.html?vue&type=template&id=ea795406&external

;// CONCATENATED MODULE: external "swiper/css"
var css_namespaceObject = require("swiper/css");
;// CONCATENATED MODULE: external "swiper/vue"
var vue_namespaceObject = require("swiper/vue");
;// CONCATENATED MODULE: external "vuetify/lib/components/VAvatar"
var VAvatar_namespaceObject = require("vuetify/lib/components/VAvatar");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-widget/vp-widget.html?vue&type=template&id=31f802aa&external







var vp_widgetvue_type_template_id_31f802aa_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-widget widget pa-6",
    attrs: {
      "elevation": _vm.flat ? 0 : 1,
      "to": _vm.value.to
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('div', [_vm.value.graphic === 'progress' ? _c(VProgressCircular_namespaceObject.VProgressCircular, {
    attrs: {
      "rotate": "-90",
      "value": _vm.value.value,
      "color": _vm.value.colour,
      "size": "62",
      "width": "10"
    }
  }) : _vm.value.graphic === 'icon' ? _c(VAvatar_namespaceObject.VAvatar, {
    attrs: {
      "color": _vm.value.colour,
      "size": "62"
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "color": "white",
      "size": "32"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.icon) + " ")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "ml-3"
  }, [_c(VCard_namespaceObject.VCardSubtitle, {
    staticClass: "vp-widget__subtitle py-0"
  }, [_vm._v(_vm._s(_vm.value.title))]), _c(VCard_namespaceObject.VCardTitle, {
    staticClass: "vp-widget__title py-0"
  }, [_vm._v(_vm._s(_vm.value.value))])], 1)])]);
};
var vp_widgetvue_type_template_id_31f802aa_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-widget/vp-widget.html?vue&type=template&id=31f802aa&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-widget/vp-widget.ts?vue&type=script&lang=ts&external


let WidgetComponent = class WidgetComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], WidgetComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], WidgetComponent.prototype, "flat", void 0);
WidgetComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], WidgetComponent);
/* harmony default export */ var vp_widgetvue_type_script_lang_ts_external = (WidgetComponent);
;// CONCATENATED MODULE: ./src/components/vp-widget/vp-widget.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_widget_vp_widgetvue_type_script_lang_ts_external = (vp_widgetvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-widget/vp-widget.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_widgetvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(703);
;// CONCATENATED MODULE: ./src/components/vp-widget/vp-widget.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-widget/vp-widget.vue



;


/* normalize component */

var vp_widget_component = normalizeComponent(
  vp_widget_vp_widgetvue_type_script_lang_ts_external,
  vp_widgetvue_type_template_id_31f802aa_external_render,
  vp_widgetvue_type_template_id_31f802aa_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_widget = (vp_widget_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-widgets/vp-widgets.ts?vue&type=script&lang=ts&external





let WidgetsComponent = class WidgetsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.swiper = null;
  }
  onSwiper(swiper) {
    this.swiper = swiper;
  }
  onPreviousClicked() {
    if (!this.swiper) {
      return;
    }
    this.swiper.slidePrev();
  }
  onNextClicked() {
    if (!this.swiper) {
      return;
    }
    this.swiper.slideNext();
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], WidgetsComponent.prototype, "widgets", void 0);
WidgetsComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    Swiper: vue_namespaceObject.Swiper,
    SwiperSlide: vue_namespaceObject.SwiperSlide,
    'vp-widget': vp_widget
  }
})], WidgetsComponent);
/* harmony default export */ var vp_widgetsvue_type_script_lang_ts_external = (WidgetsComponent);
;// CONCATENATED MODULE: ./src/components/vp-widgets/vp-widgets.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_widgets_vp_widgetsvue_type_script_lang_ts_external = (vp_widgetsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-widgets/vp-widgets.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_widgetsvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(845);
;// CONCATENATED MODULE: ./src/components/vp-widgets/vp-widgets.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-widgets/vp-widgets.vue



;


/* normalize component */

var vp_widgets_component = normalizeComponent(
  vp_widgets_vp_widgetsvue_type_script_lang_ts_external,
  vp_widgetsvue_type_template_id_ea795406_external_render,
  vp_widgetsvue_type_template_id_ea795406_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_widgets = (vp_widgets_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-data-table/vp-data-table.ts?vue&type=script&lang=ts&external















let DataTableComponent = class DataTableComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.searchTerm = '';
    this.activeFilters = {};
    this.activeSettings = {};
    this.activeColumns = [];
    this.page = 1;
    this.sortBy = '';
    this.columnSortDesc = null;
    this.conditions = {};
    this.savedSearches = [];
    this.saveDialog = false;
    this.savedSearch = null;
    this.loading = false;
    this.options = {
      sortBy: [],
      sortDesc: [],
      page: 1,
      itemsPerPage: 20,
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    };
    this.showHelp = false;
    this.initialising = true;
  }
  onRouteChanged() {
    this.updateConditionsFromQuery();
  }
  onReportChanged() {
    this.init();
  }
  onEnableSaveChanged() {
    this.loadSavedSearches();
  }
  onOptionsChanged(newOptions, oldOptions) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if ((0,external_lodash_namespaceObject.isEqual)(newOptions, oldOptions)) {
        return;
      }
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.options;
      this.conditions.itemsPerPage = itemsPerPage;
      this.page = page;
      this.conditions.page = page;
      this.conditions.order = [];
      if (sortBy.length > 0) {
        // Update the search conditions
        for (let i = 0; i < sortBy.length; i++) {
          this.conditions.order.push({
            key: sortBy[i],
            descending: sortDesc[i]
          });
        }
        // If this is a column sort then update the sort by as well as the desc value
        if (sortBy.length === 1) {
          const columnSortBy = this.findSortByColumnKey(sortBy[0]);
          if (columnSortBy) {
            this.setColumnSortBy(columnSortBy.key, sortDesc[0]);
          }
        }
      } else {
        const sortBy = this.getSortBy(this.report.defaultSortBy);
        if (sortBy) {
          if (this.isSortByColumnSort(sortBy.key)) {
            this.setColumnSortBy(sortBy.key, sortBy.order[0].descending);
          } else {
            this.setSortBy(sortBy.key);
          }
        }
      }
      // Load results
      this.debouncedLoadResults();
      // Update the query string from the conditions
      this.updateQueryFromConditions();
    });
  }
  /**
   * Watched objects don't return the actual old values due to being the same reference to the object.
   * A work around is to watch a computed value that clones the actual value you want to watch, so you get a new reference.
   *
   * See: https://stackoverflow.com/a/50538743
   *
   * @returns
   */
  get watchedOptions() {
    return (0,external_lodash_namespaceObject.cloneDeep)(this.options);
  }
  onSearchTermChanged() {
    // Clear the current results
    this.clearResults();
    if (this.searchTerm) {
      this.conditions.searchTerm = this.searchTerm;
      this.debouncedLoadResults();
    } else if (this.conditions.searchTerm) {
      const conditions = (0,external_lodash_namespaceObject.cloneDeep)(this.conditions);
      delete conditions.searchTerm;
      this.conditions = Object.assign({}, conditions);
      this.debouncedLoadResults();
    } else {
      this.debouncedLoadResults();
    }
    // Emit an event
    this.$emit('update:search-term', this.conditions.searchTerm);
  }
  onActiveFiltersChanged(newActiveFilters, oldActiveFilters) {
    // Update the conditions
    this.updateChangedConditions(newActiveFilters, oldActiveFilters);
    // Clear the current results
    this.clearResults();
    // Load results
    this.debouncedLoadResults();
    // Emit an event
    this.$emit('update:active-filters', newActiveFilters);
    // Update the query string from the conditions
    this.updateQueryFromConditions();
  }
  /**
   * Watched objects don't return the actual old values due to being the same reference to the object.
   * A work around is to watch a computed value that clones the actual value you want to watch, so you get a new reference.
   *
   * See: https://stackoverflow.com/a/50538743
   *
   * @returns
   */
  get watchedActiveFilters() {
    return (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
  }
  onActiveSettingsChanged(newActiveSettings, oldActiveSettings) {
    // Update the conditions
    this.updateChangedConditions(newActiveSettings, oldActiveSettings);
    // Clear the current results
    this.clearResults();
    // Load results
    this.debouncedLoadResults();
    // Emit an event
    this.$emit('update:active-settings', newActiveSettings);
    // Update the query string from the conditions
    this.updateQueryFromConditions();
  }
  /**
   * Watched objects don't return the actual old values due to being the same reference to the object.
   * A work around is to watch a computed value that clones the actual value you want to watch, so you get a new reference.
   *
   * See: https://stackoverflow.com/a/50538743
   *
   * @returns
   */
  get watchedActiveSettings() {
    return (0,external_lodash_namespaceObject.cloneDeep)(this.activeSettings);
  }
  onActiveColumnsChanged() {
    // Emit an event
    this.$emit('update:active-columns', this.activeColumns);
  }
  /**
   * Returns the visible headers
   */
  get headers() {
    const headers = [];
    for (const column of this.report.columns) {
      if (!this.activeColumns.includes(column.key)) {
        continue;
      }
      const sortBy = this.findSortByColumnKey(column.key);
      headers.push({
        text: column.title,
        value: column.key,
        align: column.align,
        class: column.class,
        cellClass: column.cellClass,
        width: column.width,
        sortable: !!sortBy
      });
    }
    return headers;
  }
  /**
   * Finds a matching sort by from the report using a single column key
   *
   * @param key
   * @returns
   */
  findSortByColumnKey(key) {
    const sortBy = (0,external_lodash_namespaceObject.find)(this.report.sortBys, sortBy => {
      // Column sorts can only work if there is a single sort field
      if (sortBy.order.length !== 1) {
        return false;
      }
      // Match if the single order column matches the given column key
      return sortBy.order[0].key === key;
    });
    return sortBy ? sortBy : null;
  }
  created() {
    this.debouncedLoadResults = (0,external_lodash_namespaceObject.debounce)(this.loadResults, 1000, {
      maxWait: 2000
    });
    this.init();
  }
  /**
   * Initialises the component
   */
  init() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Mark as initialising
      this.initialising = true;
      // Prepare the report
      if (this.report) {
        yield this.report.prepare();
      }
      // Reset the displayed report
      this.reset();
      // Update the conditions from any query string config
      this.updateConditionsFromQuery();
      // Load the results for the report
      this.debouncedLoadResults();
      // Load any saved searches
      this.loadSavedSearches();
      // Mark as initialised
      this.initialising = false;
      // Update the query string from any updated conditions
      this.updateQueryFromConditions();
    });
  }
  /**
   * Returns whether there is a matching active filter
   *
   * @param key
   * @returns
   */
  hasFilter(key) {
    var _a;
    return !!((_a = this.activeFilters) === null || _a === void 0 ? void 0 : _a[key]);
  }
  /**
   * Returns the value for a filter
   *
   * @param key
   * @returns
   */
  getFilter(key) {
    var _a;
    return (_a = this.activeFilters[key]) !== null && _a !== void 0 ? _a : null;
  }
  /**
   * Adds an active filter
   *
   * @param key
   * @param value
   */
  addFilter(key, value) {
    const existing = (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
    existing[key] = value;
    this.activeFilters = Object.assign({}, existing);
  }
  /**
   * Removes an active filter
   *
   * @param key
   * @returns
   */
  removeFilter(key) {
    if (!this.activeFilters[key]) {
      return;
    }
    const existing = (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
    delete existing[key];
    this.activeFilters = Object.assign({}, existing);
  }
  /**
   * Sets the active filters
   *
   * @param filters
   */
  setFilters(filters) {
    this.activeFilters = Object.assign({}, filters);
  }
  /**
   * Returns whether the settings should be shown
   *
   * @returns
   */
  get showSettings() {
    return this.report.settings.length > 0 || !this.disableSortBySelector || this.enableDownload || this.enableSave || !this.disableColumnSelector;
  }
  /**
   * Returns whether there is a matching active setting
   *
   * @param key
   * @returns
   */
  hasSetting(key) {
    var _a;
    return !!((_a = this.activeSettings) === null || _a === void 0 ? void 0 : _a[key]);
  }
  /**
   * Returns the value for a setting
   *
   * @param key
   * @returns
   */
  getSetting(key) {
    var _a;
    return (_a = this.activeSettings[key]) !== null && _a !== void 0 ? _a : null;
  }
  /**
   * Updates a setting
   *
   * @param key
   * @param value
   */
  setSetting(key, value) {
    const existing = (0,external_lodash_namespaceObject.cloneDeep)(this.activeSettings);
    existing[key] = value;
    this.activeSettings = Object.assign({}, existing);
  }
  /**
   * Sets the active settings
   *
   * @param settings
   */
  setSettings(settings) {
    this.activeSettings = Object.assign({}, settings);
  }
  /**
   * Adds an active column
   *
   * @param column
   * @returns
   */
  addColumn(column) {
    if (this.activeColumns.includes(column)) {
      return;
    }
    this.activeColumns.push(column);
  }
  /**
   * Removes an active column
   *
   * @param column
   * @returns
   */
  removeColumn(column) {
    if (!this.activeColumns.includes(column)) {
      return;
    }
    const index = this.activeColumns.indexOf(column);
    this.activeColumns.splice(index, 1);
  }
  /**
   * Sets the active columns
   *
   * @param columns
   */
  setColumns(columns) {
    this.activeColumns = columns;
  }
  /**
   * Sets the sort by
   *
   * @param key
   */
  setSortBy(key) {
    this.sortBy = key;
    this.columnSortDesc = null;
    this.updateVuetifyDatatableSort();
  }
  /**
   * Sets the column sort by
   *
   * Note: This is a sort by with a single field that matches a header.
   *       It allows sorting by clicking on the headers.
   *       A standard sort by can have multiple columns.
   *
   * @param column
   * @param descending
   */
  setColumnSortBy(key, descending = false) {
    this.sortBy = key;
    this.columnSortDesc = descending;
    this.updateVuetifyDatatableSort();
  }
  /**
   * Forces a reload of the results
   */
  reload() {
    this.loadResults();
  }
  /**
   * Clears the current results
   */
  clearResults() {
    const defaultResults = {
      results: [],
      totalResults: 0,
      totalPages: 0,
      page: 1,
      firstPage: null,
      lastPage: null,
      previousPage: null,
      nextPage: null
    };
    this.results = Object.assign({}, defaultResults);
  }
  /**
   * Resets the current report
   */
  reset() {
    var _a;
    // Reset conditions
    const setDefaults = !this.initialising || ((_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.m) !== '1';
    this.resetConditions(setDefaults);
    // Reset results
    this.clearResults();
    // Reset active columns
    this.activeColumns = this.report ? this.report.defaultColumns : [];
  }
  /**
   * Resets the conditions
   */
  resetConditions(setDefaults = true) {
    // Reset conditions
    const defaultSortBy = this.report ? this.getSortBy(this.report.defaultSortBy) : undefined;
    if (defaultSortBy) {
      if (this.isSortByColumnSort(defaultSortBy.key)) {
        this.setColumnSortBy(defaultSortBy.key, defaultSortBy.order[0].descending);
      } else {
        this.setSortBy(defaultSortBy.key);
      }
    } else {
      this.setSortBy('');
    }
    const defaultConditions = {
      itemsPerPage: this.report ? this.report.defaultItemsPerPage : 20,
      page: 1,
      order: defaultSortBy ? defaultSortBy.order : []
    };
    this.conditions = Object.assign({}, defaultConditions);
    // Reset search term
    this.searchTerm = '';
    // Reset filters
    if (setDefaults) {
      this.activeFilters = Object.assign({}, this.report ? this.report.defaultFilters : {});
    } else {
      this.activeFilters = Object.assign({});
    }
    // Reset settings
    if (setDefaults) {
      this.activeSettings = Object.assign({}, this.report ? this.report.defaultSettings : {});
    } else {
      this.activeSettings = Object.assign({});
    }
    // Add default settings to the conditions
    this.updateChangedConditions(this.activeSettings, {});
  }
  /**
   * Loads the results
   */
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.report) {
        return;
      }
      this.loading = true;
      const results = yield this.report.loadResults(this.conditions);
      this.results = Object.assign({}, results);
      // Update the query string from the conditions
      // Mainly as the search term only needs to update after a search has been performed.
      // We don't want it updating the querystring on each key press
      this.updateQueryFromConditions();
      this.loading = false;
    });
  }
  /**
   * Loads saved reports
   */
  loadSavedSearches() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.enableSave) {
        this.savedSearches = [];
        return;
      }
      const results = yield this.report.loadSavedSearches();
      this.savedSearches = results.results;
    });
  }
  /**
   * Handles the current search being clicked
   */
  onCurrentSearchClicked() {
    this.reset();
    this.savedSearch = null;
  }
  /**
   * Handles saved search clicks
   */
  onSavedSearchClicked(search) {
    var _a, _b, _c, _d, _e, _f;
    this.reset();
    this.savedSearch = Object.assign({}, search);
    if ((_a = this.savedSearch.config) === null || _a === void 0 ? void 0 : _a.searchTerm) {
      this.searchTerm = this.savedSearch.config.searchTerm;
    }
    if ((_b = this.savedSearch.config) === null || _b === void 0 ? void 0 : _b.filters) {
      this.setFilters(this.savedSearch.config.filters);
    }
    if ((_c = this.savedSearch.config) === null || _c === void 0 ? void 0 : _c.settings) {
      this.setSettings(this.savedSearch.config.settings);
    }
    if ((_d = this.savedSearch.config) === null || _d === void 0 ? void 0 : _d.columns) {
      this.setColumns(this.savedSearch.config.columns);
    }
    if ((_e = this.savedSearch.config) === null || _e === void 0 ? void 0 : _e.sortBy) {
      this.sortBy = this.savedSearch.config.sortBy;
    }
    if ((_f = this.savedSearch.config) === null || _f === void 0 ? void 0 : _f.columnSortDesc) {
      this.columnSortDesc = this.savedSearch.config.columnSortDesc;
    }
  }
  /**
   * Handles saved search pin clicks
   *
   * @param report
   */
  onSavedSearchPinClicked(search) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        // Immediate UX feedback
        search.pinned = !search.pinned;
        // Trigger the action
        if (search.pinned) {
          yield this.report.pinSavedSearch(search.id);
        } else {
          yield this.report.unpinSavedSearch(search.id);
        }
      } catch (error) {
        // Revert the change
        search.pinned = !search.pinned;
      }
    });
  }
  /**
   * Handles saved search delete requests
   *
   * @param search
   */
  onSavedSearchDeleteClicked(search) {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        yield this.report.deleteSavedSearch(search.id);
        // Remove from the view
        const index = (0,external_lodash_namespaceObject.findIndex)(this.savedSearches, {
          id: search.id
        });
        if (index >= 0) {
          this.savedSearches.splice(index, 1);
        }
        // Clear current saved search if it is this one
        if (((_a = this.savedSearch) === null || _a === void 0 ? void 0 : _a.id) === search.id) {
          this.savedSearch = null;
        }
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('report.error.failed_deleting'));
      }
    });
  }
  /**
   * Handles save button clicks
   */
  onSaveClicked() {
    var _a, _b, _c, _d;
    let savedSearch;
    if ((_a = this.savedSearch) === null || _a === void 0 ? void 0 : _a.id) {
      savedSearch = (0,external_lodash_namespaceObject.cloneDeep)(this.savedSearch);
    } else {
      savedSearch = {
        id: '',
        title: 'New search',
        description: null,
        config: {},
        pinned: false,
        dateCreated: (0,external_date_fns_namespaceObject.formatISO)(new Date()),
        dateUpdated: (0,external_date_fns_namespaceObject.formatISO)(new Date())
      };
    }
    if (this.searchTerm) {
      savedSearch.config.searchTerm = this.searchTerm;
    }
    for (const key in this.activeFilters) {
      const value = this.activeFilters[key];
      if (!((_b = savedSearch.config) === null || _b === void 0 ? void 0 : _b.filters)) {
        savedSearch.config.filters = {};
      }
      savedSearch.config.filters[key] = value;
    }
    for (const key in this.activeSettings) {
      const value = this.activeSettings[key];
      if (!((_c = savedSearch.config) === null || _c === void 0 ? void 0 : _c.settings)) {
        savedSearch.config.settings = {};
      }
      savedSearch.config.settings[key] = value;
    }
    for (const key of this.activeColumns) {
      if (!((_d = savedSearch.config) === null || _d === void 0 ? void 0 : _d.columns)) {
        savedSearch.config.columns = [];
      }
      savedSearch.config.columns.push(key);
    }
    if (this.sortBy) {
      savedSearch.config.sortBy = this.sortBy;
    }
    this.savedSearch = Object.assign({}, savedSearch);
  }
  /**
   * Saves the search
   */
  save(search) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!search) {
        return;
      }
      try {
        const savedSearch = yield this.report.saveSearch(search);
        this.saveDialog = false;
        // Update the current saved search
        this.savedSearch = Object.assign({}, savedSearch);
        // Update the array with the new saved search
        const index = (0,external_lodash_namespaceObject.findIndex)(this.savedSearches, {
          id: savedSearch.id
        });
        if (index >= 0) {
          this.savedSearches.splice(index, 1, savedSearch);
        } else {
          this.savedSearches.push(savedSearch);
        }
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('report.error.failed_saving'));
      }
    });
  }
  /**
   * Handles download button clicks
   *
   * @param format
   */
  onDownloadClicked(format) {
    this.report.downloadResults(this.conditions, format);
  }
  /**
   * Handles save active columns button clicks
   *
   * @param global
   */
  onSaveActiveColumns(global = false) {
    this.report.saveDefaultColumns(this.activeColumns, global);
  }
  /**
   * Handles back button clicks
   *
   * @returns
   */
  onBackClicked() {
    // If there is a back route, just allow the button to continue to that route
    if (this.backRoute) {
      return;
    }
    this.$emit('back');
  }
  /**
   * Handles row clicks
   *
   * @param item
   * @param associatedTableData
   */
  onRowClicked(item, associatedTableData) {
    this.$emit('click:row', item, associatedTableData);
  }
  /**
   * Updates the conditions from the query string
   */
  updateConditionsFromQuery() {
    var _a;
    // Only handle if the query string support hasn't been disabled
    if (this.disableQuerystring) {
      return;
    }
    // Generate filters, settings and sort by from the query string
    let filters;
    let settings;
    // Only set defaults if initialising the component and no modified flag in the query string
    if (this.initialising && ((_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.m) !== '1') {
      filters = (0,external_lodash_namespaceObject.cloneDeep)(this.report.defaultFilters);
      settings = (0,external_lodash_namespaceObject.cloneDeep)(this.report.defaultSettings);
    } else {
      filters = (0,external_lodash_namespaceObject.cloneDeep)(this.activeFilters);
      settings = (0,external_lodash_namespaceObject.cloneDeep)(this.activeSettings);
    }
    let searchTerm = '';
    let page = 1;
    let sortBy = this.report.defaultSortBy;
    let columnSortDesc = null;
    for (const param in this.$route.query) {
      const value = this.$route.query[param];
      if (param === 'search') {
        searchTerm = value;
        continue;
      }
      if (param === 'page') {
        page = parseInt(value);
      }
      if (param === 'order') {
        sortBy = value;
        continue;
      }
      if (param === 'desc') {
        columnSortDesc = value === '1';
      }
      const filter = (0,external_lodash_namespaceObject.find)(this.report.filters, {
        key: param
      });
      if (filter) {
        filters[param] = FilterService.getUpdatedFilterValueFromQuery(filter, value, filters[param]);
        continue;
      }
      const setting = (0,external_lodash_namespaceObject.find)(this.report.settings, {
        key: param
      });
      if (setting) {
        if (setting.type === 'date_range_comparison') {
          const dates = value.split(',');
          if (dates.length !== 4) {
            continue;
          }
          settings[param] = {
            range: [dates[0], dates[1]],
            comparedTo: [dates[2], dates[3]]
          };
        } else if (setting.type === 'boolean') {
          settings[param] = value === '1';
        } else {
          settings[param] = value;
        }
        continue;
      }
    }
    // Set the filters, settings and sort by
    if (!(0,external_lodash_namespaceObject.isEqual)(this.searchTerm, searchTerm)) {
      this.searchTerm = searchTerm;
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.activeFilters, filters)) {
      this.setFilters(filters);
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.activeSettings, settings)) {
      this.setSettings(settings);
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.page, page)) {
      this.page = page;
      this.updateVuetifyDatatablePage();
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.sortBy, sortBy)) {
      if (this.isSortByColumnSort(sortBy)) {
        if (columnSortDesc === null) {
          const columnSortBy = this.getSortBy(sortBy);
          columnSortDesc = columnSortBy ? columnSortBy === null || columnSortBy === void 0 ? void 0 : columnSortBy.order[0].descending : false;
        }
        this.setColumnSortBy(sortBy, columnSortDesc);
      } else {
        this.setSortBy(sortBy);
      }
    }
    if (this.columnSortDesc !== columnSortDesc) {
      if (columnSortDesc !== null && this.isSortByColumnSort(sortBy)) {
        this.setColumnSortBy(sortBy, columnSortDesc);
      } else {
        this.columnSortDesc = null;
      }
    }
  }
  /**
   * Updates the query string from the current conditions
   */
  updateQueryFromConditions() {
    // Only handle if the query string support hasn't been disabled
    if (this.disableQuerystring) {
      return;
    }
    // Don't update the query string until the component has finished being initialised.
    // The init() method calls this method once everything else is complete.
    if (this.initialising) {
      return;
    }
    const query = {};
    if (this.searchTerm) {
      query.search = this.searchTerm;
    }
    for (const param in this.activeFilters) {
      const filter = (0,external_lodash_namespaceObject.find)(this.report.filters, {
        key: param
      });
      if (!filter) {
        continue;
      }
      const value = this.activeFilters[param];
      const queryValue = FilterService.getQueryValueFomFilter(filter, value);
      if (queryValue !== null) {
        query[param] = queryValue;
      }
    }
    for (const param in this.activeSettings) {
      const value = this.activeSettings[param];
      if (!value && value !== false) {
        continue;
      }
      // If the value is the default value, don't add it to the query string
      const setting = (0,external_lodash_namespaceObject.find)(this.report.settings, {
        key: param
      });
      if (setting && (0,external_lodash_namespaceObject.isEqual)(value, setting.defaultValue)) {
        continue;
      }
      switch (typeof value) {
        case 'boolean':
          query[param] = value ? '1' : '0';
          break;
        case 'number':
        case 'string':
          query[param] = value;
          break;
        default:
          // eslint-disable-next-line no-case-declarations
          const dates = [];
          dates.push(...value.range);
          dates.push(...value.comparedTo);
          query[param] = dates.join(',');
      }
    }
    if (this.page && this.page !== 1) {
      query.page = `${this.page}`;
    }
    if (this.sortBy) {
      // Set the sort by id if not on the default sort by
      if (this.sortBy !== this.report.defaultSortBy) {
        query.order = this.sortBy;
      }
      // Set the desc property if not on the default for the sort by
      if (this.columnSortByDirectionModified) {
        query.desc = this.columnSortDesc ? '1' : '0';
      }
    }
    // If the conditions don't match the default conditions add a modified flag
    if (this.conditionsModified) {
      query.m = '1';
    }
    this.$router.replace({
      query
    }).catch(error => error);
  }
  /**
   * Returns whether the conditions have been modified from the default
   */
  get conditionsModified() {
    if (!this.report) {
      return false;
    }
    if (this.searchTerm) {
      return true;
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.activeFilters, this.report.defaultFilters)) {
      return true;
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.activeSettings, this.report.defaultSettings)) {
      return true;
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(this.sortBy, this.report.defaultSortBy)) {
      return true;
    }
    if (this.columnSortByDirectionModified) {
      return true;
    }
    return false;
  }
  /**
   * Returns whether the given sort by key is a column sort
   *
   * @param key
   * @returns
   */
  isSortByColumnSort(key) {
    // Load the sort by
    const sortBy = this.getSortBy(key);
    if (!sortBy || sortBy.order.length !== 1) {
      return false;
    }
    const sortByColumn = sortBy.order[0].key;
    // Check if the field matches an actual column in the report
    for (const column of this.report.columns) {
      if (column.key === sortByColumn) {
        return true;
      }
    }
    return false;
  }
  /**
   * Returns whether the column sort by direction has been modified
   */
  get columnSortByDirectionModified() {
    if (!this.sortBy || this.columnSortDesc === null) {
      return false;
    }
    const sortBy = this.getSortBy(this.sortBy);
    if (!sortBy) {
      return false;
    }
    if (sortBy.order.length === 1 && sortBy.order[0].descending !== this.columnSortDesc) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Updates conditions based on old and new changes
   *
   * @param newConditions
   * @param oldConditions
   */
  updateChangedConditions(newConditions, oldConditions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const conditions = (0,external_lodash_namespaceObject.cloneDeep)(this.conditions);
    // Delete old conditions
    for (const key in oldConditions) {
      delete conditions[key];
    }
    // Add new conditions
    for (const key in newConditions) {
      const value = newConditions[key];
      if (value === null || Array.isArray(value) && value.length === 0) {
        continue;
      }
      const filter = (0,external_lodash_namespaceObject.find)(this.report.filters, {
        key
      });
      if (filter) {
        if (filter.type === 'date-range' && Array.isArray(value) && typeof value[0] === 'string' && typeof value[1] === 'string') {
          conditions[`${key}[after]`] = value[0];
          const dayEnd = (0,external_date_fns_namespaceObject.parse)(value[1], 'yyyy-MM-dd', new Date());
          const dayAfter = (0,external_date_fns_namespaceObject.addDays)(dayEnd, 1);
          conditions[`${key}[strictly_before]`] = (0,external_date_fns_namespaceObject.format)(dayAfter, 'yyyy-MM-dd');
        } else if (Array.isArray(value)) {
          const values = [];
          for (const currentValue of value) {
            values.push(typeof currentValue === 'string' ? currentValue : currentValue.value);
          }
          conditions[key] = values;
        } else {
          switch (typeof value) {
            case 'string':
            case 'number':
            case 'boolean':
              conditions[key] = value;
              break;
            default:
              // eslint-disable-next-line max-depth
              if ('range' in value) {
                conditions[`${key}[range]`] = value.range.join(',');
                conditions[`${key}[comparedTo]`] = value.comparedTo.join(',');
              } else {
                conditions[key] = value.value;
              }
          }
        }
      } else {
        switch (typeof value) {
          case 'string':
          case 'number':
          case 'boolean':
            conditions[key] = value;
            break;
          default:
            // eslint-disable-next-line max-depth
            if ('range' in value) {
              conditions[`${key}[range]`] = value.range.join(',');
              conditions[`${key}[comparedTo]`] = value.comparedTo.join(',');
            } else {
              conditions[key] = value;
            }
        }
      }
    }
    // Update the conditions
    this.conditions = Object.assign({}, conditions);
  }
  /**
   * Returns a matching sort by for a key or undefined
   *
   * @param key
   * @returns
   */
  getSortBy(key) {
    return (0,external_lodash_namespaceObject.find)(this.report.sortBys, {
      key
    });
  }
  /**
   * Updates the vuetify datatable page
   */
  updateVuetifyDatatablePage() {
    // Update the vuetify datatable options
    const options = (0,external_lodash_namespaceObject.cloneDeep)(this.options);
    options.page = this.page;
    this.options = Object.assign({}, options);
    // Update the conditions
    this.conditions.page = this.page;
    // Load results
    this.debouncedLoadResults();
    // Update the query string from the conditions
    this.updateQueryFromConditions();
  }
  /**
   * Updates the vuetify datatable sort params
   */
  updateVuetifyDatatableSort() {
    // Load the sort by
    const sortBy = this.getSortBy(this.sortBy);
    // Update the vuetify datatable options
    const options = (0,external_lodash_namespaceObject.cloneDeep)(this.options);
    if (sortBy) {
      if (this.isSortByColumnSort(this.sortBy)) {
        options.sortBy = [sortBy.order[0].key];
        options.sortDesc = [this.columnSortDesc === true];
      } else {
        options.sortBy = [];
        options.sortDesc = [];
        for (const order of sortBy.order) {
          options.sortBy.push(order.key);
          options.sortDesc.push(order.descending);
        }
      }
    } else {
      options.sortBy = [];
      options.sortDesc = [];
    }
    this.options = Object.assign({}, options);
    // Update the conditions
    if (sortBy) {
      this.conditions.order = [];
      for (let i = 0; i < this.options.sortBy.length; i++) {
        this.conditions.order.push({
          key: this.options.sortBy[i],
          descending: this.options.sortDesc[i]
        });
      }
    } else {
      const defaultSortBy = this.getSortBy(this.report.defaultSortBy);
      this.conditions.order = defaultSortBy ? defaultSortBy.order : [];
    }
    // Load results
    this.debouncedLoadResults();
    // Emit an event
    this.$emit('update:sort-by', this.conditions.order);
    // Update the query string from the conditions
    this.updateQueryFromConditions();
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DataTableComponent.prototype, "headerClassName", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DataTableComponent.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: null
})], DataTableComponent.prototype, "h1", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DataTableComponent.prototype, "description", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DataTableComponent.prototype, "helpTitle", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DataTableComponent.prototype, "helpMessage", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], DataTableComponent.prototype, "report", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "back", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object,
  default: null
})], DataTableComponent.prototype, "backRoute", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "disableSearch", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "disableSortBySelector", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "disableColumnSelector", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "disablePagination", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "disableQuerystring", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "enableDownload", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => [{
    id: 'csv',
    title: 'CSV',
    icon: 'mdi-file-delimited'
  }]
})], DataTableComponent.prototype, "downloadFormats", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "enableSave", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "enableColumnSave", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DataTableComponent.prototype, "enableColumnSaveGlobal", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: undefined
})], DataTableComponent.prototype, "mobileBreakpoint", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: undefined
})], DataTableComponent.prototype, "tableHeight", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: undefined
})], DataTableComponent.prototype, "fixedHeader", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('$route')], DataTableComponent.prototype, "onRouteChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('report')], DataTableComponent.prototype, "onReportChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('enableSave')], DataTableComponent.prototype, "onEnableSaveChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('watchedOptions')], DataTableComponent.prototype, "onOptionsChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('searchTerm')], DataTableComponent.prototype, "onSearchTermChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('watchedActiveFilters')], DataTableComponent.prototype, "onActiveFiltersChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('watchedActiveSettings')], DataTableComponent.prototype, "onActiveSettingsChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('activeColumns')], DataTableComponent.prototype, "onActiveColumnsChanged", null);
DataTableComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-columns-selector': vp_columns_selector,
    'vp-data-table-settings': vp_data_table_settings,
    'vp-filters': vp_filters,
    'vp-loader': vp_loader,
    'vp-notification-dialog': vp_notification_dialog,
    'vp-saved-search-form': vp_saved_search_form,
    'vp-saved-searches': vp_saved_searches,
    'vp-widgets': vp_widgets
  }
})], DataTableComponent);
/* harmony default export */ var vp_data_tablevue_type_script_lang_ts_external = (DataTableComponent);
;// CONCATENATED MODULE: ./src/components/vp-data-table/vp-data-table.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_data_table_vp_data_tablevue_type_script_lang_ts_external = (vp_data_tablevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-data-table/vp-data-table.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_data_tablevue_type_style_index_0_prod_lang_scss_external = __webpack_require__(619);
;// CONCATENATED MODULE: ./src/components/vp-data-table/vp-data-table.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-data-table/vp-data-table.vue



;


/* normalize component */

var vp_data_table_component = normalizeComponent(
  vp_data_table_vp_data_tablevue_type_script_lang_ts_external,
  vp_data_tablevue_type_template_id_7d89ef5e_external_render,
  vp_data_tablevue_type_template_id_7d89ef5e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_data_table = (vp_data_table_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-date/vp-date.html?vue&type=template&id=ac634ea6&external
var vp_datevue_type_template_id_ac634ea6_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "date",
    attrs: {
      "title": _vm.fullValue
    }
  }, [_vm._v(_vm._s(_vm.value))]);
};
var vp_datevue_type_template_id_ac634ea6_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-date/vp-date.ts?vue&type=script&lang=ts&external



let DateComponent = class DateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  get value() {
    if (!this.isValidDate) {
      return '-';
    }
    let dateFormat;
    if (this.format) {
      dateFormat = this.format;
    } else if (this.timeOnly) {
      dateFormat = 'HH:mm';
      if (this.seconds) {
        dateFormat += 'ss';
      }
    } else if (this.distance) {
      if (this.distanceDayOnly) {
        return (0,external_date_fns_namespaceObject.isToday)(this.date) ? (0,external_date_fns_namespaceObject.formatDistanceStrict)(this.date, new Date()) : (0,external_date_fns_namespaceObject.format)(this.date, 'd MMM');
      } else {
        return (0,external_date_fns_namespaceObject.formatDistanceStrict)(this.date, new Date());
      }
    } else if (this.written) {
      if (this.short) {
        dateFormat = 'd MMM';
      } else {
        dateFormat = 'd MMMM';
      }
    } else if (this.isDay) {
      dateFormat = 'dd/MM/yyyy';
    } else {
      dateFormat = 'dd/MM/yyyy HH:mm';
      if (this.seconds) {
        dateFormat += 'ss';
      }
    }
    return (0,external_date_fns_namespaceObject.format)(this.date, dateFormat);
  }
  get fullValue() {
    if (!this.isValidDate) {
      return undefined;
    }
    return (0,external_date_fns_namespaceObject.format)(this.date, 'EEEE, do MMMM yyyy, HH:mm');
  }
  get isValidDate() {
    if (!this.date || !(this.date instanceof Date) || isNaN(this.date.getTime())) {
      return false;
    } else {
      return true;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Date
})], DateComponent.prototype, "date", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DateComponent.prototype, "format", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "isDay", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "timeOnly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "seconds", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "written", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "short", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "distance", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateComponent.prototype, "distanceDayOnly", void 0);
DateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], DateComponent);
/* harmony default export */ var vp_datevue_type_script_lang_ts_external = (DateComponent);
;// CONCATENATED MODULE: ./src/components/vp-date/vp-date.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_date_vp_datevue_type_script_lang_ts_external = (vp_datevue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-date/vp-date.vue





/* normalize component */
;
var vp_date_component = normalizeComponent(
  vp_date_vp_datevue_type_script_lang_ts_external,
  vp_datevue_type_template_id_ac634ea6_external_render,
  vp_datevue_type_template_id_ac634ea6_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_date = (vp_date_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-date-picker/vp-date-picker.html?vue&type=template&id=e1790dfa&external




var vp_date_pickervue_type_template_id_e1790dfa_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.readonly && !_vm.disabled ? _c(VMenu_namespaceObject.VMenu, {
    staticClass: "vp-menu",
    attrs: {
      "close-on-content-click": false,
      "light": _vm.light,
      "dark": _vm.dark,
      "left": "",
      "bottom": "",
      "origin": "top right",
      "offset-overflow": "",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g({
          staticClass: "vp-form-control",
          attrs: {
            "slot": "activator",
            "label": _vm.label,
            "value": _vm.formattedDate,
            "hide-details": _vm.hideDetails,
            "clearable": _vm.clearable,
            "filled": _vm.filled,
            "outlined": _vm.outlined,
            "solo": _vm.solo,
            "error": _vm.error,
            "error-messages": _vm.errorMessages
          },
          on: {
            "click:clear": _vm.onDateCleared,
            "dblclick": event => _vm.$emit('dblclick', event),
            "change": _vm.onDateEntered
          },
          slot: "activator"
        }, on))];
      }
    }], null, false, 2819302211),
    model: {
      value: _vm.isVisible,
      callback: function ($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "value": _vm.isoformattedDate
    },
    on: {
      "change": _vm.onDateSelected
    }
  })], 1) : _c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.label,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "value": _vm.formattedDate,
      "hide-details": _vm.hideDetails,
      "filled": _vm.filled,
      "solo": _vm.solo,
      "error": _vm.error,
      "error-messages": _vm.errorMessages
    }
  });
};
var vp_date_pickervue_type_template_id_e1790dfa_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-date-picker/vp-date-picker.html?vue&type=template&id=e1790dfa&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-date-picker/vp-date-picker.ts?vue&type=script&lang=ts&external



let DatePickerComponent = class DatePickerComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.date = null;
    this.isVisible = false;
  }
  created() {
    this.onValueUpdated();
  }
  onValueUpdated() {
    const date = typeof this.value === 'string' ? (0,external_date_fns_namespaceObject.parseISO)(this.value) : this.value;
    if (!(0,external_date_fns_namespaceObject.isValid)(date)) {
      return;
    }
    this.date = date;
  }
  /**
   * Returns the date formatted as a string
   */
  get formattedDate() {
    return this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd') : '';
  }
  /**
   * Sets the formatted date
   */
  set formattedDate(value) {
    this.date = (0,external_date_fns_namespaceObject.parseISO)(value);
    this.emitUpdatedValue();
  }
  /**
   * Returns the date as a string in iso format
   */
  get isoformattedDate() {
    return this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd') : '';
  }
  /**
   * Handles dates being entered manually
   *
   * @param value
   */
  onDateEntered(value) {
    const date = (0,external_date_fns_namespaceObject.parseISO)(value);
    if (!(0,external_date_fns_namespaceObject.isValid)(date)) {
      return;
    }
    this.date = date;
    this.emitUpdatedValue();
  }
  /**
   * Handles date selection.
   *
   * @param value
   */
  onDateSelected(value) {
    this.isVisible = false;
    this.date = (0,external_date_fns_namespaceObject.parseISO)(value);
    this.emitUpdatedValue();
  }
  /**
   * Handles date clearing.
   */
  onDateCleared() {
    this.isVisible = false;
    this.date = null;
    this.emitUpdatedValue();
  }
  /**
   * Emits the updated value
   */
  emitUpdatedValue() {
    if (typeof this.value === 'string') {
      this.$emit('input', this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd') : null);
    } else {
      this.$emit('input', this.date);
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: [Date, String]
})], DatePickerComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], DatePickerComponent.prototype, "label", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "hideDetails", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "clearable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "filled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "outlined", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "solo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "disabled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DatePickerComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DatePickerComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], DatePickerComponent.prototype, "errorMessages", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DatePickerComponent.prototype, "onValueUpdated", null);
DatePickerComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], DatePickerComponent);
/* harmony default export */ var vp_date_pickervue_type_script_lang_ts_external = (DatePickerComponent);
;// CONCATENATED MODULE: ./src/components/vp-date-picker/vp-date-picker.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_date_picker_vp_date_pickervue_type_script_lang_ts_external = (vp_date_pickervue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-date-picker/vp-date-picker.vue





/* normalize component */
;
var vp_date_picker_component = normalizeComponent(
  vp_date_picker_vp_date_pickervue_type_script_lang_ts_external,
  vp_date_pickervue_type_template_id_e1790dfa_external_render,
  vp_date_pickervue_type_template_id_e1790dfa_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_date_picker = (vp_date_picker_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-date-range/vp-date-range.html?vue&type=template&id=5981238d&external
var vp_date_rangevue_type_template_id_5981238d_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "date-range"
  }, [_vm.isSameDay && !_vm.endIsDay ? _c('span', [_c('vp-date', {
    attrs: {
      "date": _vm.start,
      "format": _vm.format,
      "is-day": true
    }
  }), _c('vp-date', {
    attrs: {
      "date": _vm.start,
      "format": _vm.format,
      "time-only": true
    }
  }), _vm._v(" - "), _c('vp-date', {
    attrs: {
      "date": _vm.end,
      "format": _vm.format,
      "time-only": true
    }
  })], 1) : _vm.isSameDay && _vm.endIsDay ? _c('span', [_c('vp-date', {
    attrs: {
      "date": _vm.start,
      "format": _vm.format,
      "is-day": _vm.startIsDay
    }
  })], 1) : _c('span', [_c('vp-date', {
    attrs: {
      "date": _vm.start,
      "format": _vm.format,
      "is-day": _vm.startIsDay
    }
  }), _vm._v(" - "), _c('vp-date', {
    attrs: {
      "date": _vm.end,
      "format": _vm.format,
      "is-day": _vm.endIsDay
    }
  })], 1)]);
};
var vp_date_rangevue_type_template_id_5981238d_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-date-range/vp-date-range.ts?vue&type=script&lang=ts&external




let DateRangeComponent = class DateRangeComponent extends external_vue_property_decorator_namespaceObject.Vue {
  get isSameDay() {
    if (this.endIsDay) {
      return (0,external_date_fns_namespaceObject.isSameDay)(this.start, this.dayBefore(this.end));
    } else {
      return (0,external_date_fns_namespaceObject.isSameDay)(this.start, this.end);
    }
  }
  dayBefore(date) {
    return (0,external_date_fns_namespaceObject.subDays)(date, 1);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Date
})], DateRangeComponent.prototype, "start", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateRangeComponent.prototype, "startIsDay", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Date
})], DateRangeComponent.prototype, "end", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateRangeComponent.prototype, "endIsDay", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], DateRangeComponent.prototype, "format", void 0);
DateRangeComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-date': vp_date
  }
})], DateRangeComponent);
/* harmony default export */ var vp_date_rangevue_type_script_lang_ts_external = (DateRangeComponent);
;// CONCATENATED MODULE: ./src/components/vp-date-range/vp-date-range.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_date_range_vp_date_rangevue_type_script_lang_ts_external = (vp_date_rangevue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-date-range/vp-date-range.vue





/* normalize component */
;
var vp_date_range_component = normalizeComponent(
  vp_date_range_vp_date_rangevue_type_script_lang_ts_external,
  vp_date_rangevue_type_template_id_5981238d_external_render,
  vp_date_rangevue_type_template_id_5981238d_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_date_range = (vp_date_range_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VTimePicker"
var VTimePicker_namespaceObject = require("vuetify/lib/components/VTimePicker");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-date-time-picker/vp-date-time-picker.html?vue&type=template&id=223927e2&external










var vp_date_time_pickervue_type_template_id_223927e2_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.readonly && !_vm.disabled ? _c(VMenu_namespaceObject.VMenu, {
    staticClass: "vp-menu",
    attrs: {
      "close-on-content-click": false,
      "light": _vm.light,
      "dark": _vm.dark,
      "left": "",
      "bottom": "",
      "origin": "top right",
      "offset-overflow": "",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VTextField_namespaceObject.VTextField, _vm._g({
          staticClass: "vp-form-control",
          attrs: {
            "slot": "activator",
            "label": _vm.label,
            "value": _vm.formattedDate,
            "hide-details": _vm.hideDetails,
            "clearable": _vm.clearable,
            "filled": _vm.filled,
            "outlined": _vm.outlined,
            "solo": _vm.solo,
            "error": _vm.error,
            "error-messages": _vm.errorMessages
          },
          on: {
            "click:clear": _vm.onDateCleared,
            "dblclick": event => _vm.$emit('dblclick', event),
            "change": _vm.onDateEntered
          },
          slot: "activator"
        }, on))];
      }
    }], null, false, 2819302211),
    model: {
      value: _vm.isVisible,
      callback: function ($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_vm.isVisible ? _c(VTabs_namespaceObject.VTabs, {
    attrs: {
      "grow": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabs_namespaceObject.VTab, {
    attrs: {
      "href": "#date"
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-calendar")])], 1), _c(VTabs_namespaceObject.VTab, {
    attrs: {
      "href": "#time"
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-clock-outline")])], 1), _c(VTabs_namespaceObject.VTabsItems, {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabs_namespaceObject.VTabItem, {
    attrs: {
      "value": "date",
      "transition": false,
      "reverse-transition": false
    }
  }, [_c(VDatePicker_namespaceObject.VDatePicker, {
    attrs: {
      "value": _vm.isoformattedDate
    },
    on: {
      "change": _vm.onDateSelected
    }
  })], 1), _c(VTabs_namespaceObject.VTabItem, {
    attrs: {
      "value": "time",
      "transition": false,
      "reverse-transition": false
    }
  }, [_c(VTimePicker_namespaceObject.VTimePicker, {
    attrs: {
      "value": _vm.isoformattedTime,
      "format": "24hr"
    },
    on: {
      "input": _vm.onTimeUpdated,
      "change": _vm.onTimeSelected
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.label,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "value": _vm.formattedDate,
      "hide-details": _vm.hideDetails,
      "filled": _vm.filled,
      "solo": _vm.solo,
      "error": _vm.error,
      "error-messages": _vm.errorMessages
    }
  });
};
var vp_date_time_pickervue_type_template_id_223927e2_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-date-time-picker/vp-date-time-picker.html?vue&type=template&id=223927e2&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-date-time-picker/vp-date-time-picker.ts?vue&type=script&lang=ts&external



let DateTimePickerComponent = class DateTimePickerComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.date = null;
    this.isVisible = false;
    this.tab = 'date';
  }
  created() {
    this.onValueUpdated();
    this.tab = this.defaultTab;
  }
  onValueUpdated() {
    const date = typeof this.value === 'string' ? (0,external_date_fns_namespaceObject.parseISO)(this.value) : this.value;
    if (!(0,external_date_fns_namespaceObject.isValid)(date)) {
      return;
    }
    this.date = date;
  }
  /**
   * Returns the date formatted as a string
   */
  get formattedDate() {
    return this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd HH:mm') : '';
  }
  /**
   * Sets the formatted date
   */
  set formattedDate(value) {
    this.date = (0,external_date_fns_namespaceObject.parseISO)(value);
    this.emitUpdatedValue();
  }
  /**
   * Returns the date as a string in iso format
   */
  get isoformattedDate() {
    return this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd HH:mm') : '';
  }
  /**
   * Returns the date as a string in iso format
   */
  get isoformattedTime() {
    return this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'HH:mm:ss') : '';
  }
  /**
   * Handles dates being entered manually
   *
   * @param value
   */
  onDateEntered(value) {
    const date = (0,external_date_fns_namespaceObject.parseISO)(value);
    if (!(0,external_date_fns_namespaceObject.isValid)(date)) {
      return;
    }
    this.date = date;
    this.emitUpdatedValue();
  }
  /**
   * Handles date selection
   *
   * @param value
   */
  onDateSelected(value) {
    this.tab = 'time';
    if (!this.date) {
      this.date = new Date();
    }
    const selectedDate = (0,external_date_fns_namespaceObject.parseISO)(value);
    const selectedDayOfYear = (0,external_date_fns_namespaceObject.getDayOfYear)(selectedDate);
    this.date = (0,external_date_fns_namespaceObject.setDayOfYear)(this.date, selectedDayOfYear);
    this.emitUpdatedValue();
  }
  /**
   * Handles time updates
   *
   * @param value
   */
  onTimeUpdated(value) {
    if (!this.date) {
      this.date = new Date();
    }
    const selectedDate = (0,external_date_fns_namespaceObject.parseISO)(`${(0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd')} ${value}`);
    const selectedHours = (0,external_date_fns_namespaceObject.getHours)(selectedDate);
    const selectedMinutes = (0,external_date_fns_namespaceObject.getMinutes)(selectedDate);
    const selectedSeconds = (0,external_date_fns_namespaceObject.getSeconds)(selectedDate);
    this.date = (0,external_date_fns_namespaceObject.setHours)(this.date, selectedHours);
    this.date = (0,external_date_fns_namespaceObject.setMinutes)(this.date, selectedMinutes);
    this.date = (0,external_date_fns_namespaceObject.setSeconds)(this.date, selectedSeconds);
    this.emitUpdatedValue();
  }
  /**
   * Handles time selection
   *
   * @param value
   */
  onTimeSelected(value) {
    this.onTimeUpdated(value);
    this.isVisible = false;
    this.tab = 'date';
  }
  /**
   * Handles date clearing.
   */
  onDateCleared() {
    this.isVisible = false;
    this.date = null;
    this.emitUpdatedValue();
  }
  /**
   * Emits the updated value
   */
  emitUpdatedValue() {
    if (typeof this.value === 'string') {
      this.$emit('input', this.date ? (0,external_date_fns_namespaceObject.format)(this.date, 'yyyy-MM-dd HH:mm:ss') : null);
    } else {
      this.$emit('input', this.date);
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: [Date, String]
})], DateTimePickerComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], DateTimePickerComponent.prototype, "label", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "hideDetails", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "clearable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "filled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "outlined", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "solo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "disabled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], DateTimePickerComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'date'
})], DateTimePickerComponent.prototype, "defaultTab", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], DateTimePickerComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], DateTimePickerComponent.prototype, "errorMessages", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], DateTimePickerComponent.prototype, "onValueUpdated", null);
DateTimePickerComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], DateTimePickerComponent);
/* harmony default export */ var vp_date_time_pickervue_type_script_lang_ts_external = (DateTimePickerComponent);
;// CONCATENATED MODULE: ./src/components/vp-date-time-picker/vp-date-time-picker.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_date_time_picker_vp_date_time_pickervue_type_script_lang_ts_external = (vp_date_time_pickervue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-date-time-picker/vp-date-time-picker.vue





/* normalize component */
;
var vp_date_time_picker_component = normalizeComponent(
  vp_date_time_picker_vp_date_time_pickervue_type_script_lang_ts_external,
  vp_date_time_pickervue_type_template_id_223927e2_external_render,
  vp_date_time_pickervue_type_template_id_223927e2_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_date_time_picker = (vp_date_time_picker_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-file-selector/vp-file-selector.html?vue&type=template&id=6cf3abe9&external


var vp_file_selectorvue_type_template_id_6cf3abe9_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "file-selector"
  }, [_vm.icon ? _c(VIcon_namespaceObject.VIcon, {
    staticClass: "file-selector__icon"
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm.text ? _c('span', {
    staticClass: "file-selector__text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _c('input', {
    ref: "input",
    staticClass: "file-selector__input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileSelected
    }
  })], 1);
};
var vp_file_selectorvue_type_template_id_6cf3abe9_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-file-selector/vp-file-selector.html?vue&type=template&id=6cf3abe9&external

;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/content/file-helper"
var file_helper_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/content/file-helper");
var file_helper_default = /*#__PURE__*/__webpack_require__.n(file_helper_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-file-selector/vp-file-selector.ts?vue&type=script&lang=ts&external



let FileSelectorComponent = class FileSelectorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  onFileSelected() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Get the file that has been selected.
      if (!this.$refs.input.files) {
        return;
      }
      const file = this.$refs.input.files[0];
      if (!file) {
        return;
      }
      // Convert to a Uint8Array.
      const data = yield file_helper_default().fileToUint8Array(file);
      // Emit a file-selected event with the file's details.
      this.$emit('file-selected', file.name, file.type, data);
      // Clear the value of the input for the next selection.
      this.$refs.input.value = '';
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], FileSelectorComponent.prototype, "icon", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], FileSelectorComponent.prototype, "text", void 0);
FileSelectorComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], FileSelectorComponent);
/* harmony default export */ var vp_file_selectorvue_type_script_lang_ts_external = (FileSelectorComponent);
;// CONCATENATED MODULE: ./src/components/vp-file-selector/vp-file-selector.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_file_selector_vp_file_selectorvue_type_script_lang_ts_external = (vp_file_selectorvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-file-selector/vp-file-selector.vue





/* normalize component */
;
var vp_file_selector_component = normalizeComponent(
  vp_file_selector_vp_file_selectorvue_type_script_lang_ts_external,
  vp_file_selectorvue_type_template_id_6cf3abe9_external_render,
  vp_file_selectorvue_type_template_id_6cf3abe9_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_file_selector = (vp_file_selector_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VStepper"
var VStepper_namespaceObject = require("vuetify/lib/components/VStepper");
;// CONCATENATED MODULE: external "vuetify/lib/components/VTooltip"
var VTooltip_namespaceObject = require("vuetify/lib/components/VTooltip");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-form/vp-form.html?vue&type=template&id=783a5fb4&external












var vp_formvue_type_template_id_783a5fb4_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm_namespaceObject.VForm, {
    staticClass: "vp-form",
    class: {
      'vp-form--stepper': _vm.form.stepper
    }
  }, [_vm.form.stepper ? _c(VStepper_namespaceObject.VStepper, {
    attrs: {
      "non-linear": _vm.form.nonLinear
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c(VStepper_namespaceObject.VStepperHeader, [_vm._l(_vm.fieldSets, function (item, index) {
    return [_c(VStepper_namespaceObject.VStepperStep, {
      key: `header_${index}`,
      attrs: {
        "editable": "",
        "rules": [() => !_vm.isFieldSetErrored(item.fieldSet)],
        "step": index + 1
      }
    }, [_vm._v(" " + _vm._s(item.fieldSet.title) + " "), item.fieldSet.required ? _c('small', [_vm._v(_vm._s(_vm.$t('general.message.required')))]) : _vm._e(), !item.fieldSet.required && item.fieldSet.optional ? _c('small', [_vm._v(_vm._s(_vm.$t('general.message.optional')))]) : _vm._e()]), index + 1 < _vm.fieldSets.length ? _c(VDivider_namespaceObject.VDivider) : _vm._e()];
  })], 2), _c(VStepper_namespaceObject.VStepperItems, _vm._l(_vm.fieldSets, function (item, index) {
    return _c(VStepper_namespaceObject.VStepperContent, {
      key: `content_${index}`,
      attrs: {
        "step": index + 1
      }
    }, [_vm._t(item.fieldSet.slotName ?? `fieldSet${index + 1}`, function () {
      return [_c('vp-form-field-set', {
        attrs: {
          "errors": _vm.validationErrors,
          "fieldValues": _vm.fieldValues,
          "hide-legend": ""
        },
        on: {
          "change:field": _vm.onChange,
          "dblclick:field": (field, component, event) => _vm.$emit('dblclick:field', field, component, event),
          "download": attachment => _vm.$emit('download', attachment)
        },
        model: {
          value: _vm.form.items[item.originalIndex],
          callback: function ($$v) {
            _vm.$set(_vm.form.items, item.originalIndex, $$v);
          },
          expression: "form.items[item.originalIndex]"
        }
      })];
    }), _c(VDivider_namespaceObject.VDivider, {
      staticClass: "my-5"
    }), _c('div', {
      staticClass: "d-flex"
    }, [_c(VTooltip_namespaceObject.VTooltip, {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function ({
          on,
          attrs
        }) {
          return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
            attrs: {
              "disabled": _vm.step <= 1,
              "fab": "",
              "text": "",
              "small": ""
            },
            on: {
              "click": _vm.onPreviousStep
            }
          }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-left")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.action.previous')))])]), _c(VTooltip_namespaceObject.VTooltip, {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function ({
          on,
          attrs
        }) {
          return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
            staticClass: "ml-3",
            attrs: {
              "disabled": _vm.step === _vm.fieldSets.length,
              "fab": "",
              "text": "",
              "small": ""
            },
            on: {
              "click": _vm.onNextStep
            }
          }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-right")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.action.next')))])]), _c(VGrid_namespaceObject.VSpacer), _vm.form.cancelButton ? _c(VBtn_namespaceObject.VBtn, {
      staticClass: "vp-btn",
      attrs: {
        "text": "",
        "disabled": _vm.saving
      },
      on: {
        "click": _vm.onCancel
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]) : _vm._e(), _vm.form.saveButton || typeof _vm.form.saveButton === 'undefined' ? [_vm.hasNextStep ? _c(VBtn_namespaceObject.VBtn, {
      staticClass: "vp-btn ml-2",
      attrs: {
        "color": _vm.nextStepsRequired ? 'primary' : undefined,
        "depressed": ""
      },
      on: {
        "click": _vm.onNextStep
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('general.action.continue')) + " ")]) : _vm._e(), !_vm.nextStepsRequired ? _c(VBtn_namespaceObject.VBtn, {
      staticClass: "vp-btn ml-2",
      attrs: {
        "color": "primary",
        "depressed": "",
        "loading": _vm.saving,
        "disabled": _vm.saving
      },
      on: {
        "click": _vm.onSave
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")]) : _vm._e()] : _vm._e()], 2)], 2);
  }), 1)], 1) : [_vm._l(_vm.form.items, function (item, index) {
    return [_vm.isFieldSet(item) && _vm.isFieldSetVisible(item) ? [_vm._t(item.slotName ?? `fieldSet${index + 1}`, function () {
      return [_c('vp-form-field-set', {
        key: index,
        attrs: {
          "errors": _vm.validationErrors,
          "fieldValues": _vm.fieldValues
        },
        on: {
          "change:field": _vm.onChange,
          "dblclick:field": (field, component, event) => _vm.$emit('dblclick:field', field, component, event),
          "download": attachment => _vm.$emit('download', attachment)
        },
        model: {
          value: _vm.form.items[index],
          callback: function ($$v) {
            _vm.$set(_vm.form.items, index, $$v);
          },
          expression: "form.items[index]"
        }
      })];
    })] : !_vm.isFieldSet(item) && (item.disableNotHide || _vm.isFieldVisible(item)) ? _c('vp-form-field', {
      key: item.key,
      attrs: {
        "disabled": !_vm.isFieldVisible(item),
        "errors": _vm.validationErrors,
        "fieldValues": _vm.fieldValues
      },
      on: {
        "input": _vm.onChange,
        "dblclick": (field, component, event) => _vm.$emit('dblclick:field', field, component, event),
        "download": attachment => _vm.$emit('download', attachment)
      },
      model: {
        value: _vm.form.items[index],
        callback: function ($$v) {
          _vm.$set(_vm.form.items, index, $$v);
        },
        expression: "form.items[index]"
      }
    }) : _vm._e()];
  }), _vm.form.cancelButton ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "text": "",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]) : _vm._e(), _vm.form.saveButton || typeof _vm.form.saveButton === 'undefined' ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn ml-2",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.saving,
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")]) : _vm._e()]], 2);
};
var vp_formvue_type_template_id_783a5fb4_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-form/vp-form.html?vue&type=template&id=783a5fb4&external

;// CONCATENATED MODULE: external "core-js/modules/web.dom-exception.stack.js"
var web_dom_exception_stack_js_namespaceObject = require("core-js/modules/web.dom-exception.stack.js");
;// CONCATENATED MODULE: external "core-js/modules/web.structured-clone.js"
var web_structured_clone_js_namespaceObject = require("core-js/modules/web.structured-clone.js");
;// CONCATENATED MODULE: external "vuetify/lib/components/VCombobox"
var VCombobox_namespaceObject = require("vuetify/lib/components/VCombobox");
;// CONCATENATED MODULE: external "vuetify/lib/components/VSwitch"
var VSwitch_namespaceObject = require("vuetify/lib/components/VSwitch");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-form/field/vp-form-field.html?vue&type=template&id=32430611&external
















var vp_form_fieldvue_type_template_id_32430611_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.field.type === 'hidden' ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.field.key
    },
    domProps: {
      "value": _vm.field.value
    },
    on: {
      "change": _vm.onUpdate
    }
  }) : _c('div', {
    staticClass: "vp-formField",
    class: _vm.classes
  }, [!_vm.field.hideTitle ? _c('span', {
    staticClass: "vp-formField__label v-label",
    class: {
      'theme--light': !_vm.$vuetify.theme.dark,
      'theme--dark': _vm.$vuetify.theme.dark
    }
  }, [_vm._v(" " + _vm._s(_vm.field.title) + " "), _vm.field.required ? _c(VTooltip_namespaceObject.VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_vm._v(" *")])];
      }
    }], null, false, 2591800757)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.message.required')))])]) : _vm._e()], 1) : _vm._e(), _vm.field.description ? _c('p', {
    staticClass: "vp-formField__description text-caption"
  }, [_vm._v(" " + _vm._s(_vm.field.description) + " ")]) : _vm._e(), _vm.field.type === 'boolean' && _vm.field.required ? _c(VSwitch_namespaceObject.VSwitch, {
    staticClass: "vp-form-control",
    attrs: {
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'boolean' && !_vm.field.required ? _c('vp-boolean-radio-group', {
    attrs: {
      "either": true,
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'date' && !_vm.field.dropdown ? _c('vp-date-picker', {
    attrs: {
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": _vm.onUpdate,
      "dblclick": _vm.onDoubleClick
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'date' && _vm.field.dropdown ? _c('div', {
    staticClass: "vp-formField__dateSplit"
  }, [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.day'),
      "items": _vm.days,
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "error": _vm.hasError
    },
    on: {
      "change": _vm.onUpdateDateDropdown
    },
    model: {
      value: _vm.day,
      callback: function ($$v) {
        _vm.day = $$v;
      },
      expression: "day"
    }
  }), _c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.month'),
      "items": _vm.months,
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "error": _vm.hasError
    },
    on: {
      "change": _vm.onUpdateDateDropdown
    },
    model: {
      value: _vm.month,
      callback: function ($$v) {
        _vm.month = $$v;
      },
      expression: "month"
    }
  }), _c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.year'),
      "items": _vm.years,
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "error": _vm.hasError
    },
    on: {
      "change": _vm.onUpdateDateDropdown
    },
    model: {
      value: _vm.year,
      callback: function ($$v) {
        _vm.year = $$v;
      },
      expression: "year"
    }
  })], 1) : _vm.field.type === 'datetime' ? _c('vp-date-time-picker', {
    attrs: {
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": _vm.onUpdate,
      "dblclick": _vm.onDoubleClick
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'file' ? _c('div', {
    staticClass: "vp-formField__file"
  }, [_vm.field.value ? _c('span', {
    staticClass: "vp-formField__file__existing mr-3"
  }, [_c(VTooltip_namespaceObject.VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "ml-0",
          attrs: {
            "rounded": ""
          },
          on: {
            "click": _vm.onFileDownload
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v(_vm._s(_vm.attachmentIcon))]), _c('span', {
          staticClass: "ml-2"
        }, [_vm._v(_vm._s(_vm.field.value.filename))])], 1)];
      }
    }], null, false, 2923733335)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.action.download_filename', {
    filename: _vm.field.value.filename
  })))])]), _c(VTooltip_namespaceObject.VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": _vm.onFileDelete
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-delete")])], 1)];
      }
    }], null, false, 3451131027)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.action.delete_file')))])])], 1) : _vm._e(), !_vm.field.value ? _c('vp-file-selector', {
    staticClass: "vp-formField__file__upload",
    on: {
      "file-selected": _vm.onFileSelected
    }
  }) : _vm._e(), _c('div', {
    staticClass: "v-messages",
    class: {
      'theme--light': !_vm.$vuetify.theme.dark,
      'theme--dark': _vm.$vuetify.theme.dark
    }
  }, [_c('div', {
    staticClass: "v-messages__wrapper"
  })])], 1) : _vm.field.optionsCallback && !_vm.field.allowNewOptions ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    staticClass: "vp-form-control",
    attrs: {
      "value": _vm.field.multiple ? _vm.values : _vm.field.value,
      "items": _vm.dynamicOptions,
      "loading": _vm.loading,
      "search-input": _vm.search,
      "item-text": "title",
      "item-value": "value",
      "return-object": _vm.field.multiple ? true : false,
      "multiple": _vm.field.multiple,
      "filter": _vm.field.disableFilter ? _vm.dynamicOptionsDisabledFilter : undefined,
      "hide-no-data": "",
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "menu-props": {
        contentClass: 'vp-menu'
      },
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.onUpdateAutocomplete,
      "dblclick": _vm.onDoubleClick
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, {
          domProps: {
            "textContent": _vm._s(item.title)
          }
        }), item.subtitle ? _c(VList_namespaceObject.VListItemSubtitle, {
          domProps: {
            "textContent": _vm._s(item.subtitle)
          }
        }) : _vm._e()], 1)];
      }
    }])
  }) : _vm.field.optionsCallback && _vm.field.allowNewOptions ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-form-control",
    attrs: {
      "value": _vm.field.multiple ? _vm.values : _vm.field.value,
      "items": _vm.dynamicOptions,
      "loading": _vm.loading,
      "search-input": _vm.search,
      "item-text": "title",
      "item-value": "value",
      "return-object": _vm.field.multiple ? true : false,
      "multiple": _vm.field.multiple,
      "filter": _vm.field.disableFilter ? _vm.dynamicOptionsDisabledFilter : undefined,
      "hide-no-data": "",
      "filled": "",
      "chips": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "menu-props": {
        contentClass: 'vp-menu'
      },
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.onUpdateAutocomplete,
      "dblclick": _vm.onDoubleClick
    }
  }) : ['integer', 'string'].includes(_vm.field.type) && _vm.field?.options?.length > 0 && _vm.field.dropdown && _vm.field.multiple ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-form-control",
    attrs: {
      "items": _vm.field.options,
      "item-text": "title",
      "item-value": "value",
      "multiple": true,
      "filled": "",
      "chips": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "menu-props": {
        contentClass: 'vp-menu'
      },
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onValuesUpdated,
      "dblclick": _vm.onDoubleClick
    },
    model: {
      value: _vm.values,
      callback: function ($$v) {
        _vm.values = $$v;
      },
      expression: "values"
    }
  }) : ['integer', 'string'].includes(_vm.field.type) && _vm.field?.options?.length > 0 && _vm.field.dropdown && !_vm.field.multiple ? _c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-form-control",
    attrs: {
      "items": _vm.field.options,
      "item-text": "title",
      "item-value": "value",
      "filled": "",
      "return-object": false,
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "menu-props": {
        contentClass: 'vp-menu'
      },
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onUpdate
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, {
          domProps: {
            "textContent": _vm._s(item.title)
          }
        }), item.subtitle ? _c(VList_namespaceObject.VListItemSubtitle, {
          domProps: {
            "textContent": _vm._s(item.subtitle)
          }
        }) : _vm._e()], 1)];
      }
    }]),
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : ['integer', 'string'].includes(_vm.field.type) && _vm.field?.options?.length > 0 && !_vm.field.dropdown && _vm.field.multiple ? _c('div', [_vm._l(_vm.field.options, function (option) {
    return _c(VCheckbox_namespaceObject.VCheckbox, {
      key: option.value,
      staticClass: "vp-form-control",
      attrs: {
        "label": option.title,
        "value": option.value,
        "hide-details": "",
        "readonly": _vm.field.readonly,
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.onValuesUpdated
      },
      model: {
        value: _vm.values,
        callback: function ($$v) {
          _vm.values = $$v;
        },
        expression: "values"
      }
    });
  }), _c('div', {
    staticClass: "v-messages",
    class: {
      'theme--light': !_vm.$vuetify.theme.dark,
      'theme--dark': _vm.$vuetify.theme.dark
    }
  }, [_c('div', {
    staticClass: "v-messages__wrapper"
  })])], 2) : ['integer', 'string'].includes(_vm.field.type) && _vm.field?.options?.length > 0 && !_vm.field.dropdown && !_vm.field.multiple ? _c(VRadioGroup_namespaceObject.VRadioGroup, {
    staticClass: "vp-form-control",
    attrs: {
      "column": _vm.field.column,
      "row": _vm.field.row,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }, _vm._l(_vm.field.options, function (option) {
    return _c(VRadioGroup_namespaceObject.VRadio, {
      key: option.value,
      attrs: {
        "label": option.title,
        "value": option.value,
        "readonly": _vm.field.readonly,
        "disabled": _vm.disabled
      }
    });
  }), 1) : _vm.field.type === 'string' && _vm.field.multiline && _vm.field.rich ? _c('vp-text-editor', {
    attrs: {
      "markdown": _vm.field.markdown,
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'string' && _vm.field.multiline && !_vm.field.rich ? _c(VTextarea_namespaceObject.VTextarea, {
    staticClass: "vp-form-control",
    attrs: {
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _vm.field.type === 'string' && _vm.field.multiple ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-form-control",
    attrs: {
      "multiple": true,
      "filled": "",
      "chips": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "menu-props": {
        contentClass: 'vp-menu'
      },
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "change": _vm.onUpdate,
      "dblclick": _vm.onDoubleClick
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  }) : _c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "type": _vm.field.discreet && !_vm.indiscreet ? 'password' : 'text',
      "append-icon": _vm.field.discreetToggle ? _vm.indiscreet ? 'mdi-eye' : 'mdi-eye-off' : undefined,
      "filled": "",
      "readonly": _vm.field.readonly,
      "disabled": _vm.disabled,
      "clearable": _vm.field.clearable,
      "error": _vm.hasError,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": _vm.debouncedOnUpdate,
      "click:append": function ($event) {
        _vm.indiscreet = !_vm.indiscreet;
      },
      "dblclick": _vm.onDoubleClick
    },
    model: {
      value: _vm.field.value,
      callback: function ($$v) {
        _vm.$set(_vm.field, "value", $$v);
      },
      expression: "field.value"
    }
  })], 1);
};
var vp_form_fieldvue_type_template_id_32430611_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-form/field/vp-form-field.html?vue&type=template&id=32430611&external

;// CONCATENATED MODULE: external "core-js/modules/es.array-buffer.detached.js"
var es_array_buffer_detached_js_namespaceObject = require("core-js/modules/es.array-buffer.detached.js");
;// CONCATENATED MODULE: external "core-js/modules/es.array-buffer.transfer.js"
var es_array_buffer_transfer_js_namespaceObject = require("core-js/modules/es.array-buffer.transfer.js");
;// CONCATENATED MODULE: external "core-js/modules/es.array-buffer.transfer-to-fixed-length.js"
var es_array_buffer_transfer_to_fixed_length_js_namespaceObject = require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
;// CONCATENATED MODULE: external "core-js/modules/es.typed-array.to-reversed.js"
var es_typed_array_to_reversed_js_namespaceObject = require("core-js/modules/es.typed-array.to-reversed.js");
;// CONCATENATED MODULE: external "core-js/modules/es.typed-array.to-sorted.js"
var es_typed_array_to_sorted_js_namespaceObject = require("core-js/modules/es.typed-array.to-sorted.js");
;// CONCATENATED MODULE: external "core-js/modules/es.typed-array.with.js"
var es_typed_array_with_js_namespaceObject = require("core-js/modules/es.typed-array.with.js");
;// CONCATENATED MODULE: external "core-js/modules/web.url-search-params.delete.js"
var web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// CONCATENATED MODULE: external "core-js/modules/web.url-search-params.has.js"
var web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// CONCATENATED MODULE: external "core-js/modules/web.url-search-params.size.js"
var web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// CONCATENATED MODULE: ./src/model/services/form/form-service.ts
class FormService {
  /**
   * Returns a simple key/value collection of the values of the form's fields
   *
   * @param form
   * @returns
   */
  static getFormValues(form) {
    const values = {};
    for (const item of form.items) {
      if (FormService.isFieldSet(item)) {
        for (const field of item.fields) {
          values[field.key] = field.value;
        }
      } else {
        values[item.key] = item.value;
      }
    }
    return values;
  }
  /**
   * Returns whether the given item is of type FormFieldSetInterface
   *
   * @param item
   * @returns
   */
  static isFieldSet(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) !== undefined;
  }
  /**
   * Returns whether the given field is visible
   *
   * @param fieldSet
   * @param fieldValues
   */
  static isFieldSetVisible(fieldSet, fieldValues) {
    if (!fieldSet.dependencies) {
      return true;
    }
    for (const dependentField in fieldSet.dependencies) {
      const dependentValue = fieldSet.dependencies[dependentField];
      if (dependentValue instanceof RegExp) {
        if (!`${fieldValues[dependentField]}`.match(dependentValue)) {
          return false;
        }
      } else if (fieldValues[dependentField] !== dependentValue) {
        return false;
      }
    }
    return true;
  }
  /**
   * Returns whether the given field is errored
   *
   * @param fieldSet
   * @param validationErrors
   */
  static isFieldSetErrored(fieldSet, validationErrors) {
    for (const field of fieldSet.fields) {
      if (validationErrors[field.key]) {
        return true;
      }
    }
    return false;
  }
  /**
   * Returns whether the given field is visible
   *
   * @param fieldSet
   * @param fieldValues
   */
  static isFieldVisible(field, fieldValues) {
    if (!field.dependencies) {
      return true;
    }
    for (const dependentField in field.dependencies) {
      const dependentValue = field.dependencies[dependentField];
      if (dependentValue instanceof RegExp) {
        if (!`${fieldValues[dependentField]}`.match(dependentValue)) {
          return false;
        }
      } else if (fieldValues[dependentField] !== dependentValue) {
        return false;
      }
    }
    return true;
  }
  /**
   * Returns an MDI icon for an attachment.
   *
   * @param attachment
   */
  static getAttachmentIcon(attachment) {
    if (attachment.mimeType) {
      return FormService.getIconFromMimeType(attachment.mimeType);
    } else {
      return FormService.getIconFromExtension(attachment.filename.split('.').pop());
    }
  }
  /**
   * Returns an MDI icon for a mime type.
   *
   * @param mimeType
   */
  static getIconFromMimeType(mimeType) {
    switch (mimeType) {
      case 'application/pdf':
      case 'attachment/pdf':
        return 'mdi-file-pdf';
      case 'audio/aac':
      case 'audio/mpeg':
      case 'audio/mp4':
      case 'audio/ogg':
      case 'audio/vorbis':
      case 'audio/vnd.wav':
      case 'audio/wav':
      case 'audio/webm':
        return 'mdi-file-music';
      case 'application/msword':
      case 'application/rtf':
      case 'application/x-abiword':
      case 'application/vnd.oasis.opendocument.text':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'text/csv':
      case 'text/plain':
        return 'mdi-file-document';
      case 'image/apng':
      case 'image/avif':
      case 'image/bmp':
      case 'image/gif':
      case 'image/jpeg':
      case 'image/png':
      case 'image/svg+xml':
      case 'image/webp':
        return 'mdi-file-image';
      case 'video/mp4':
      case 'video/ogg':
      case 'video/quicktime':
      case 'video/x-msvideo':
      case 'video/x-ms-wmv':
      case 'video/webm':
        return 'mdi-file-video';
      default:
        return 'mdi-file';
    }
  }
  /**
   * Returns an MDI icon for an extension.
   *
   * @param extension
   */
  static getIconFromExtension(extension) {
    switch (extension) {
      case 'pdf':
        return 'mdi-file-pdf';
      case 'aac':
      case 'mp3':
      case 'wav':
      case 'weba':
        return 'mdi-file-music';
      case 'abw':
      case 'csv':
      case 'doc':
      case 'docx':
      case 'odt':
      case 'rtf':
      case 'txt':
        return 'mdi-file-document';
      case 'avif':
      case 'bmp':
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'svg':
      case 'tif':
      case 'tiff':
      case 'webp':
        return 'mdi-file-image';
      case 'avi':
      case 'mp4':
      case 'mpeg':
      case 'mov':
      case 'wmv':
      case 'webm':
        return 'mdi-file-video';
      default:
        return 'mdi-file';
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-form/field/vp-form-field.ts?vue&type=script&lang=ts&external




















let FormFieldComponent = class FormFieldComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.field = {
      key: '',
      title: '',
      type: 'string',
      required: false,
      value: null
    };
    this.values = [];
    // Split date values
    this.day = 1;
    this.month = 1;
    this.year = 1;
    // Dynamic option values
    this.loading = false;
    this.search = null;
    this.selectedResults = [];
    this.results = [];
    this.indiscreet = false;
  }
  created() {
    this.debouncedLoadResults = (0,external_lodash_namespaceObject.debounce)(this.loadResults, 300, {
      maxWait: 500
    });
    this.debouncedOnUpdate = (0,external_lodash_namespaceObject.debounce)(this.onUpdate, 300, {
      maxWait: 500
    });
    this.onValueChanged();
    this.debouncedLoadResults(true);
  }
  onValueChanged() {
    // Don't do anything if the data is the same
    if ((0,external_lodash_namespaceObject.isEqual)(this.field, this.value)) {
      return;
    }
    // Determine if the actual value has changed
    const valueChanged = !this.field || !(0,external_lodash_namespaceObject.isEqual)(this.field.value, this.value.value);
    // Determine if the cache buster has changed
    const cacheBusterChanged = !this.field || this.field.cacheBuster !== this.value.cacheBuster;
    // Update the working field
    this.field = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
    // Prepare helper values
    this.encodeValues();
    this.updateSplitDate();
    // Reload results if the cache buster value has changed
    if (cacheBusterChanged) {
      this.debouncedLoadResults();
    }
    // Things to do only if the actual field value has changed
    if (valueChanged) {
      // Clear the existing search
      this.search = null;
      // Reload the selected dynamic options if the field's value has changed
      this.loadSelectedDynamicOptions();
    }
  }
  onSearchChanged() {
    this.debouncedLoadResults();
  }
  /**
   * Returns the dynamic classes for the field
   */
  get classes() {
    const classes = {
      'vp-formField--row': this.field.row
    };
    const fieldKey = `vp-formField--${this.field.key}`;
    classes[fieldKey] = true;
    return classes;
  }
  /**
   * Handles updates
   */
  onUpdate() {
    // Trigger an event
    this.$emit('input', this.field);
  }
  /**
   * Handles date dropdown value updates
   */
  onUpdateDateDropdown() {
    // Handle issue where the days may be more than the newly selected month
    if (this.day > this.daysInMonth) {
      this.day = this.daysInMonth;
    }
    // Set the field value
    this.field.value = (0,external_date_fns_namespaceObject.parse)(`${this.year}-${this.month}-${this.day}`, 'y-M-d', new Date());
    // Trigger a standard update
    this.onUpdate();
  }
  /**
   * Handles autocomplete value updates
   */
  onUpdateAutocomplete(value) {
    if (this.field.multiple) {
      this.values = value;
      this.onValuesUpdated();
    } else {
      if (Array.isArray(value)) {
        this.field.value = value.length > 0 ? value[0] : null;
      } else {
        this.field.value = value;
      }
      this.onUpdate();
    }
    this.loadSelectedDynamicOptions();
    this.search = '';
  }
  /**
   * Handles array value updates
   */
  onValuesUpdated() {
    this.decodeValues();
    this.onUpdate();
  }
  /**
   * Handles file selections
   *
   * @param filename
   * @param mimeType
   * @param data
   */
  onFileSelected(filename, mimeType, data) {
    this.field.value = {
      filename,
      mimeType,
      size: data.byteLength,
      data
    };
    this.onUpdate();
  }
  /**
   * Handles downloading of an attachment
   */
  onFileDownload() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.field.value || typeof this.field.value !== 'object' || !('filename' in this.field.value)) {
        return;
      }
      // Just emit the field value if configured
      if (this.field.emitDownload) {
        this.$emit('download', this.field.value);
        return;
      }
      let uri;
      if (this.field.value.uri) {
        uri = this.field.value.uri;
      } else if (this.field.value.data) {
        // Convert the data to a blob
        const blob = new Blob([new Uint8Array(this.field.value.data)]);
        // Create a file URI
        uri = window.URL.createObjectURL(blob);
      } else {
        return;
      }
      // Generate a download link
      const link = document.createElement('a');
      link.setAttribute('download', this.field.value.filename);
      link.style.display = 'none';
      link.href = uri;
      document.body.appendChild(link);
      // Simulate a click on the link to auto download
      window.requestAnimationFrame(() => {
        const event = new MouseEvent('click');
        link.dispatchEvent(event);
        document.body.removeChild(link);
      });
    });
  }
  /**
   * Handles deletion of an attachment
   */
  onFileDelete() {
    this.field.value = null;
    this.onUpdate();
  }
  /**
   * Handles double click events on text fields
   *
   * @param event
   */
  onDoubleClick(event) {
    this.$emit('dblclick', this.field, this, event);
  }
  /**
   * Returns the attachment icon
   *
   * @returns
   */
  get attachmentIcon() {
    if (!this.field.value || typeof this.field.value !== 'object' || !('filename' in this.field.value)) {
      return '';
    }
    return FormService.getAttachmentIcon(this.field.value);
  }
  /**
   * Returns the days that are available in the current month
   */
  get days() {
    // If not a dropdown date field return an empty array
    if (this.field.type !== 'date' || !this.field.dropdown) {
      return [];
    }
    // Return the days in array form
    const days = [];
    for (let day = 1; day <= this.daysInMonth; day++) {
      days.push(day);
    }
    return days;
  }
  /**
   * Returns the number of days in the currently selected month
   */
  get daysInMonth() {
    // Get the current date value
    const date = (0,external_date_fns_namespaceObject.parse)(`${this.year}-${this.month}-1`, 'y-M-d', new Date());
    // Get the number of days in the selected month
    return (0,external_date_fns_namespaceObject.getDaysInMonth)(date);
  }
  /**
   * Returns the months
   */
  get months() {
    return [{
      value: 1,
      text: this.$t('general.month.january')
    }, {
      value: 2,
      text: this.$t('general.month.february')
    }, {
      value: 3,
      text: this.$t('general.month.march')
    }, {
      value: 4,
      text: this.$t('general.month.april')
    }, {
      value: 5,
      text: this.$t('general.month.may')
    }, {
      value: 6,
      text: this.$t('general.month.june')
    }, {
      value: 7,
      text: this.$t('general.month.july')
    }, {
      value: 8,
      text: this.$t('general.month.august')
    }, {
      value: 9,
      text: this.$t('general.month.september')
    }, {
      value: 10,
      text: this.$t('general.month.october')
    }, {
      value: 11,
      text: this.$t('general.month.november')
    }, {
      value: 12,
      text: this.$t('general.month.december')
    }];
  }
  /**
   * Returns the years
   */
  get years() {
    const date = new Date();
    const maxYear = (0,external_date_fns_namespaceObject.getYear)(date);
    const minYear = maxYear - 100;
    const years = [];
    for (let year = minYear; year <= maxYear; year++) {
      years.push(year);
    }
    return years;
  }
  /**
   * Returns the dynamic options
   */
  get dynamicOptions() {
    const options = [];
    // Add currently selected items
    for (const result of this.selectedResults) {
      options.push(result);
    }
    // Add search results
    for (const result of this.results) {
      options.push(result);
    }
    return options;
  }
  /**
   * Loads the options for already selected values
   */
  loadSelectedDynamicOptions() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.field.optionsCallback) {
        return;
      }
      this.selectedResults = [];
      const titles = {};
      // If a titles callback has been defined then load the titles from all the current values
      if (this.field.titlesCallback) {
        // Get the current values which need matching titles
        const values = [];
        if (this.field.multiple) {
          for (const value of this.values) {
            if (typeof value === 'object') {
              values.push(value.value);
            } else {
              values.push(value);
            }
          }
        } else if (this.field.value && !Array.isArray(this.field.value) && typeof this.field.value !== 'object') {
          values.push(this.field.value);
        }
        // Check the existing results first for matches as we might not need to query the callback
        for (const result of this.results) {
          if (values.includes(result.value)) {
            titles[result.value] = result.title;
          }
        }
        // Get titles from the callback if we haven't already found them all
        let callbackTitles = {};
        if (Object.keys(titles).length !== values.length || !(0,external_lodash_namespaceObject.isEqual)(Object.keys(titles), values)) {
          callbackTitles = yield this.field.titlesCallback(values);
        }
        for (const value in callbackTitles) {
          titles[value] = callbackTitles[value];
        }
      }
      if (this.field.multiple) {
        for (const value of this.values) {
          if (typeof value === 'object') {
            this.selectedResults.push(value);
          } else if (titles[value]) {
            this.selectedResults.push({
              value,
              title: titles[value]
            });
          } else {
            this.selectedResults.push({
              value,
              title: value.replace(/[_-]/g, ' ').replace(/(^|\s)\S/g, t => t.toUpperCase())
            });
          }
        }
      } else if (this.field.value && !Array.isArray(this.field.value) && typeof this.field.value !== 'object' && titles[this.field.value]) {
        this.selectedResults.push({
          value: this.field.value,
          title: titles[this.field.value]
        });
      }
    });
  }
  /**
   * Filter function that returns all items regardless of query.
   *
   * This is used when you may want API based results that search through non-title fields, e.g. barcode
   *
   * @returns
   */
  dynamicOptionsDisabledFilter() {
    return true;
  }
  /**
   * Encodes values into a format as expected by the component used for display
   *
   * @returns
   */
  encodeValues() {
    if (!this.field.multiple || !Array.isArray(this.field.value) || !this.field.options && !this.field.optionsCallback) {
      this.values = [];
      return;
    }
    // If a combobox then convert the values to objects due to a bug
    // See: https://github.com/vuetifyjs/vuetify/issues/5479
    if (this.field.dropdown && this.field.options && !this.field.optionsCallback) {
      const values = [];
      for (const value of this.field.value) {
        // Find the matching option
        for (const option of this.field.options) {
          if (option.value === value) {
            values.push(option);
            break;
          }
        }
      }
      this.values = values;
    } else {
      this.values = this.field.value;
    }
  }
  /**
   * Decodes the values from the component into expected form values
   */
  decodeValues() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const values = [];
    for (const value of this.values) {
      if (typeof value === 'object') {
        values.push(value.value);
      } else {
        values.push(value);
      }
    }
    this.field.value = values;
  }
  /**
   * Updates the split date values
   */
  updateSplitDate() {
    // Reset the date values if not a date dropdown
    if (this.field.type !== 'date' || !this.field.dropdown) {
      this.day = 1;
      this.month = 1;
      this.year = 1;
    } else {
      let date;
      if (this.field.value instanceof Date) {
        date = this.field.value;
      } else {
        date = new Date();
      }
      this.day = parseInt((0,external_date_fns_namespaceObject.format)(date, 'd'));
      this.month = (0,external_date_fns_namespaceObject.getMonth)(date) + 1;
      this.year = (0,external_date_fns_namespaceObject.getYear)(date);
      // Trigger an update if the value has changed
      if (this.field.value instanceof Date && (0,external_date_fns_namespaceObject.format)(this.field.value, 'y-M-d') === `${this.year}-${this.month}-${this.day}`) {
        return;
      }
      this.onUpdateDateDropdown();
    }
  }
  /**
   * Loads dynamic results
   *
   * @param initialLoad
   * @returns
   */
  loadResults(initialLoad = false) {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.field.optionsCallback || initialLoad && this.field.disableInitialOptionsCallback) {
        return;
      }
      try {
        this.loading = true;
        // For single selection, the search term is the actual title of the selected item...
        // but we want to show all default options when clicking on the field, so force an
        // empty search term in this case
        let search;
        if (!this.field.multiple && this.selectedResults.length > 0 && this.selectedResults[0].title === this.search) {
          search = '';
        } else {
          search = (_a = this.search) !== null && _a !== void 0 ? _a : '';
        }
        let results = [];
        // Return empty results if no search term and set to not show empty results
        if (!search && this.field.disableEmptySearchResults) {
          results = [];
        }
        // Otherwise load results from the callback
        else {
          results = yield this.field.optionsCallback(search);
        }
        // If a single value field, ensure the current value exists in the results, so it isn't cleared
        if (!this.field.multiple && this.field.value && this.search && typeof this.field.value !== 'object' && !Array.isArray(this.field.value)) {
          const match = (0,external_lodash_namespaceObject.find)(results, result => result.value === this.field.value);
          if (!match) {
            results.push({
              value: this.field.value,
              title: this.search
            });
          }
        }
        this.results = results;
      } finally {
        this.loading = false;
      }
    });
  }
  /**
   * Returns whether the field is in an error state
   *
   * @param property
   * @returns
   */
  get hasError() {
    return !!this.errors[this.field.key];
  }
  /**
   * Returns the error message for a field
   *
   * @param property
   */
  get errorMessages() {
    return this.field.key in this.errors ? this.errors[this.field.key] : [];
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormFieldComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], FormFieldComponent.prototype, "disabled", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormFieldComponent.prototype, "errors", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], FormFieldComponent.prototype, "onValueChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('search')], FormFieldComponent.prototype, "onSearchChanged", null);
FormFieldComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-boolean-radio-group': vp_boolean_radio_group,
    'vp-date-picker': vp_date_picker,
    'vp-date-time-picker': vp_date_time_picker,
    'vp-file-selector': vp_file_selector,
    'vp-text-editor': vp_text_editor
  }
})], FormFieldComponent);
/* harmony default export */ var vp_form_fieldvue_type_script_lang_ts_external = (FormFieldComponent);
;// CONCATENATED MODULE: ./src/components/vp-form/field/vp-form-field.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var field_vp_form_fieldvue_type_script_lang_ts_external = (vp_form_fieldvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-form/field/vp-form-field.vue





/* normalize component */
;
var vp_form_field_component = normalizeComponent(
  field_vp_form_fieldvue_type_script_lang_ts_external,
  vp_form_fieldvue_type_template_id_32430611_external_render,
  vp_form_fieldvue_type_template_id_32430611_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_form_field = (vp_form_field_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-form/field-set/vp-form-field-set.html?vue&type=template&id=ab21ceca&external
var vp_form_field_setvue_type_template_id_ab21ceca_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('fieldset', {
    staticClass: "vp-form__fieldSet vp-form-control"
  }, [_vm.fieldSet.title && !_vm.hideLegend ? _c('legend', {
    staticClass: "vp-form__fieldSet__title"
  }, [_vm._v(" " + _vm._s(_vm.fieldSet.title) + " ")]) : _vm._e(), _vm._l(_vm.fieldSet.fields, function (field, index) {
    return [field.disableNotHide || _vm.isFieldVisible(field) ? _c('vp-form-field', {
      key: field.key,
      staticClass: "vp-form__fieldSet__field",
      attrs: {
        "disabled": !_vm.isFieldVisible(field),
        "errors": _vm.errors
      },
      on: {
        "input": _vm.onUpdate,
        "dblclick": (field, component, event) => _vm.$emit('dblclick:field', field, component, event),
        "download": attachment => _vm.$emit('download', attachment)
      },
      model: {
        value: _vm.fieldSet.fields[index],
        callback: function ($$v) {
          _vm.$set(_vm.fieldSet.fields, index, $$v);
        },
        expression: "fieldSet.fields[index]"
      }
    }) : _vm._e()];
  })], 2);
};
var vp_form_field_setvue_type_template_id_ab21ceca_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-form/field-set/vp-form-field-set.ts?vue&type=script&lang=ts&external





let FormFieldSetComponent = class FormFieldSetComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.fieldSet = {
      title: '',
      fields: []
    };
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    this.fieldSet = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
  }
  /**
   * Handles updates
   *
   * @param field
   */
  onUpdate(field) {
    // Notify that the fieldset has changed
    this.$emit('input', this.fieldSet);
    // Notify the of the specific field change
    this.$emit('change:field', field);
  }
  /**
   * Returns whether the given field is visible
   *
   * @param key
   */
  isFieldVisible(field) {
    return FormService.isFieldVisible(field, this.fieldValues);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormFieldSetComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormFieldSetComponent.prototype, "errors", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormFieldSetComponent.prototype, "fieldValues", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], FormFieldSetComponent.prototype, "hideLegend", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], FormFieldSetComponent.prototype, "onValueChanged", null);
FormFieldSetComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-form-field': vp_form_field
  }
})], FormFieldSetComponent);
/* harmony default export */ var vp_form_field_setvue_type_script_lang_ts_external = (FormFieldSetComponent);
;// CONCATENATED MODULE: ./src/components/vp-form/field-set/vp-form-field-set.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var field_set_vp_form_field_setvue_type_script_lang_ts_external = (vp_form_field_setvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-form/field-set/vp-form-field-set.vue





/* normalize component */
;
var vp_form_field_set_component = normalizeComponent(
  field_set_vp_form_field_setvue_type_script_lang_ts_external,
  vp_form_field_setvue_type_template_id_ab21ceca_external_render,
  vp_form_field_setvue_type_template_id_ab21ceca_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_form_field_set = (vp_form_field_set_component.exports);
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/model/validator/abstract-validator"
var abstract_validator_namespaceObject = require("@vertical-plus/vue-js-core/dist/model/validator/abstract-validator");
var abstract_validator_default = /*#__PURE__*/__webpack_require__.n(abstract_validator_namespaceObject);
;// CONCATENATED MODULE: external "big.js"
var external_big_js_namespaceObject = require("big.js");
var external_big_js_default = /*#__PURE__*/__webpack_require__.n(external_big_js_namespaceObject);
;// CONCATENATED MODULE: ./src/model/validator/form-validator.ts





class FormValidator extends (abstract_validator_default()) {
  validate(form) {
    this.errors = {};
    const fieldValues = FormService.getFormValues(form);
    for (const item of form.items) {
      if (this.isFieldSet(item)) {
        this.validateFieldSet(item, fieldValues, this.errors);
      } else {
        this.validateField(item, fieldValues, this.errors);
      }
    }
    return this.errors;
  }
  /**
   * Validates a field set
   *
   * @param fieldSet
   * @param fieldValues
   * @param validationErrors
   */
  validateFieldSet(fieldSet, fieldValues, validationErrors) {
    for (const field of fieldSet.fields) {
      this.validateField(field, fieldValues, validationErrors);
    }
  }
  /**
   * Validates a field
   *
   * @param field
   * @param fieldValues
   * @param validationErrors
   */
  validateField(field, fieldValues, validationErrors) {
    // Skip validation if this field is not visible due to dependencies
    if (!FormService.isFieldVisible(field, fieldValues)) {
      return;
    }
    // General validation rules
    switch (field.type) {
      case 'boolean':
        this.validateBoolean(field, validationErrors);
        break;
      case 'date':
        this.validateDate(field, validationErrors);
        break;
      case 'datetime':
        this.validateDateTime(field, validationErrors);
        break;
      case 'decimal':
        this.validateDecimal(field, validationErrors);
        break;
      case 'integer':
        this.validateInteger(field, validationErrors);
        break;
      case 'hidden':
      case 'string':
        this.validateString(field, validationErrors);
        break;
    }
    // Custom validator
    if (field.validator) {
      const errors = field.validator(field, fieldValues);
      if (errors.length > 0) {
        if (validationErrors[field.key]) {
          validationErrors[field.key].push(...errors);
        } else {
          validationErrors[field.key] = errors;
        }
      }
    }
  }
  /**
   * Validates a boolean field
   *
   * @param field
   * @param validationErrors
   * @returns
   */
  validateBoolean(field, validationErrors) {
    const errors = [];
    if (field.required && field.value === null) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    if (field.value !== null && typeof field.value !== 'boolean') {
      errors.push(this.i18n.t('general.validation.value_must_be_boolean').toString());
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Validates a date field
   *
   * @param field
   * @param validationErrors
   */
  validateDate(field, validationErrors) {
    const errors = [];
    // Required value
    if (field.required && !field.value) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    // Date value
    if (field.value !== null && !(0,external_date_fns_namespaceObject.isValid)(field.value)) {
      errors.push(this.i18n.t('general.validation.value_must_be_date').toString());
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Validates a date time field
   *
   * @param field
   * @param validationErrors
   */
  validateDateTime(field, validationErrors) {
    const errors = [];
    // Required value
    if (field.required && !field.value) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    // Date value
    if (field.value !== null && !(0,external_date_fns_namespaceObject.isValid)(field.value)) {
      errors.push(this.i18n.t('general.validation.value_must_be_datetime').toString());
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Validates a decimal field
   *
   * @param field
   * @param validationErrors
   */
  validateDecimal(field, validationErrors) {
    var _a, _b;
    const errors = [];
    // Required value
    if (field.required && !field.value) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    // Decimal value
    if (typeof field.value === 'string') {
      try {
        const decimal = new (external_big_js_default())(field.value);
        // Min
        if (((_a = field.validationRules) === null || _a === void 0 ? void 0 : _a.minValue) && (field.value === null || decimal.lt(field.validationRules.minValue))) {
          errors.push(this.i18n.t('general.validation.value_min_value', {
            length: field.validationRules.minValue
          }).toString());
        }
        // Max
        if (((_b = field.validationRules) === null || _b === void 0 ? void 0 : _b.maxValue) && (field.value === null || decimal.gt(field.validationRules.maxValue))) {
          errors.push(this.i18n.t('general.validation.value_max_value', {
            length: field.validationRules.maxValue
          }).toString());
        }
      } catch (error) {
        errors.push(this.i18n.t('general.validation.value_must_be_decimal').toString());
      }
    } else if (field.value !== null) {
      errors.push(this.i18n.t('general.validation.value_must_be_decimal').toString());
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Validates an integer field
   *
   * @param field
   * @param validationErrors
   */
  validateInteger(field, validationErrors) {
    var _a, _b;
    const errors = [];
    // Required value
    if (field.required && field.value === null) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    if (!field.multiple) {
      // Integer value
      if (field.value !== null && (typeof field.value === 'number' && !Number.isInteger(field.value) || typeof field.value === 'string' && !Number.isInteger(parseFloat(field.value)))) {
        errors.push(this.i18n.t('general.validation.value_must_be_integer').toString());
      }
      // Min
      if (((_a = field.validationRules) === null || _a === void 0 ? void 0 : _a.minValue) && (field.value === null || field.value < field.validationRules.minValue)) {
        errors.push(this.i18n.t('general.validation.value_min_value', {
          length: field.validationRules.minValue
        }).toString());
      }
      // Max
      if (((_b = field.validationRules) === null || _b === void 0 ? void 0 : _b.maxValue) && (field.value === null || field.value > field.validationRules.maxValue)) {
        errors.push(this.i18n.t('general.validation.value_max_value', {
          length: field.validationRules.maxValue
        }).toString());
      }
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Validates a string field
   *
   * @param field
   * @param validationErrors
   */
  validateString(field, validationErrors) {
    var _a, _b;
    const errors = [];
    // Required value
    if (field.required && !field.value) {
      errors.push(this.i18n.t('general.validation.field_is_required').toString());
    }
    if (!field.multiple) {
      // String value
      if (field.value !== null && typeof field.value !== 'string') {
        errors.push(this.i18n.t('general.validation.value_must_be_string').toString());
      }
      // Min length
      if (((_a = field.validationRules) === null || _a === void 0 ? void 0 : _a.minLength) && (field.value === null || field.value.length < field.validationRules.minLength)) {
        errors.push(this.i18n.t('general.validation.value_min_length', {
          length: field.validationRules.minLength
        }).toString());
      }
      // Max length
      if (((_b = field.validationRules) === null || _b === void 0 ? void 0 : _b.maxLength) && (field.value === null || field.value.length > field.validationRules.maxLength)) {
        errors.push(this.i18n.t('general.validation.value_max_length', {
          length: field.validationRules.maxLength
        }).toString());
      }
    }
    if (errors.length > 0) {
      validationErrors[field.key] = errors;
    }
  }
  /**
   * Returns whether the given item is of type FormFieldSetInterface
   *
   * @param item
   * @returns
   */
  isFieldSet(item) {
    return FormService.isFieldSet(item);
  }
}
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/util"
var util_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/util");
var util_default = /*#__PURE__*/__webpack_require__.n(util_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-form/vp-form.ts?vue&type=script&lang=ts&external











let FormComponent = class FormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.form = {
      items: []
    };
    this.step = 1;
    this.saveClicked = false;
    this.validationErrors = {};
    /**
     * Flat version of the field values
     */
    this.fieldValues = {};
  }
  created() {
    this.onValueUpdated();
    this.validator = new FormValidator();
  }
  onValueUpdated() {
    this.form = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
    this.updateFieldValues();
  }
  /**
   * Sets the stepper step
   *
   * @param step
   */
  setStep(step) {
    this.step = step;
  }
  /**
   * Sets a value in the form
   *
   * @param field
   * @param value
   */
  setValue(key, value) {
    const cacheBuster = new Date().getTime().toString();
    for (let i = 0; i < this.form.items.length; i++) {
      const item = this.form.items[i];
      if (FormService.isFieldSet(item)) {
        for (let j = 0; j < item.fields.length; j++) {
          const field = item.fields[j];
          if (field.key !== key) {
            continue;
          }
          const newField = (0,external_lodash_namespaceObject.cloneDeep)(field);
          newField.value = value;
          newField.cacheBuster = cacheBuster;
          const newFieldSet = (0,external_lodash_namespaceObject.cloneDeep)(item);
          newFieldSet.fields[j] = newField;
          this.form.items.splice(i, 1, newFieldSet);
        }
      } else {
        if (item.key !== key) {
          continue;
        }
        const newField = (0,external_lodash_namespaceObject.cloneDeep)(item);
        newField.value = value;
        newField.cacheBuster = cacheBuster;
        this.form.items.splice(i, 1, newField);
      }
    }
    // Update the field values and potentially trigger a change event
    this.updateFieldValues();
  }
  /**
   * Returns whether the form is valid
   */
  get valid() {
    return Object.keys(this.validationErrors).length === 0;
  }
  /**
   * Returns whether there is another step after the current
   */
  get hasNextStep() {
    return this.step < this.fieldSets.length;
  }
  /**
   * Returns whether one of the next steps contains a required field with no value
   */
  get nextStepsRequired() {
    for (const fieldSet of this.fieldSets) {
      // Skip if before the current step
      if (fieldSet.originalIndex + 1 <= this.step) {
        continue;
      }
      // Return true if any field in the field set is required and doesn't have a value
      for (const field of fieldSet.fieldSet.fields) {
        if (field.required && this.isFieldVisible(field) && util_default().isNullOrUndefined(this.fieldValues[field.key])) {
          return true;
        }
      }
    }
    // If we get here then there aren't any required, empty fields in the next steps
    return false;
  }
  /**
   * Validates the form
   */
  validate() {
    this.validationErrors = Object.assign({}, this.validator.validate(this.form));
  }
  /**
   * Validates a specific field
   *
   * @param field
   */
  validateField(field) {
    // Copy the validation errors
    const validationErrors = structuredClone(this.validationErrors);
    // Delete the field from the validation errors
    if (validationErrors[field.key]) {
      delete validationErrors[field.key];
    }
    // Validate the field
    this.validator.validateField(field, this.fieldValues, validationErrors);
    // Update the validation errors
    this.validationErrors = Object.assign({}, validationErrors);
  }
  /**
   * Returns a flat object with field values
   */
  updateFieldValues() {
    // Get the latest values for the form
    let values = FormService.getFormValues(this.form);
    // Clear any fields that are dependent on a changed field
    values = this.clearDependentFields(this.fieldValues, values);
    // Have the values actually changed?
    const changed = !(0,external_lodash_namespaceObject.isEqual)(this.fieldValues, values);
    // Assign the updated field values
    this.fieldValues = Object.assign({}, values);
    // Trigger an event if the values have actually changed
    if (changed) {
      this.$emit('change:values', this.fieldValues);
    }
  }
  /**
   * Handles change events
   */
  onChange(field) {
    // Update the stored field values
    this.updateFieldValues();
    // Only re-validate if the save button has been clicked
    if (this.saveClicked) {
      this.validate();
    }
    // ...or if the field is set to validate on change
    else if (field.validateOnChange) {
      this.validateField(field);
    }
  }
  /**
   * Handles cancels
   */
  onCancel() {
    this.$emit('cancel');
  }
  /**
   * Handles saves
   */
  onSave() {
    // Mark the fact the save button has been clicked
    this.saveClicked = true;
    // Run validation again
    this.validate();
    // Ensure the form is valid before progressing
    if (!this.valid) {
      return;
    }
    // Emit a save event
    this.$emit('save', this.form);
  }
  /**
   * Handles previous step navigation
   *
   * @returns
   */
  onPreviousStep() {
    if (this.step <= 1) {
      return;
    }
    this.step--;
  }
  /**
   * Handles next step navigation
   *
   * @returns
   */
  onNextStep() {
    if (this.step >= this.fieldSets.length) {
      return;
    }
    this.step++;
  }
  /**
   * Returns only the field sets from the form
   *
   * Note: This is used when in stepper view mode
   */
  get fieldSets() {
    const fieldSets = [];
    for (let index = 0; index < this.form.items.length; index++) {
      const item = this.form.items[index];
      if (FormService.isFieldSet(item)) {
        fieldSets.push({
          fieldSet: item,
          originalIndex: index
        });
      }
    }
    return fieldSets;
  }
  /**
   * Returns whether the given item is of type FormFieldSetInterface
   *
   * @param item
   * @returns
   */
  isFieldSet(item) {
    return FormService.isFieldSet(item);
  }
  /**
   * Returns whether the given field set is visible
   *
   * @param fieldSet
   * @returns
   */
  isFieldSetVisible(fieldSet) {
    return FormService.isFieldSetVisible(fieldSet, this.fieldValues);
  }
  /**
   * Returns whether the given field set is errored
   *
   * @param fieldSet
   * @returns
   */
  isFieldSetErrored(fieldSet) {
    return FormService.isFieldSetErrored(fieldSet, this.validationErrors);
  }
  /**
   * Returns whether the given field is visible
   *
   * @param key
   */
  isFieldVisible(field) {
    return FormService.isFieldVisible(field, this.fieldValues);
  }
  /**
   * Clears the values from dependent fields if the value of any dependencies has changed
   *
   * @param oldValues
   * @param newValues
   */
  clearDependentFields(oldValues, newValues) {
    // Get changed values
    const changed = Object.keys(oldValues).filter(key => oldValues[key] !== newValues[key]);
    // Nothing to do if no changed values
    if (changed.length === 0) {
      return newValues;
    }
    const cacheBuster = new Date().getTime().toString();
    // Get fields that are dependent on any of these fields and clear them
    for (let i = 0; i < this.form.items.length; i++) {
      const item = this.form.items[i];
      if (FormService.isFieldSet(item)) {
        const newFieldSet = (0,external_lodash_namespaceObject.cloneDeep)(item);
        let fieldSetChanged = false;
        for (let j = 0; j < item.fields.length; j++) {
          const field = item.fields[j];
          if (!field.dependencies) {
            continue;
          }
          for (const dependentField in field.dependencies) {
            // eslint-disable-next-line max-depth
            if (changed.includes(dependentField)) {
              // Mark the field set as having changed
              fieldSetChanged = true;
              // Update the field within the fieldset
              const newField = (0,external_lodash_namespaceObject.cloneDeep)(field);
              newField.value = null;
              newField.cacheBuster = cacheBuster;
              newFieldSet.fields[j] = newField;
              break;
            }
          }
        }
        // If the field set has changed then replace in the form items
        if (fieldSetChanged) {
          this.form.items.splice(i, 1, newFieldSet);
        }
      } else {
        for (const dependentField in item.dependencies) {
          // eslint-disable-next-line max-depth
          if (changed.includes(dependentField)) {
            const newField = (0,external_lodash_namespaceObject.cloneDeep)(item);
            newField.value = null;
            newField.cacheBuster = cacheBuster;
            this.form.items.splice(i, 1, newField);
            break;
          }
        }
      }
    }
    // Load the latest updated values from the form
    const updatedValues = FormService.getFormValues(this.form);
    // Recurse
    return this.clearDependentFields(newValues, updatedValues);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], FormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], FormComponent.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], FormComponent.prototype, "onValueUpdated", null);
FormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-form-field-set': vp_form_field_set,
    'vp-form-field': vp_form_field
  }
})], FormComponent);
/* harmony default export */ var vp_formvue_type_script_lang_ts_external = (FormComponent);
;// CONCATENATED MODULE: ./src/components/vp-form/vp-form.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_form_vp_formvue_type_script_lang_ts_external = (vp_formvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(591);
;// CONCATENATED MODULE: ./src/components/vp-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-form/vp-form.vue



;


/* normalize component */

var vp_form_component = normalizeComponent(
  vp_form_vp_formvue_type_script_lang_ts_external,
  vp_formvue_type_template_id_783a5fb4_external_render,
  vp_formvue_type_template_id_783a5fb4_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_form = (vp_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/google-sign-in-button/google-sign-in-button.html?vue&type=template&id=36b03d5e&external
var google_sign_in_buttonvue_type_template_id_36b03d5e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.signedIn ? _c('div', {
    staticClass: "google-signInButton button button--google-sign-in",
    class: {
      'google-signInButton--disabled': !_vm.initialised
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.signIn.apply(null, arguments);
      }
    }
  }, [_vm.logo ? _c('div', {
    staticClass: "google-signInButton__icon button__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Google Logo"
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "google-signInButton__text button__text"
  }, [_vm._v(_vm._s(_vm.$t('authentication.action.sign_in_google')))])]) : _c('div', {
    staticClass: "google-signInButton button button--google-sign-in",
    class: {
      'google-signInButton--disabled': !_vm.initialised
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.signOut.apply(null, arguments);
      }
    }
  }, [_vm.logo ? _c('div', {
    staticClass: "google-signInButton__icon button__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Google Logo"
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "google-signInButton__text button__text"
  }, [_vm._v(_vm._s(_vm.$t('authentication.action.sign_out_google')))])]);
};
var google_sign_in_buttonvue_type_template_id_36b03d5e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/model/services/api/google/google-api-service.ts


class GoogleApiService {
  /**
   * Initialises the Google API
   *
   * @param config
   */
  static initApi(config) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Check if it's already been initialised
      if (GoogleApiService.isInitialised) {
        return;
      }
      // Load the client
      yield this.loadClient();
      // Init the api
      google.accounts.id.initialize({
        client_id: config.clientId,
        use_fedcm_for_prompt: true,
        callback: response => GoogleApiService.handleCredentialsResponse(response)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      });
      // Mark the API as having been initialised
      GoogleApiService.isInitialised = true;
    });
  }
  /**
   * Loads the google accounts client
   *
   * @returns
   */
  static loadClient() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://accounts.google.com/gsi/client');
      document.head.appendChild(script);
      return new Promise(resolve => {
        script.onload = () => {
          resolve();
        };
      });
    });
  }
  /**
   * Handles the credentials response
   *
   * @param response
   */
  static handleCredentialsResponse(response) {
    if (response.credential) {
      event_bus_default().instance.$emit('google-sign-in', response.credential);
    }
  }
}
GoogleApiService.isInitialised = false;
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/google-sign-in-button/google-sign-in-button.ts?vue&type=script&lang=ts&external


/* eslint-disable @typescript-eslint/no-explicit-any */


let GoogleSignInComponent = class GoogleSignInComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.initialised = false;
    this.signedIn = false;
  }
  created() {
    this.listener = token => {
      this.handleGoogleSignInEvent(token);
    };
    // Listen for Google sign in events
    event_bus_default().instance.$on('google-sign-in', this.listener);
  }
  beforeDestroy() {
    // Stop listening for Google sign in events
    event_bus_default().instance.$off('google-sign-in', this.listener);
  }
  mounted() {
    this.initApi();
  }
  /**
   * Initialises the API
   */
  initApi() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Initialise the API.
      yield GoogleApiService.initApi(this.config);
      // Mark as initialised
      this.initialised = true;
    });
  }
  /**
   * Handle a Google sign in event
   *
   * @param token
   */
  handleGoogleSignInEvent(token) {
    // Mark as signed in
    this.signedIn = true;
    // Emit the signed in event
    this.$emit('logged-in-token', token);
  }
  /**
   * Signs the user in.
   */
  signIn() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.initialised) {
        return;
      }
      // Show the login prompt
      google.accounts.id.prompt(notification => {
        // Handle failed to display reason
        if (notification.isNotDisplayed()) {
          switch (notification.getNotDisplayedReason()) {
            case 'browser_not_supported':
              console.error('Browser not supported for Google sign in');
              break;
            case 'invalid_client':
              console.error('Invalid client for Google sign in');
              break;
            case 'missing_client_id':
              console.error('Client id not defined for Google sign in');
              break;
            case 'opt_out_or_no_session':
              event_bus_default().instance.$emit('notification', this.$t('authentication.message.prompt_opt_out_or_no_session'), 'error');
              break;
            case 'secure_http_required':
              console.error('Secure http required for Google sign in');
              break;
            case 'suppressed_by_user':
              event_bus_default().instance.$emit('notification', this.$t('authentication.message.prompt_suppressed_by_user'), 'error');
              break;
            case 'unregistered_origin':
              console.error('Google sign in not supported on this unregistered origin');
              break;
            case 'unknown_reason':
              break;
          }
        }
      });
    });
  }
  /**
   * Signs the user out.
   */
  signOut() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.initialised) {
        return;
      }
      // Prevent auto re-login
      google.accounts.id.disableAutoSelect();
      // Emit a logged-out event.
      this.$emit('logged-out');
      // Mark as signed out.
      this.signedIn = false;
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], GoogleSignInComponent.prototype, "logo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], GoogleSignInComponent.prototype, "config", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], GoogleSignInComponent.prototype, "offline", void 0);
GoogleSignInComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], GoogleSignInComponent);
/* harmony default export */ var google_sign_in_buttonvue_type_script_lang_ts_external = (GoogleSignInComponent);
;// CONCATENATED MODULE: ./src/components/google-sign-in-button/google-sign-in-button.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var google_sign_in_button_google_sign_in_buttonvue_type_script_lang_ts_external = (google_sign_in_buttonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/google-sign-in-button/google-sign-in-button.scss?vue&type=style&index=0&prod&lang=scss&external
var google_sign_in_buttonvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(187);
;// CONCATENATED MODULE: ./src/components/google-sign-in-button/google-sign-in-button.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/google-sign-in-button/google-sign-in-button.vue



;


/* normalize component */

var google_sign_in_button_component = normalizeComponent(
  google_sign_in_button_google_sign_in_buttonvue_type_script_lang_ts_external,
  google_sign_in_buttonvue_type_template_id_36b03d5e_external_render,
  google_sign_in_buttonvue_type_template_id_36b03d5e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var google_sign_in_button = (google_sign_in_button_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VSnackbar"
var VSnackbar_namespaceObject = require("vuetify/lib/components/VSnackbar");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-notifications/vp-notifications.html?vue&type=template&id=06bd42ce&external



var vp_notificationsvue_type_template_id_06bd42ce_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VSnackbar_namespaceObject.VSnackbar, {
    attrs: {
      "bottom": "",
      "multi-line": _vm.isMultiline,
      "timeout": _vm.timeout,
      "color": _vm.type
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function ({
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._b({
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.isVisible = false;
            }
          }
        }, 'v-btn', attrs, false), [_vm._v(" " + _vm._s(_vm.$t('general.action.close')) + " ")])];
      }
    }]),
    model: {
      value: _vm.isVisible,
      callback: function ($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]);
};
var vp_notificationsvue_type_template_id_06bd42ce_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-notifications/vp-notifications.html?vue&type=template&id=06bd42ce&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-notifications/vp-notifications.ts?vue&type=script&lang=ts&external



let NotificationsComponent = class NotificationsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.isVisible = false;
    this.isMultiline = false;
    this.timeout = 5000;
    this.text = '';
    this.type = '';
  }
  created() {
    this.listener = (text = '', type = '') => {
      this.handleNotification(text, type);
    };
    event_bus_default().instance.$on('notification', this.listener);
  }
  beforeDestroy() {
    event_bus_default().instance.$off('notification', this.listener);
  }
  /**
   * Handles a new notification message.
   *
   * @param text
   * @param type
   */
  handleNotification(text = '', type = '') {
    this.text = text;
    this.type = type;
    this.isVisible = true;
  }
};
NotificationsComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], NotificationsComponent);
/* harmony default export */ var vp_notificationsvue_type_script_lang_ts_external = (NotificationsComponent);
;// CONCATENATED MODULE: ./src/components/vp-notifications/vp-notifications.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_notifications_vp_notificationsvue_type_script_lang_ts_external = (vp_notificationsvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-notifications/vp-notifications.vue





/* normalize component */
;
var vp_notifications_component = normalizeComponent(
  vp_notifications_vp_notificationsvue_type_script_lang_ts_external,
  vp_notificationsvue_type_template_id_06bd42ce_external_render,
  vp_notificationsvue_type_template_id_06bd42ce_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_notifications = (vp_notifications_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-priority-table/vp-priority-table.html?vue&type=template&id=5ffddccb&external




var vp_priority_tablevue_type_template_id_5ffddccb_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-priority-table"
  }, [_vm.title ? _c('div', {
    staticClass: "align-center d-md-flex"
  }, [_c('h2', {
    staticClass: "vp-priority-table__heading"
  }, [_vm._v(" " + _vm._s(_vm.title) + " (" + _vm._s(_vm.itemCount) + ") ")]), _vm.helpMessage ? [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "ml-2",
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showHelp = true;
      }
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-information-outline")])], 1), _c('vp-notification-dialog', {
    attrs: {
      "title": _vm.helpTitle,
      "message": _vm.helpMessage,
      "text": ""
    },
    model: {
      value: _vm.showHelp,
      callback: function ($$v) {
        _vm.showHelp = $$v;
      },
      expression: "showHelp"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.description ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _c(VDataTable_namespaceObject.VDataTable, {
    staticClass: "elevation-3 vp-data-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": _vm.defaultRows,
      "footer-props": _vm.footerProps
    },
    on: {
      "click:row": _vm.onRowClicked,
      "update:options": _vm.setDefaultRows
    },
    scopedSlots: _vm._u([{
      key: "header.issue",
      fn: function ({
        header
      }) {
        return [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-alert")]), _vm._v(" " + _vm._s(header.value) + " ")];
      }
    }, {
      key: "item.recommendation",
      fn: function ({
        item
      }) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(item.recommendation)
          }
        })];
      }
    }, _vm.showViewAll ? {
      key: "footer.prepend",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          staticClass: "vp-btn",
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.viewAllCallback
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.message.view_all')) + " ")])];
      },
      proxy: true
    } : null], null, true)
  })], 1);
};
var vp_priority_tablevue_type_template_id_5ffddccb_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-priority-table/vp-priority-table.html?vue&type=template&id=5ffddccb&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-priority-table/vp-priority-table.ts?vue&type=script&lang=ts&external



let PriorityIssues = class PriorityIssues extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.showHelp = false;
  }
  /**
   * Returns the number of items for the header
   */
  get itemCount() {
    return this.count > -1 ? this.count : this.items.length;
  }
  /**
   * Handles row clicks
   *
   * @param item
   */
  onRowClicked(item) {
    this.$emit('click:row', item);
  }
  /**
   * Function to set the items per page numbers
   */
  get footerProps() {
    return {
      'items-per-page-options': this.itemsPerPageOptions
    };
  }
  /**
   * Function to set the default rows to the selected value
   * @param options
   */
  setDefaultRows(options) {
    this.defaultRows = options.itemsPerPage;
  }
  /**
   *  Function when view all button is clicked select all (-1) from the dropdown
   */
  viewAllCallback() {
    this.defaultRows = -1;
  }
  /**
   *  Function to check to see if to display the view all button or not - if the all button is pressed, and the total items is greater the default rows     */
  get showViewAll() {
    return this.itemsPerPageOptions.includes(-1) && this.defaultRows !== -1 && this.items.length > this.defaultRows;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssues.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssues.prototype, "description", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssues.prototype, "helpTitle", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssues.prototype, "helpMessage", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], PriorityIssues.prototype, "headers", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], PriorityIssues.prototype, "items", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: -1
})], PriorityIssues.prototype, "count", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: 3
})], PriorityIssues.prototype, "defaultRows", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => [3, 5, 10, -1]
})], PriorityIssues.prototype, "itemsPerPageOptions", void 0);
PriorityIssues = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-notification-dialog': vp_notification_dialog
  }
})], PriorityIssues);
/* harmony default export */ var vp_priority_tablevue_type_script_lang_ts_external = (PriorityIssues);
;// CONCATENATED MODULE: ./src/components/vp-priority-table/vp-priority-table.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_priority_table_vp_priority_tablevue_type_script_lang_ts_external = (vp_priority_tablevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-priority-table/vp-priority-table.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_priority_tablevue_type_style_index_0_prod_lang_scss_external = __webpack_require__(299);
;// CONCATENATED MODULE: ./src/components/vp-priority-table/vp-priority-table.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-priority-table/vp-priority-table.vue



;


/* normalize component */

var vp_priority_table_component = normalizeComponent(
  vp_priority_table_vp_priority_tablevue_type_script_lang_ts_external,
  vp_priority_tablevue_type_template_id_5ffddccb_external_render,
  vp_priority_tablevue_type_template_id_5ffddccb_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_priority_table = (vp_priority_table_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-priority-table-simple/vp-priority-table-simple.html?vue&type=template&id=5e1276a8&external



var vp_priority_table_simplevue_type_template_id_5e1276a8_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-priority-table-simple"
  }, [_vm.title ? _c('div', {
    staticClass: "align-center d-md-flex",
    class: _vm.titleClass
  }, [_c('h2', {
    staticClass: "vp-priority-table-simple__heading"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.link ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn ml-auto",
    attrs: {
      "text": "",
      "to": _vm.link
    }
  }, [_vm._t("linkTitle", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('general.message.view_all')) + " ")];
  })], 2) : _vm._e()], 1) : _vm._e(), _c(VDataTable_namespaceObject.VSimpleTable, {
    staticClass: "vp-simple-table",
    attrs: {
      "height": _vm.tableHeight
    }
  }, [_c('tbody', _vm._l(_vm.items, function (item) {
    return _c('tr', {
      key: item.name,
      on: {
        "click": function ($event) {
          return _vm.onRowClick(item);
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.issue))]), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.recommendation)
      }
    })])]);
  }), 0)])], 1);
};
var vp_priority_table_simplevue_type_template_id_5e1276a8_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-priority-table-simple/vp-priority-table-simple.html?vue&type=template&id=5e1276a8&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-priority-table-simple/vp-priority-table-simple.ts?vue&type=script&lang=ts&external


let PriorityIssuesSimple = class PriorityIssuesSimple extends external_vue_property_decorator_namespaceObject.Vue {
  /**
   * Handles row clicks
   *
   * @param item
   */
  onRowClick(item) {
    this.$emit('click:row', item);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssuesSimple.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], PriorityIssuesSimple.prototype, "titleClass", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object,
  default: null
})], PriorityIssuesSimple.prototype, "link", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: null
})], PriorityIssuesSimple.prototype, "tableHeight", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], PriorityIssuesSimple.prototype, "items", void 0);
PriorityIssuesSimple = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], PriorityIssuesSimple);
/* harmony default export */ var vp_priority_table_simplevue_type_script_lang_ts_external = (PriorityIssuesSimple);
;// CONCATENATED MODULE: ./src/components/vp-priority-table-simple/vp-priority-table-simple.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_priority_table_simple_vp_priority_table_simplevue_type_script_lang_ts_external = (vp_priority_table_simplevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-priority-table-simple/vp-priority-table-simple.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_priority_table_simplevue_type_style_index_0_prod_lang_scss_external = __webpack_require__(675);
;// CONCATENATED MODULE: ./src/components/vp-priority-table-simple/vp-priority-table-simple.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-priority-table-simple/vp-priority-table-simple.vue



;


/* normalize component */

var vp_priority_table_simple_component = normalizeComponent(
  vp_priority_table_simple_vp_priority_table_simplevue_type_script_lang_ts_external,
  vp_priority_table_simplevue_type_template_id_5e1276a8_external_render,
  vp_priority_table_simplevue_type_template_id_5e1276a8_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_priority_table_simple = (vp_priority_table_simple_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VPagination"
var VPagination_namespaceObject = require("vuetify/lib/components/VPagination");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-result-list/vp-result-list.html?vue&type=template&id=0d0691a5&external




var vp_result_listvue_type_template_id_0d0691a5_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "result-list",
    attrs: {
      "light": _vm.light,
      "dark": _vm.dark
    }
  }, [!_vm.loading && _vm.results.results.length > 0 ? [_c(VDataTable_namespaceObject.VDataTable, {
    staticClass: "result-list__table vp-data-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.results.results,
      "item-key": "id",
      "hide-default-footer": "",
      "server-items-length": _vm.results.results.length,
      "page": _vm.pagination.page,
      "sort-by": _vm.pagination.sortBy,
      "sort-desc": _vm.pagination.descending,
      "dense": _vm.dense
    },
    on: {
      "update:options": _vm.onUpdateOptions
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    })], null, true)
  }), _c('div', {
    staticClass: "result-list__pagination"
  }, [_c(VPagination_namespaceObject.VPagination, {
    attrs: {
      "value": _vm.pagination.page,
      "length": _vm.results.total_pages,
      "total-visible": 7
    },
    on: {
      "input": _vm.onSelectPage
    }
  })], 1)] : _vm.loading ? _c('vp-loader') : _c('p', {
    staticClass: "result-list__no-results"
  }, [_vm._v(_vm._s(_vm.$t('search.message.no_results_found')))])], 2);
};
var vp_result_listvue_type_template_id_0d0691a5_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-result-list/vp-result-list.html?vue&type=template&id=0d0691a5&external

;// CONCATENATED MODULE: ./src/model/services/search/search-conditions-service.ts



class SearchConditionsService {
  /**
   * Updates the search conditions based on the query string of the page.
   *
   * @param route
   * @param defaultLimit
   * @param defaultSortBy
   */
  getConditionsFromQueryParams(route, defaultLimit, defaultSortBy, defaultDescending = false) {
    const conditions = {};
    this.setStringCondition(route, 'search_term', 'searchTerm', conditions);
    this.setStringCondition(route, 'limit', 'limit', conditions, defaultLimit);
    this.setStringCondition(route, 'page', 'page', conditions);
    this.setStringCondition(route, 'sort_by', 'sortBy', conditions, defaultSortBy);
    if (conditions.sortBy === defaultSortBy) {
      this.setBooleanCondition(route, 'desc', 'descending', conditions, defaultDescending);
    } else {
      this.setBooleanCondition(route, 'desc', 'descending', conditions, false);
    }
    return conditions;
  }
  /**
   * Updates the page query string based on the search conditions.
   *
   * @param conditions
   * @param defaultLimit
   * @param defaultSortBy
   */
  getQueryParamsFromConditions(conditions, defaultLimit, defaultSortBy, defaultDescending = false) {
    const params = {};
    this.setStringParam('search_term', 'searchTerm', conditions, params);
    if (conditions.limit && conditions.limit !== defaultLimit) {
      params.limit = conditions.limit;
    }
    if (conditions.page && conditions.page > 1) {
      params.page = conditions.page.toString();
    }
    if (conditions.sortBy) {
      if (conditions.sortBy !== defaultSortBy) {
        params.sort_by = conditions.sortBy;
        if (conditions.descending) {
          this.setBooleanParam('desc', 'descending', conditions, params);
        }
      } else if (conditions.descending !== defaultDescending) {
        this.setBooleanParam('desc', 'descending', conditions, params);
      }
    }
    return params;
  }
  /**
   * Sets a string condition from the query string.
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   * @param defaultValue
   */
  setStringCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      conditions[property] = route.query[param];
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets a string param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setStringParam(param, property, conditions, params) {
    if (conditions[property]) {
      params[param] = conditions[property];
    }
  }
  /**
   * Sets a string array condition from the query string.
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   * @param defaultValue
   */
  setStringArrayCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      conditions[property] = route.query[param].split(',');
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets a string array param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setStringArrayParam(param, property, conditions, params) {
    if (conditions[property]) {
      params[param] = conditions[property].join(',');
    }
  }
  /**
   * Sets an integer condition from the query string.
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   * @param defaultValue
   */
  setIntegerCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      conditions[property] = parseInt(route.query[param]);
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets an integer param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setIntegerParam(param, property, conditions, params) {
    this.setStringParam(param, property, conditions, params);
  }
  /**
   * Sets an integer array condition from the query string.
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   * @param defaultValue
   */
  setIntegerArrayCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      const stringValues = route.query[param].split(',');
      const integerValues = [];
      for (const stringValue of stringValues) {
        integerValues.push(parseInt(stringValue));
      }
      conditions[property] = integerValues;
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets an integer array param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setIntegerArrayParam(param, property, conditions, params) {
    this.setStringArrayParam(param, property, conditions, params);
  }
  /**
   * Sets a boolean condition from the query string.
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   */
  setBooleanCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      conditions[property] = route.query[param] === '1';
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets a boolean param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setBooleanParam(param, property, conditions, params) {
    if (util_default().isNullOrUndefined(conditions[property])) {
      return;
    }
    params[param] = conditions[property] ? '1' : '0';
  }
  /**
   * Sets a date condition from the query string
   *
   * @param route
   * @param param
   * @param property
   * @param conditions
   * @param defaultValue
   */
  setDateCondition(route, param, property, conditions, defaultValue) {
    if (param in route.query) {
      conditions[property] = (0,external_date_fns_namespaceObject.parseISO)(route.query[param]);
    } else {
      conditions[property] = util_default().isNullOrUndefined(defaultValue) ? null : defaultValue;
    }
  }
  /**
   * Sets a date param from conditions.
   *
   * @param param
   * @param property
   * @param conditions
   * @param params
   */
  setDateParam(param, property, conditions, params) {
    if (util_default().isNullOrUndefined(conditions[property])) {
      return;
    }
    params[param] = (0,external_date_fns_namespaceObject.format)(conditions[property], 'yyyy-MM-dd');
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-result-list/vp-result-list.ts?vue&type=script&lang=ts&external





let ResultListComponent = class ResultListComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.conditions = {
      limit: 50,
      page: 1,
      searchTerm: '',
      sortBy: '',
      descending: false
    };
  }
  created() {
    this.conditions.limit = this.resultsPerPage;
    this.conditions.sortBy = this.defaultSortBy;
    this.conditions.descending = this.defaultDescending;
    this.updateConditionsFromQueryString();
    this.loadResults();
  }
  onQueryChanged() {
    this.updateConditionsFromQueryString();
    this.loadResults();
  }
  onResultsPerPageChanged() {
    this.conditions.limit = this.resultsPerPage;
  }
  onDefaultSortByChanged() {
    this.conditions.sortBy = this.defaultSortBy;
  }
  onDefaultDescendingChanged() {
    if (this.conditions.sortBy === this.defaultSortBy) {
      this.conditions.descending = this.defaultDescending;
    }
  }
  /**
   * Returns the pagination details.
   */
  get pagination() {
    return {
      totalItems: this.results.total_results,
      rowsPerPage: this.results.results_per_page,
      page: this.results.page,
      sortBy: this.results.sort_by,
      descending: this.results.descending
    };
  }
  /**
   * Loads the results.
   */
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.$emit('load', this.conditions);
    });
  }
  /**
   * Handles pagination option updates.
   */
  onUpdateOptions(options) {
    const originalConditions = (0,external_lodash_namespaceObject.cloneDeep)(this.conditions);
    this.conditions.page = options.page;
    this.conditions.sortBy = options.sortBy.length > 0 ? options.sortBy[0] : this.defaultSortBy;
    if (options.sortDesc.length > 0) {
      this.conditions.descending = options.sortDesc[0];
    } else {
      this.conditions.descending = this.conditions.sortBy === this.defaultSortBy ? this.defaultDescending : false;
    }
    if (!(0,external_lodash_namespaceObject.isEqual)(originalConditions, this.conditions)) {
      if (this.silent) {
        this.loadResults();
      } else {
        this.updateQueryStringFromConditions();
      }
    }
  }
  /**
   * Handles page updates.
   *
   * @param page
   */
  onSelectPage(page) {
    this.conditions.page = page;
    if (this.silent) {
      this.loadResults();
    } else {
      this.updateQueryStringFromConditions();
    }
  }
  /**
   * Handles click events on an item
   *
   * @param item
   */
  onOpenItem(item) {
    this.$emit('open', item);
  }
  /**
   * Updates the search conditions based on the query string of the page.
   */
  updateConditionsFromQueryString() {
    // Don't bother if set to silent as the query string shouldn't be used
    if (this.silent) {
      return;
    }
    this.conditions = this.searchConditionsService.getConditionsFromQueryParams(this.$route, this.resultsPerPage, this.defaultSortBy, this.defaultDescending);
  }
  /**
   * Updates the page query string based on the search conditions.
   */
  updateQueryStringFromConditions() {
    // Don't update the query string if set to be silent
    if (this.silent) {
      return;
    }
    const query = this.searchConditionsService.getQueryParamsFromConditions(this.conditions, this.resultsPerPage, this.defaultSortBy, this.defaultDescending);
    this.$router.replace({
      query
    }).catch(error => error);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array
})], ResultListComponent.prototype, "headers", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], ResultListComponent.prototype, "results", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 50,
  type: Number
})], ResultListComponent.prototype, "resultsPerPage", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: 'id',
  type: String
})], ResultListComponent.prototype, "defaultSortBy", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "defaultDescending", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "dense", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "loading", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], ResultListComponent.prototype, "silent", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: () => new SearchConditionsService(),
  type: Object
})], ResultListComponent.prototype, "searchConditionsService", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('$route.query')], ResultListComponent.prototype, "onQueryChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('resultsPerPage')], ResultListComponent.prototype, "onResultsPerPageChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('defaultSortBy')], ResultListComponent.prototype, "onDefaultSortByChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('defaultDescending')], ResultListComponent.prototype, "onDefaultDescendingChanged", null);
ResultListComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-loader': vp_loader
  }
})], ResultListComponent);
/* harmony default export */ var vp_result_listvue_type_script_lang_ts_external = (ResultListComponent);
;// CONCATENATED MODULE: ./src/components/vp-result-list/vp-result-list.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_result_list_vp_result_listvue_type_script_lang_ts_external = (vp_result_listvue_type_script_lang_ts_external); 
;// CONCATENATED MODULE: ./src/components/vp-result-list/vp-result-list.vue





/* normalize component */
;
var vp_result_list_component = normalizeComponent(
  vp_result_list_vp_result_listvue_type_script_lang_ts_external,
  vp_result_listvue_type_template_id_0d0691a5_external_render,
  vp_result_listvue_type_template_id_0d0691a5_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_result_list = (vp_result_list_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-simple-json-editor/vp-simple-json-editor.html?vue&type=template&id=822e7286&external








var vp_simple_json_editorvue_type_template_id_822e7286_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-simple-json-editor vp-card"
  }, [_vm.title ? _c(VCard_namespaceObject.VCardTitle, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c(VCard_namespaceObject.VCardText, {
    staticClass: "vp-simple-json-editor__cardText vp-field-group",
    class: {
      'vp-simple-json-editor__cardText--editable-keys': _vm.editableKeys
    }
  }, [_vm._l(_vm.jsonObject, function (row, i) {
    return _c('div', {
      key: i,
      staticClass: "vp-simple-json-editor__cardText__fieldGroup vp-field-group",
      class: {
        'vp-simple-json-editor__cardText__fieldGroup--editable-keys': _vm.editableKeys
      }
    }, [_vm.editableKeys ? _c(VTextField_namespaceObject.VTextField, {
      staticClass: "vp-form-control",
      attrs: {
        "label": _vm.$t('general.field.key'),
        "placeholder": _vm.$t('general.field.key'),
        "filled": "",
        "hide-details": "auto"
      },
      on: {
        "change": _vm.onUpdate
      },
      model: {
        value: _vm.jsonObject[i].key,
        callback: function ($$v) {
          _vm.$set(_vm.jsonObject[i], "key", $$v);
        },
        expression: "jsonObject[i].key"
      }
    }) : _vm._e(), _vm.editableKeys ? _c(VTextField_namespaceObject.VTextField, {
      staticClass: "vp-form-control",
      attrs: {
        "label": _vm.$t('general.field.value'),
        "placeholder": _vm.$t('general.field.value'),
        "filled": "",
        "hide-details": "auto"
      },
      on: {
        "change": _vm.onUpdate
      },
      model: {
        value: _vm.jsonObject[i].value,
        callback: function ($$v) {
          _vm.$set(_vm.jsonObject[i], "value", $$v);
        },
        expression: "jsonObject[i].value"
      }
    }) : _vm._e(), !_vm.editableKeys && _vm.isTextField(_vm.jsonObject[i].key) ? _c(VTextField_namespaceObject.VTextField, {
      staticClass: "vp-form-control",
      attrs: {
        "label": _vm.getFieldLabel(_vm.jsonObject[i].key),
        "placeholder": _vm.jsonObject[i].key,
        "type": _vm.getTextFieldType(_vm.jsonObject[i].key),
        "filled": "",
        "hide-details": "auto"
      },
      on: {
        "change": _vm.onUpdate
      },
      model: {
        value: _vm.jsonObject[i].value,
        callback: function ($$v) {
          _vm.$set(_vm.jsonObject[i], "value", $$v);
        },
        expression: "jsonObject[i].value"
      }
    }) : _vm._e(), !_vm.editableKeys && _vm.isSelect(_vm.jsonObject[i].key) ? _c(VSelect_namespaceObject.VSelect, {
      staticClass: "vp-form-control",
      attrs: {
        "label": _vm.getFieldLabel(_vm.jsonObject[i].key),
        "placeholder": _vm.jsonObject[i].key,
        "items": _vm.getFieldOptions(_vm.jsonObject[i].key),
        "item-text": "title",
        "item-value": "value",
        "filled": ""
      },
      on: {
        "change": _vm.onUpdate
      },
      model: {
        value: _vm.jsonObject[i].value,
        callback: function ($$v) {
          _vm.$set(_vm.jsonObject[i], "value", $$v);
        },
        expression: "jsonObject[i].value"
      }
    }) : _vm._e(), _vm.editableKeys && _vm.$vuetify.breakpoint.smAndUp ? _c(VBtn_namespaceObject.VBtn, {
      staticClass: "vp-btn mt-2",
      attrs: {
        "fab": "",
        "plain": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeIndex(i);
        }
      }
    }, [_c(VIcon_namespaceObject.VIcon, {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-trash-can-outline")])], 1) : _vm._e(), _vm.editableKeys && _vm.$vuetify.breakpoint.xsOnly ? _c('div', {
      staticClass: "vp-simple-json-editor__cardText__fieldGroup__btnGroup"
    }, [_c(VBtn_namespaceObject.VBtn, {
      staticClass: "vp-btn",
      attrs: {
        "color": "primary",
        "plain": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeIndex(i);
        }
      }
    }, [_c(VIcon_namespaceObject.VIcon, {
      staticClass: "mr-1",
      attrs: {
        "left": ""
      }
    }, [_vm._v(" mdi-trash-can-outline ")]), _vm._v(" " + _vm._s(_vm.$t('general.action.remove_field')) + " ")], 1)], 1) : _vm._e()], 1);
  }), _vm.editableKeys ? _c('div', {
    staticClass: "vp-simple-json-editor__cardText__btnGroup"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "plain": "",
      "small": ""
    },
    on: {
      "click": _vm.addNewIndex
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    staticClass: "mr-1",
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus ")]), _vm._v(" " + _vm._s(_vm.$t('general.action.add_field')) + " ")], 1)], 1) : _vm._e()], 2)], 1);
};
var vp_simple_json_editorvue_type_template_id_822e7286_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-simple-json-editor/vp-simple-json-editor.html?vue&type=template&id=822e7286&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-simple-json-editor/vp-simple-json-editor.ts?vue&type=script&lang=ts&external



let SimpleJsonEditorComponent = class SimpleJsonEditorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.jsonObject = null;
  }
  created() {
    this.readValue();
  }
  onValueUpdated() {
    this.readValue();
  }
  onUpdate() {
    if (this.jsonObject) {
      this.$emit('input', this.buildJson());
    }
  }
  readValue() {
    if (this.value) {
      this.jsonObject = [];
      for (const key in this.value) {
        this.jsonObject.push({
          key,
          value: this.value[key]
        });
      }
    }
  }
  buildJson() {
    if (!this.jsonObject) {
      return this.nullable ? null : {};
    }
    if (this.nullable && !Object.keys(this.jsonObject).length) {
      return null;
    }
    const json = {};
    for (const row of this.jsonObject) {
      json[row.key] = row.value;
    }
    return json;
  }
  removeIndex(index) {
    if (!this.jsonObject) {
      return;
    }
    this.jsonObject.splice(index, 1);
    this.onUpdate();
  }
  addNewIndex() {
    if (!this.jsonObject) {
      this.jsonObject = [];
    }
    this.jsonObject.push({
      key: '',
      value: ''
    });
    this.onUpdate();
  }
  getFieldConfig(key) {
    if (!this.config || !this.config[key]) {
      return null;
    }
    return this.config[key];
  }
  getFieldLabel(key) {
    const config = this.getFieldConfig(key);
    if (!config || !config.label) {
      return key;
    }
    return config.label;
  }
  getInputType(key) {
    const config = this.getFieldConfig(key);
    if (!config) {
      return 'text';
    }
    return config.type;
  }
  isTextField(key) {
    const textFieldTypes = ['text', 'password', 'number'];
    return textFieldTypes.includes(this.getInputType(key));
  }
  isPassword(key) {
    return this.getInputType(key) === 'password';
  }
  isSelect(key) {
    return this.getInputType(key) === 'select';
  }
  getTextFieldType(key) {
    const type = this.getInputType(key);
    switch (type) {
      case 'password':
      case 'number':
        return type;
      case 'text':
      default:
        return 'text';
    }
  }
  getFieldOptions(key) {
    const config = this.getFieldConfig(key);
    if (!config || !config.options) {
      return [];
    }
    return config.options;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SimpleJsonEditorComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: null
})], SimpleJsonEditorComponent.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: true
})], SimpleJsonEditorComponent.prototype, "editableKeys", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], SimpleJsonEditorComponent.prototype, "nullable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SimpleJsonEditorComponent.prototype, "config", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], SimpleJsonEditorComponent.prototype, "onValueUpdated", null);
SimpleJsonEditorComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], SimpleJsonEditorComponent);
/* harmony default export */ var vp_simple_json_editorvue_type_script_lang_ts_external = (SimpleJsonEditorComponent);
;// CONCATENATED MODULE: ./src/components/vp-simple-json-editor/vp-simple-json-editor.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_simple_json_editor_vp_simple_json_editorvue_type_script_lang_ts_external = (vp_simple_json_editorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-simple-json-editor/vp-simple-json-editor.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_simple_json_editorvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(279);
;// CONCATENATED MODULE: ./src/components/vp-simple-json-editor/vp-simple-json-editor.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-simple-json-editor/vp-simple-json-editor.vue



;


/* normalize component */

var vp_simple_json_editor_component = normalizeComponent(
  vp_simple_json_editor_vp_simple_json_editorvue_type_script_lang_ts_external,
  vp_simple_json_editorvue_type_template_id_822e7286_external_render,
  vp_simple_json_editorvue_type_template_id_822e7286_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_simple_json_editor = (vp_simple_json_editor_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-translatable-field/vp-translatable-field.html?vue&type=template&id=6f643864&external







var vp_translatable_fieldvue_type_template_id_6f643864_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "translatable-field"
  }, [_c('span', {
    staticClass: "translatable-field__label"
  }, [_vm._v(_vm._s(_vm.label))]), _c(VTabs_namespaceObject.VTabs, {
    staticClass: "translatable-field__tabs vp-tabs-bar",
    class: {
      'translatable-field__tabs--error': _vm.error
    },
    attrs: {
      "color": _vm.colour,
      "slider-color": _vm.sliderColour,
      "light": _vm.light,
      "dark": _vm.dark,
      "hide-slider": ""
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_vm._l(_vm.supportedLocales, function (locale) {
    return _c(VTabs_namespaceObject.VTab, {
      key: locale,
      staticClass: "translatable-field__tab",
      attrs: {
        "light": _vm.light,
        "dark": _vm.dark
      }
    }, [_vm._v(" " + _vm._s(locale) + " ")]);
  }), _vm._l(_vm.supportedLocales, function (locale) {
    return _c(VTabs_namespaceObject.VTabItem, {
      key: locale,
      staticClass: "translatable-field__tab-content",
      attrs: {
        "light": _vm.light,
        "dark": _vm.dark
      }
    }, [_c(VCard_namespaceObject.VCard, {
      attrs: {
        "light": _vm.light,
        "dark": _vm.dark
      }
    }, [_c(VCard_namespaceObject.VCardText, {
      staticClass: "px-0"
    }, [_vm.editor ? _c('vp-text-editor', {
      attrs: {
        "value": _vm.formTranslations[locale],
        "init": _vm.init,
        "markdown": _vm.markdown,
        "readonly": _vm.readonly
      },
      on: {
        "input": value => _vm.onTextEditorChange(locale, value)
      }
    }) : _c(VTextField_namespaceObject.VTextField, {
      staticClass: "hover-errors vp-form-control",
      attrs: {
        "error": _vm.errors && locale in _vm.errors,
        "error-messages": _vm.errors && locale in _vm.errors ? _vm.errors[locale] : [],
        "filled": "",
        "hide-details": "auto"
      },
      on: {
        "change": _vm.onChange
      },
      model: {
        value: _vm.formTranslations[locale],
        callback: function ($$v) {
          _vm.$set(_vm.formTranslations, locale, $$v);
        },
        expression: "formTranslations[locale]"
      }
    })], 1)], 1)], 1);
  })], 2)], 1);
};
var vp_translatable_fieldvue_type_template_id_6f643864_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-translatable-field/vp-translatable-field.html?vue&type=template&id=6f643864&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-translatable-field/vp-translatable-field.ts?vue&type=script&lang=ts&external





let TranslatableFieldComponent = class TranslatableFieldComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.formTranslations = {};
    this.activeTab = 0;
  }
  created() {
    this.onValueUpdated();
  }
  onValueUpdated() {
    this.formTranslations = Object.assign({}, (0,external_lodash_namespaceObject.cloneDeep)(this.value));
  }
  /**
   * Returns an array of locales with no translations.
   */
  get emptyLocales() {
    const emptyLocales = [];
    if (this.formTranslations) {
      for (const locale of this.supportedLocales) {
        if (!this.formTranslations[locale]) {
          emptyLocales.push(locale);
        }
      }
    }
    return emptyLocales;
  }
  /**
   * Called when a text field's value changes.
   */
  onChange() {
    this.$emit('input', this.formTranslations);
  }
  /**
   * Called when a text editor's value changes.
   *
   * @param locale
   * @param value
   */
  onTextEditorChange(locale, value) {
    this.formTranslations[locale] = value;
    this.$emit('input', this.formTranslations);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], TranslatableFieldComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], TranslatableFieldComponent.prototype, "label", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array
})], TranslatableFieldComponent.prototype, "supportedLocales", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "editor", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: true,
  type: Boolean
})], TranslatableFieldComponent.prototype, "init", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "markdown", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Object
})], TranslatableFieldComponent.prototype, "errors", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], TranslatableFieldComponent.prototype, "colour", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], TranslatableFieldComponent.prototype, "sliderColour", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "light", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  default: false,
  type: Boolean
})], TranslatableFieldComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], TranslatableFieldComponent.prototype, "onValueUpdated", null);
TranslatableFieldComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-text-editor': vp_text_editor
  }
})], TranslatableFieldComponent);
/* harmony default export */ var vp_translatable_fieldvue_type_script_lang_ts_external = (TranslatableFieldComponent);
;// CONCATENATED MODULE: ./src/components/vp-translatable-field/vp-translatable-field.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_translatable_field_vp_translatable_fieldvue_type_script_lang_ts_external = (vp_translatable_fieldvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-translatable-field/vp-translatable-field.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_translatable_fieldvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(491);
;// CONCATENATED MODULE: ./src/components/vp-translatable-field/vp-translatable-field.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-translatable-field/vp-translatable-field.vue



;


/* normalize component */

var vp_translatable_field_component = normalizeComponent(
  vp_translatable_field_vp_translatable_fieldvue_type_script_lang_ts_external,
  vp_translatable_fieldvue_type_template_id_6f643864_external_render,
  vp_translatable_fieldvue_type_template_id_6f643864_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_translatable_field = (vp_translatable_field_component.exports);
;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_namespaceObject);
;// CONCATENATED MODULE: external "@mdi/js"
var js_namespaceObject = require("@mdi/js");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-trend/vp-trend.ts?vue&type=script&lang=ts&external


/* harmony default export */ var vp_trendvue_type_script_lang_ts_external = (external_vue_default().extend({
  functional: true,
  props: {
    value: String
  },
  render(h, ctx) {
    let icon;
    switch (ctx.props.value) {
      case 'up':
        icon = js_namespaceObject.mdiTrendingUp;
        break;
      case 'down':
        icon = js_namespaceObject.mdiTrendingDown;
        break;
      case 'neutral':
      default:
        icon = js_namespaceObject.mdiTrendingNeutral;
    }
    const path = h('path', {
      attrs: {
        d: icon
      }
    });
    const svg = h('svg', [path]);
    return h('span', {
      class: `trend trend--${ctx.props.value}`
    }, [svg]);
  }
}));
;// CONCATENATED MODULE: ./src/components/vp-trend/vp-trend.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_trend_vp_trendvue_type_script_lang_ts_external = (vp_trendvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-trend/vp-trend.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_trendvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(685);
;// CONCATENATED MODULE: ./src/components/vp-trend/vp-trend.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-trend/vp-trend.vue
var vp_trend_render, vp_trend_staticRenderFns
;

;


/* normalize component */

var vp_trend_component = normalizeComponent(
  vp_trend_vp_trendvue_type_script_lang_ts_external,
  vp_trend_render,
  vp_trend_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_trend = (vp_trend_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-trending-value/vp-trending-value.html?vue&type=template&id=369ebda2&external



var vp_trending_valuevue_type_template_id_369ebda2_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "content-class": "trending-value__hover-data",
      "open-on-hover": "",
      "close-on-content-click": false,
      "transition": false,
      "offset-y": "",
      "max-width": "250px",
      "disabled": _vm.disableHover || !_vm.previous && !_vm.projected
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('span', _vm._g(_vm._b({
          staticClass: "trending-value d-flex align-center",
          class: _vm.classes
        }, 'span', attrs, false), on), [_c('span', {
          staticClass: "trending-value__value"
        }, [_vm._v(" " + _vm._s(_vm.showProjected ? _vm.format(_vm.projected) : _vm.format(_vm.value)) + " ")]), !_vm.disableTrend ? _c('vp-trend', {
          staticClass: "project-value__trend",
          model: {
            value: _vm.trend,
            callback: function ($$v) {
              _vm.trend = $$v;
            },
            expression: "trend"
          }
        }) : _vm._e()], 1)];
      }
    }])
  }, [_c(VDataTable_namespaceObject.VSimpleTable, {
    staticClass: "vp-simple-table",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', [_c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('general.field.current')) + " ")]), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(" " + _vm._s(_vm.format(_vm.value)) + " ")])]), _vm.projected ? _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('general.field.projected')) + " ")]), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(" " + _vm._s(_vm.format(_vm.projected)) + " ")])]) : _vm._e(), _vm.previous ? _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('general.field.previous')) + " ")]), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(" " + _vm._s(_vm.format(_vm.previous)) + " ")])]) : _vm._e()])];
      },
      proxy: true
    }])
  })], 1);
};
var vp_trending_valuevue_type_template_id_369ebda2_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-trending-value/vp-trending-value.html?vue&type=template&id=369ebda2&external

;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/i18n/locale-helper"
var locale_helper_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/i18n/locale-helper");
var locale_helper_default = /*#__PURE__*/__webpack_require__.n(locale_helper_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-trending-value/vp-trending-value.ts?vue&type=script&lang=ts&external





let TrendingValueComponent = class TrendingValueComponent extends external_vue_property_decorator_namespaceObject.Vue {
  /**
   * Returns the optional classes for the component
   */
  get classes() {
    return {
      'trending-value--trending-up': !this.disableTrendColour && this.trend === 'up',
      'trending-value--trending-down': !this.disableTrendColour && this.trend === 'down',
      'trending-value--trending-neutral': !this.disableTrendColour && this.trend === 'neutral'
    };
  }
  /**
   * Returns the trend type/direction
   */
  get trend() {
    var _a;
    // Convert comparison values to Decimal
    let comparisonValue = (_a = this.projected) !== null && _a !== void 0 ? _a : this.value;
    if (typeof comparisonValue === 'number' || typeof comparisonValue === 'string') {
      comparisonValue = new (external_big_js_default())(comparisonValue);
    }
    let previousValue = this.previous;
    if (typeof this.previous === 'number' || typeof this.previous === 'string') {
      previousValue = new (external_big_js_default())(this.previous);
    }
    // If the previous value is 0 then simply check the comparison value for positivity / negativity
    if (previousValue.eq(0)) {
      switch (true) {
        case comparisonValue.gt(0):
          return 'up';
        case comparisonValue.lt(0):
          return 'down';
        default:
          return 'neutral';
      }
    }
    // Compare the values and calculate the change based on the percentage
    const change = comparisonValue.div(previousValue).minus(1).mul(100).toNumber();
    if (change >= this.percentageChange) {
      return 'up';
    } else if (change <= -this.percentageChange) {
      return 'down';
    }
    return 'neutral';
  }
  /**
   * Formats the given value accordingly
   *
   * @param value
   * @returns
   */
  format(value) {
    var _a;
    if (this.currency) {
      return locale_helper_default().formatCurrency(value, (_a = this.decimalPlaces) !== null && _a !== void 0 ? _a : 2, this.currency);
    } else if (this.decimalPlaces) {
      return new (external_big_js_default())(value).toFixed(this.decimalPlaces);
    } else {
      return `${value}`;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TrendingValueComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TrendingValueComponent.prototype, "projected", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TrendingValueComponent.prototype, "previous", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: 25
})], TrendingValueComponent.prototype, "percentageChange", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TrendingValueComponent.prototype, "showProjected", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String,
  default: undefined
})], TrendingValueComponent.prototype, "currency", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: undefined
})], TrendingValueComponent.prototype, "decimalPlaces", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TrendingValueComponent.prototype, "disableHover", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TrendingValueComponent.prototype, "disableTrend", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TrendingValueComponent.prototype, "disableTrendColour", void 0);
TrendingValueComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-trend': vp_trend
  }
})], TrendingValueComponent);
/* harmony default export */ var vp_trending_valuevue_type_script_lang_ts_external = (TrendingValueComponent);
;// CONCATENATED MODULE: ./src/components/vp-trending-value/vp-trending-value.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_trending_value_vp_trending_valuevue_type_script_lang_ts_external = (vp_trending_valuevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-trending-value/vp-trending-value.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_trending_valuevue_type_style_index_0_prod_lang_scss_external = __webpack_require__(71);
;// CONCATENATED MODULE: ./src/components/vp-trending-value/vp-trending-value.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-trending-value/vp-trending-value.vue



;


/* normalize component */

var vp_trending_value_component = normalizeComponent(
  vp_trending_value_vp_trending_valuevue_type_script_lang_ts_external,
  vp_trending_valuevue_type_template_id_369ebda2_external_render,
  vp_trending_valuevue_type_template_id_369ebda2_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_trending_value = (vp_trending_value_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/vp-widget-icon/vp-widget-icon.html?vue&type=template&id=7fbdec20&external






var vp_widget_iconvue_type_template_id_7fbdec20_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-widget-icon pa-3 text-center",
    attrs: {
      "to": _vm.value.to
    }
  }, [_vm.value.title ? _c(VCard_namespaceObject.VCardTitle, {
    class: {
      'justify-center': _vm.titleCenter
    }
  }, [_vm._v(_vm._s(_vm.value.title))]) : _vm._e(), _c(VIcon_namespaceObject.VIcon, {
    class: {
      'v-icon--outline': _vm.outline,
      'v-icon--background': _vm.background,
      'rounded-circle': _vm.rounded
    },
    attrs: {
      "size": _vm.size ? _vm.size : 50,
      "color": _vm.value.colour
    }
  }, [_vm._v(" " + _vm._s(_vm.value.icon) + " ")]), _vm.value.subtitle ? _c(VCard_namespaceObject.VCardSubtitle, {
    staticClass: "headline font-weight-bold"
  }, [_vm._v(_vm._s(_vm.value.subtitle))]) : _vm._e(), _vm.value.text ? _c(VCard_namespaceObject.VCardText, [_vm._v(_vm._s(_vm.value.text))]) : _vm._e()], 1);
};
var vp_widget_iconvue_type_template_id_7fbdec20_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/vp-widget-icon/vp-widget-icon.html?vue&type=template&id=7fbdec20&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/vp-widget-icon/vp-widget-icon.ts?vue&type=script&lang=ts&external


let WidgetIconComponent = class WidgetIconComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], WidgetIconComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], WidgetIconComponent.prototype, "outline", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], WidgetIconComponent.prototype, "background", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], WidgetIconComponent.prototype, "rounded", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], WidgetIconComponent.prototype, "titleCenter", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: undefined
})], WidgetIconComponent.prototype, "size", void 0);
WidgetIconComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], WidgetIconComponent);
/* harmony default export */ var vp_widget_iconvue_type_script_lang_ts_external = (WidgetIconComponent);
;// CONCATENATED MODULE: ./src/components/vp-widget-icon/vp-widget-icon.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var vp_widget_icon_vp_widget_iconvue_type_script_lang_ts_external = (vp_widget_iconvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/vp-widget-icon/vp-widget-icon.scss?vue&type=style&index=0&prod&lang=scss&external
var vp_widget_iconvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(979);
;// CONCATENATED MODULE: ./src/components/vp-widget-icon/vp-widget-icon.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/vp-widget-icon/vp-widget-icon.vue



;


/* normalize component */

var vp_widget_icon_component = normalizeComponent(
  vp_widget_icon_vp_widget_iconvue_type_script_lang_ts_external,
  vp_widget_iconvue_type_template_id_7fbdec20_external_render,
  vp_widget_iconvue_type_template_id_7fbdec20_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vp_widget_icon = (vp_widget_icon_component.exports);
;// CONCATENATED MODULE: ./src/i18n/translations/messages.ts
const messages = {
  en: {
    authentication: {
      action: {
        sign_in_google: 'Sign in with Google',
        sign_out_google: 'Sign out'
      },
      message: {
        prompt_opt_out_or_no_session: 'You have globally opted out of Google Sign in',
        prompt_suppressed_by_user: 'Sign in has been previously dismissed. Please clear site data and try again.'
      }
    },
    general: {
      action: {
        add_field: 'Add Field',
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        continue: 'Continue',
        delete: 'Delete',
        delete_file: 'Delete File',
        download: 'Download',
        download_file: 'Download File',
        download_filename: 'Download {filename}',
        next: 'Next',
        no: 'No',
        ok: 'Ok',
        previous: 'Previous',
        remove_field: 'Remove Field',
        save_as_new: 'Save as New',
        save_global: 'Save (Global)',
        save: 'Save',
        search: 'Search',
        update: 'Update',
        upload: 'Upload',
        yes: 'Yes'
      },
      field: {
        actions: 'Actions',
        compared_to: 'Compared To',
        current: 'Current',
        custom: 'Custom',
        date_range: 'Date Range',
        day: 'Day',
        description: 'Description',
        enabled: 'Enabled',
        key: 'Key',
        last_days: 'Last {days} days',
        last_month: 'Last Month',
        last_quarter: 'Last Quarter',
        last_week: 'Last Week',
        last_year: 'Last Year',
        latest_notifications: 'Latest Notifications',
        new_notifications: 'New Notifications',
        month: 'Month',
        previous: 'Previous',
        projected: 'Projected',
        text: 'Text',
        this_month: 'This Month',
        this_quarter: 'This Quarter',
        this_week: 'This Week',
        this_year: 'This Year',
        title: 'Title',
        today: 'Today',
        value: 'Value',
        year: 'Year',
        yesterday: 'Yesterday'
      },
      message: {
        choose_comparison_date_ranges: 'Choose comparison date ranges',
        optional: 'Optional',
        required: 'Required',
        warning: 'Warning',
        view_all: 'View All'
      },
      month: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
      },
      validation: {
        field_is_required: 'Field is required',
        value_min_value: 'Must be at least {length}',
        value_max_value: 'Must be less than {length}',
        value_min_length: 'Must be at least {length} characters',
        value_max_length: 'Must be less than {length} characters',
        value_must_be_boolean: 'Value must be boolean',
        value_must_be_date: 'Value must be a date',
        value_must_be_datetime: 'Value must be a date & time',
        value_must_be_decimal: 'Value must be a decimal',
        value_must_be_integer: 'Value must be an integer',
        value_must_be_string: 'Value must be text'
      }
    },
    report: {
      action: {
        current_search: 'Current Search',
        save_search: 'Save Search',
        saved_searches: 'Saved Searches',
        confirm_deletion: 'Confirm deletion'
      },
      error: {
        failed_deleting: 'There was an error deleting the search',
        failed_saving: 'There was an error saving the search'
      },
      message: {
        confirm_deletion: 'Please confirm you wish to delete:'
      }
    },
    search: {
      action: {
        add_filter: 'Add Filter',
        apply_filter: 'Apply Filter',
        hide_all_columns: 'Hide all columns',
        save_as_default: 'Save as default',
        show_all_columns: 'Show all columns'
      },
      message: {
        no_results_found: 'No results were found',
        sort_by: 'Sort by'
      }
    }
  }
};
/* harmony default export */ var translations_messages = (messages);
;// CONCATENATED MODULE: external "vue-observe-visibility"
var external_vue_observe_visibility_namespaceObject = require("vue-observe-visibility");
var external_vue_observe_visibility_default = /*#__PURE__*/__webpack_require__.n(external_vue_observe_visibility_namespaceObject);
;// CONCATENATED MODULE: ./src/library.ts





























// Define all the components to export
const components = {
  BaseStylingComponent: vp_base_styling,
  BooleanRadioGroupComponent: vp_boolean_radio_group,
  ConfirmDialogComponent: vp_confirm_dialog,
  DataTableComponent: vp_data_table,
  DateComponent: vp_date,
  DatePickerComponent: vp_date_picker,
  DateRangeComponent: vp_date_range,
  DateRangeComparisonPickerComponent: vp_date_range_comparison_picker,
  DateTimePickerComponent: vp_date_time_picker,
  DialogComponent: vp_dialog,
  FileSelectorComponent: vp_file_selector,
  FormComponent: vp_form,
  FormFieldComponent: vp_form_field,
  GoogleSignInComponent: google_sign_in_button,
  LoaderComponent: vp_loader,
  NotificationDialogComponent: vp_notification_dialog,
  NotificationsComponent: vp_notifications,
  PriorityTableComponent: vp_priority_table,
  PriorityTableSimpleComponent: vp_priority_table_simple,
  ResultListComponent: vp_result_list,
  SimpleJsonEditorComponent: vp_simple_json_editor,
  TextEditorComponent: vp_text_editor,
  TranslatableFieldComponent: vp_translatable_field,
  TrendComponent: vp_trend,
  TrendingValueComponent: vp_trending_value,
  WidgetComponent: vp_widget,
  WidgetIconComponent: vp_widget_icon,
  messages: translations_messages
};
// Define html tags to components
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const componentTags = {
  'google-sign-in-button': google_sign_in_button,
  'vp-base-styling': vp_base_styling,
  'vp-boolean-radio-group': vp_boolean_radio_group,
  'vp-confirm-dialog': vp_confirm_dialog,
  'vp-data-table': vp_data_table,
  'vp-date': vp_date,
  'vp-date-picker': vp_date_picker,
  'vp-date-range': vp_date_range,
  'vp-date-range-comparison-picker': vp_date_range_comparison_picker,
  'vp-date-time-picker': vp_date_time_picker,
  'vp-dialog': vp_dialog,
  'vp-file-selector': vp_file_selector,
  'vp-form': vp_form,
  'vp-form-field': vp_form_field,
  'vp-loader': vp_loader,
  'vp-notification-dialog': vp_notification_dialog,
  'vp-notifications': vp_notifications,
  'vp-priority-table': vp_priority_table,
  'vp-priority-table-simple': vp_priority_table_simple,
  'vp-result-list': vp_result_list,
  'vp-simple-json-editor': vp_simple_json_editor,
  'vp-text-editor': vp_text_editor,
  'vp-translatable-field': vp_translatable_field,
  'vp-trend': vp_trend,
  'vp-trending-value': vp_trending_value,
  'vp-widget': vp_widget,
  'vp-widget-icon': vp_widget_icon
};
// Register each component globally in Vue so it can be used anywhere
for (const tag in componentTags) {
  external_vue_default().component(tag, componentTags[tag]);
}
// Register the Vue Observe Visibility plugin

external_vue_default().use((external_vue_observe_visibility_default()));
/* harmony default export */ var library = (components);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (library);


}();
module.exports = __webpack_exports__["default"];
/******/ })()
;
//# sourceMappingURL=vue-js-components.common.js.map